/* eslint-disable */
// Ported VERBATIM from the Claude Design handoff (design_handoff_all_loaders / "Holiday Loading.html").
// Each function returns an inline-SVG string for one holiday loading scene, rolling its own
// random traits per call (wrap in useMemo at the call site for a stable per-mount render).
// Do NOT hand-edit; re-port from the handoff if the source changes.

const rnd = (a, b) => a + Math.random() * (b - a);

/* ---- Independence Day: night sky, fireworks, and the full Stars & Stripes ---- */
function independenceScene() {
  const FW = [
    ['#ef4123', 252,  40, 0.0],
    ['#ffffff', 318,  96, 0.6],
    ['#6699cc', 102, 154, 1.1],
    ['#ffd24d', 288, 168, 1.7],
    ['#ef4123', 226,  70, 2.1],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*26).toFixed(1)}" y2="${(Math.sin(a)*26).toFixed(1)}" stroke="${c}" stroke-width="1.7" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*30).toFixed(1)}" cy="${(Math.sin(a)*30).toFixed(1)}" r="1.8" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  let stars = '';
  for (let i = 0; i < 22; i++) {
    const x = rnd(12, 348), y = rnd(10, 150), s = rnd(1, 2.1), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${s.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // ---- the flag itself: 10:19 ratio, 13 stripes, 50-star union ----
  const W = 152, H = 80, SH = H / 13;          // stripe height
  const CW = 0.76 * H, CH = 7 * SH;            // union spans 7 stripes
  let cloth = '';
  for (let i = 0; i < 13; i++) {
    cloth += `<rect y="${(i * SH).toFixed(2)}" width="${W}" height="${(SH + 0.05).toFixed(2)}" fill="${i % 2 ? '#ffffff' : '#B22234'}"/>`;
  }
  const star = (cx, cy, r) => {
    let p = '';
    for (let k = 0; k < 10; k++) {
      const a = -Math.PI / 2 + k * Math.PI / 5, rr = k % 2 ? r * 0.42 : r;
      p += `${(cx + rr * Math.cos(a)).toFixed(2)},${(cy + rr * Math.sin(a)).toFixed(2)} `;
    }
    return `<polygon points="${p.trim()}" fill="#ffffff"/>`;
  };
  cloth += `<rect width="${CW.toFixed(2)}" height="${CH.toFixed(2)}" fill="#3C3B6E"/>`;
  // 9 rows alternating 6 and 5 stars = 50
  for (let row = 1; row <= 9; row++) {
    const n = row % 2 ? 6 : 5;
    for (let j = 0; j < n; j++) {
      const col = row % 2 ? 2 * j + 1 : 2 * j + 2;
      cloth += star((CW * col) / 12, (CH * row) / 10, 2.3);
    }
  }
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(255,255,255,.28)" stroke-width="0.6"/>`;

  // slice into vertical strips so the cloth ripples; hoist edge stays pinned to the pole
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="uscp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.6 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#uscp${i})"><use href="#usflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Independence Day — the American flag waving under fireworks">
    <defs>
      <linearGradient id="skyJul4" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#102338"/><stop offset="0.6" stop-color="#1a395a"/><stop offset="1" stop-color="#1e4164"/>
      </linearGradient>
      <g id="usflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyJul4)"/>
    ${stars}
    ${bursts}
    <line x1="44" y1="212" x2="44" y2="12" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="10" r="3" fill="#f6c700"/>
    <g transform="translate(45,18)">${strips}</g>
    <!-- easter egg: an occasional little UFO fly-by across the night sky -->
    <g class="ufo"><g transform="translate(0,40)">
      <path d="M-7,4 L-13,22 L13,22 L7,4 Z" fill="#8fe3ff" opacity="0.16"/>
      <ellipse cx="0" cy="1" rx="19" ry="6.5" fill="#8c99a8"/>
      <ellipse cx="0" cy="-0.6" rx="19" ry="4.6" fill="#aeb9c6"/>
      <path d="M-9,-2 A 9 6 0 0 1 9,-2 Z" fill="#bfe8ff"/>
      <ellipse cx="-3" cy="-4" rx="3" ry="1.6" fill="#eafaff" opacity="0.8"/>
      <circle class="twinkle" cx="-11" cy="3.5" r="1.7" fill="#ffd24d" style="animation-delay:0s"/>
      <circle class="twinkle" cx="0" cy="5" r="1.7" fill="#4fd1ff" style="animation-delay:.3s"/>
      <circle class="twinkle" cx="11" cy="3.5" r="1.7" fill="#ff5bb0" style="animation-delay:.6s"/>
    </g></g>
  </svg>`;
}

/* ---- an anatomically-arranged tom turkey ----
   built around the body centre (0,0): fanned tail behind, plump body,
   folded wing, curved neck up to a bare head with snood + wattle + beak,
   a chest beard, and two three-toed legs on the ground. ---- */
function turkey(x, y, s, delay) {
  // display fan — dark-brown quills warming to a buff-banded tip
  const feathers = ['#5e3411', '#7a4318', '#9c5a24', '#c1701f', '#e0902a', '#c1701f', '#9c5a24', '#7a4318', '#5e3411'];
  const M = feathers.length, spread = 118;
  let fan = '';
  for (let i = 0; i < M; i++) {
    const ang = -spread / 2 + (spread / (M - 1)) * i;
    fan += `<g transform="rotate(${ang.toFixed(1)})">
      <path d="M0,6 C -6.6,-13 -6.6,-37 0,-47 C 6.6,-37 6.6,-13 0,6 Z" fill="${feathers[i]}" stroke="#4a2a0e" stroke-width="0.7"/>
      <path d="M0,-34 C -3.9,-38 -3.9,-44 0,-47 C 3.9,-44 3.9,-38 0,-34 Z" fill="#f4dca6"/>
    </g>`;
  }

  return `<g transform="translate(${x},${y}) scale(${s})"><g class="turkey" style="animation-delay:${delay}s">
    <!-- tail fan, pivoted low in the rump so the quills root into the body -->
    <g transform="translate(3,6) rotate(12)">${fan}</g>
    <!-- legs + three-toed feet, standing on the ground -->
    <g stroke="#d98324" stroke-width="2.4" stroke-linecap="round" fill="none">
      <path d="M-4,13 L-5,25"/><path d="M5,13 L6,25"/>
    </g>
    <g stroke="#d98324" stroke-width="1.7" stroke-linecap="round">
      <path d="M-5,25 l-4.5,3 M-5,25 l0,4.2 M-5,25 l4.5,3"/>
      <path d="M6,25 l-4.5,3 M6,25 l0,4.2 M6,25 l4.5,3"/>
    </g>
    <!-- body mass + rump hump (covers the fan roots) + belly + breast -->
    <ellipse cx="6" cy="1" rx="13" ry="12.5" fill="#7a4318"/>
    <ellipse cx="1" cy="5" rx="16.5" ry="14.5" fill="#7a4318"/>
    <ellipse cx="-2" cy="7" rx="12.5" ry="11.5" fill="#9c5a28"/>
    <ellipse cx="-9" cy="6" rx="6.5" ry="9.5" fill="#b5701f"/>
    <!-- chest beard -->
    <path d="M-10,13 q-1.5,7 -1,12" stroke="#33210f" stroke-width="1.5" stroke-linecap="round" fill="none"/>
    <!-- folded wing laid across the body flank, rooted at the shoulder -->
    <path d="M-8,-6 C 2,-11 14,-8 14,4 C 14,13 7,18 1,15 C -4,12 -7,4 -8,-6 Z" fill="#653a16"/>
    <path d="M-6,-5 C 3,-8 11,-4 13,4" stroke="#7a4318" stroke-width="2.2" fill="none" stroke-linecap="round"/>
    <path d="M-4,-2 C 3,-3 9,1 11,8" stroke="#4a2a0e" stroke-width="0.8" fill="none"/>
    <path d="M-3,3 C 2,3 7,6 9,12" stroke="#4a2a0e" stroke-width="0.8" fill="none"/>
    <!-- feathered lower neck -->
    <path d="M-9,-2 C -16,-1 -18,-11 -14,-18 L-8,-13 Z" fill="#7a4318"/>
    <!-- bare upper neck -->
    <path d="M-12.5,-8 C -15,-13 -15,-19 -13.4,-22.5" stroke="#9fb0be" stroke-width="4" stroke-linecap="round" fill="none"/>
    <!-- head -->
    <circle cx="-14.4" cy="-23" r="4.1" fill="#adbcc9"/>
    <path d="M-16,-25.4 a4.1 4.1 0 0 0 -1,5.4" fill="#d8350f" opacity="0.55"/>
    <!-- beak -->
    <path d="M-18,-23 L-23.4,-21.9 L-18,-20 Z" fill="#f2b134"/>
    <!-- snood draping over the beak -->
    <path d="M-18,-24.4 q-4.4,0.4 -4.8,4.6" stroke="#d8350f" stroke-width="1.6" stroke-linecap="round" fill="none"/>
    <!-- wattle at the throat -->
    <path d="M-16,-20 q-1,5.2 -3,7.2 q-1.9,-1 -1,-6.2 Z" fill="#d8350f"/>
    <!-- eye -->
    <circle cx="-15" cy="-24" r="0.95" fill="#1a1a1a"/>
  </g></g>`;
}

/* ---- a ribbed, highlighted pumpkin ---- */
function pumpkin(x, y, s, c) {
  const rib = 'rgba(74,42,14,.28)';
  return `<g transform="translate(${x},${y}) scale(${s})">
    <path d="M0,-9 C -1,-14 -5,-15 -7,-18" stroke="#6d8237" stroke-width="2.4" fill="none" stroke-linecap="round"/>
    <ellipse cx="-9" cy="0" rx="6" ry="11" fill="${c}"/>
    <ellipse cx="9" cy="0" rx="6" ry="11" fill="${c}"/>
    <ellipse cx="0" cy="0" rx="15" ry="11.5" fill="${c}"/>
    <ellipse cx="0" cy="0" rx="7" ry="11.5" fill="${c}"/>
    <path d="M-6,-9.4 A 15 11.5 0 0 0 -6,9.4" stroke="${rib}" fill="none" stroke-width="1"/>
    <path d="M6,-9.4 A 15 11.5 0 0 1 6,9.4" stroke="${rib}" fill="none" stroke-width="1"/>
    <line x1="0" y1="-11" x2="0" y2="11" stroke="${rib}" stroke-width="1"/>
    <ellipse cx="-5" cy="-4" rx="2.4" ry="4" fill="rgba(255,255,255,.20)"/>
  </g>`;
}

/* ---- a bumpy bicolour gourd ---- */
function gourd(x, y, s) {
  return `<g transform="translate(${x},${y}) scale(${s})">
    <path d="M0,-15 C 2.5,-17 4.5,-15 3.5,-12.5" stroke="#6d8237" stroke-width="1.6" fill="none" stroke-linecap="round"/>
    <ellipse cx="0" cy="-8" rx="5" ry="6.5" fill="#e8b530"/>
    <ellipse cx="0" cy="3.5" rx="9.5" ry="8.5" fill="#5a8a3a"/>
    <ellipse cx="0" cy="-3.5" rx="5.5" ry="4.5" fill="#7aa84a"/>
    <ellipse cx="-3.5" cy="4" rx="2" ry="3" fill="rgba(255,255,255,.16)"/>
  </g>`;
}

/* ---- a corn cob with peeled husk leaves ---- */
function corn(x, y, s, rot) {
  let k = '';
  for (let r = 0; r < 8; r++) for (let c = 0; c < 3; c++) {
    k += `<circle cx="${(-3 + c * 3).toFixed(1)}" cy="${(-11 + r * 3).toFixed(1)}" r="1.6" fill="${(r + c) % 2 ? '#f4cf4e' : '#e8b530'}"/>`;
  }
  return `<g transform="translate(${x},${y}) scale(${s}) rotate(${rot || 0})">
    <path d="M-5,9 C -12,5 -13,-9 -8,-13" fill="#8faa3a"/>
    <path d="M5,9 C 12,5 13,-9 8,-13" fill="#a6c24a"/>
    <ellipse cx="0" cy="-1" rx="5.2" ry="12.5" fill="#e8b530"/>
    ${k}
  </g>`;
}

/* ---- a shiny apple with leaf ---- */
function apple(x, y, s, c) {
  return `<g transform="translate(${x},${y}) scale(${s})">
    <path d="M0,-6 C 1,-9 4,-10 6,-9" stroke="#6d4423" stroke-width="1.3" fill="none" stroke-linecap="round"/>
    <path d="M2,-8 q4,-3 7.5,-1 q-2.5,4 -7.5,1 Z" fill="#6d8237"/>
    <path d="M0,-5 C -6.5,-8 -9.5,-2 -8.5,3 C -7.5,8.5 -3,10.5 0,8.4 C 3,10.5 7.5,8.5 8.5,3 C 9.5,-2 6.5,-8 0,-5 Z" fill="${c || '#d8350f'}"/>
    <ellipse cx="-3.2" cy="0" rx="2" ry="3.6" fill="rgba(255,255,255,.26)"/>
  </g>`;
}

/* ---- a whole pumpkin pie on a plate, with whipped-cream dollops ---- */
function pie(x, y, s) {
  return `<g transform="translate(${x},${y}) scale(${s})">
    <ellipse cx="0" cy="6" rx="27" ry="7" fill="#dfe4ea"/>
    <ellipse cx="0" cy="4.4" rx="24.5" ry="6" fill="#f4f7fa"/>
    <path d="M-22,3.5 Q0,14 22,3.5 L20.5,-0.5 Q0,8.5 -20.5,-0.5 Z" fill="#b56b1d"/>
    <ellipse cx="0" cy="-0.5" rx="22" ry="6.5" fill="#c98a3a"/>
    <ellipse cx="0" cy="-1.6" rx="18" ry="5" fill="#c47a28"/>
    <circle cx="-8" cy="-2.6" r="2.4" fill="#fff8ec"/>
    <circle cx="0" cy="-3.2" r="2.7" fill="#fff8ec"/>
    <circle cx="8" cy="-2.6" r="2.4" fill="#fff8ec"/>
  </g>`;
}

/* ---- a bundled sheaf of wheat ---- */
function wheat(x, y, s) {
  let stalks = '';
  for (let i = -2; i <= 2; i++) {
    let heads = '';
    for (let g = 0; g < 6; g++) heads += `<ellipse cx="0" cy="${(-15 - g * 2.4).toFixed(1)}" rx="2.1" ry="1.4" fill="#e0a83a"/>`;
    stalks += `<g transform="rotate(${i * 9})"><line x1="0" y1="6" x2="0" y2="-15" stroke="#c9962e" stroke-width="1.2"/>${heads}</g>`;
  }
  return `<g transform="translate(${x},${y}) scale(${s})">${stalks}<path d="M-4.5,5 l9,0" stroke="#8a5a12" stroke-width="1.8" stroke-linecap="round"/></g>`;
}

/* ---- a woven cornucopia (horn of plenty) opening to the right ---- */
function cornucopia(x, y, s) {
  let weave = '';
  for (let i = 0; i < 4; i++) weave += `<path d="M${16 - i * 6.5},-6 C ${7 - i * 6.5},-8.5 ${1 - i * 6.5},-5 ${-1 - i * 6.5},0.5" stroke="#7a5122" stroke-width="1" fill="none"/>`;
  return `<g transform="translate(${x},${y}) scale(${s})">
    <path d="M18,-8 C 0,-16 -20,-10 -31,7 C -25,13 -14,10 -12,4 C -8,-4 5,-4 13,0.5 C 17,2.5 19,-2 18,-8 Z" fill="#9c6a2e"/>
    <path d="M-31,7 C -35,11 -34,17 -29,18 C -27,13 -28,9.5 -25,7.5 Z" fill="#7a5122"/>
    <ellipse cx="15" cy="-4" rx="4.5" ry="8.5" fill="#5e3f1a"/>
    ${weave}
  </g>`;
}

/* ---- Thanksgiving: harvest dusk — migrating birds, autumn tree line,
        rolling fields, falling leaves and a laid-out harvest feast ---- */
function thanksgivingScene() {
  const palette = ['#ef4123', '#f79321', '#c8641e', '#a6572a', '#d99a2b', '#8a4b1f'];

  // falling autumn leaves
  let leaves = '';
  for (let i = 0; i < 11; i++) {
    const x = rnd(12, 348);
    const size = rnd(6, 10.5);
    const c = palette[Math.floor(rnd(0, palette.length))];
    const dur = rnd(4.5, 8.5);
    const delay = -rnd(0, dur);
    const d = `M0,${(-size).toFixed(1)} C ${(size*0.95).toFixed(1)},${(-size*0.25).toFixed(1)} ${(size*0.7).toFixed(1)},${(size*0.75).toFixed(1)} 0,${size.toFixed(1)} C ${(-size*0.7).toFixed(1)},${(size*0.75).toFixed(1)} ${(-size*0.95).toFixed(1)},${(-size*0.25).toFixed(1)} 0,${(-size).toFixed(1)} Z`;
    leaves += `<g transform="translate(${x.toFixed(1)},0)"><g class="leaf" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s">
      <path d="${d}" fill="${c}"/>
      <line x1="0" y1="${(-size*0.85).toFixed(1)}" x2="0" y2="${(size*0.95).toFixed(1)}" stroke="rgba(255,255,255,.4)" stroke-width="0.8"/>
    </g></g>`;
  }

  // a distant V of migrating birds, gently twinkling in
  let birds = '';
  [[70,42],[86,38],[102,44],[118,48],[262,52],[278,48],[294,54]].forEach(([bx,by],i) => {
    birds += `<path class="twinkle" style="animation-delay:${(i*0.3).toFixed(2)}s" d="M${bx},${by} q4,-4 8,0 q4,-4 8,0" stroke="#5e3a1e" stroke-width="1.3" fill="none" stroke-linecap="round"/>`;
  });

  // muted autumn tree line on the horizon
  let treeline = '';
  [[26,'#8a4b1f'],[54,'#a6572a'],[86,'#9c5a24'],[300,'#8a4b1f'],[330,'#a6572a'],[356,'#9c5a24']].forEach(([tx,tc]) => {
    const r = rnd(14, 20), ty = 176 - r * 0.4;
    treeline += `<line x1="${tx}" y1="${ty}" x2="${tx}" y2="184" stroke="#5e3411" stroke-width="2.4"/>
      <circle cx="${tx}" cy="${ty.toFixed(1)}" r="${r.toFixed(1)}" fill="${tc}" opacity="0.55"/>`;
  });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Thanksgiving harvest scene with a turkey, pumpkins and a cornucopia">
    <defs><linearGradient id="skyTxg" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#f6c778"/><stop offset="0.5" stop-color="#e79a4d"/><stop offset="1" stop-color="#c76b2f"/>
    </linearGradient>
    <radialGradient id="sunTxg" cx="0.5" cy="0.30" r="0.55">
      <stop offset="0" stop-color="#fff6df"/><stop offset="1" stop-color="#fff6df" stop-opacity="0"/>
    </radialGradient></defs>
    <rect width="360" height="220" fill="url(#skyTxg)"/>
    <circle class="glow" cx="180" cy="58" r="128" fill="url(#sunTxg)"/>
    ${birds}
    ${treeline}
    <path d="M-10 184 Q 180 168 370 184 V 220 H -10 Z" fill="#c8641e" opacity="0.4"/>
    ${leaves}
    <path d="M-10 196 Q 180 174 370 196 V 220 H -10 Z" fill="#8a4b1f" opacity="0.6"/>
    <path d="M-10 207 Q 180 189 370 207 V 220 H -10 Z" fill="#6b3a17" opacity="0.78"/>

    <!-- LEFT: cornucopia spilling a harvest of fruit -->
    ${cornucopia(66, 200, 1.1)}
    ${apple(96, 198, 0.95, '#d8350f')}
    ${apple(110, 203, 0.85, '#e0902a')}
    ${corn(120, 196, 0.85, 24)}
    ${pumpkin(100, 208, 0.6, '#e07a1e')}

    <!-- CENTRE-FRONT: pie + gourds tucked below the mark -->
    ${gourd(150, 205, 0.85)}
    ${pie(196, 208, 0.82)}
    ${gourd(228, 206, 0.7)}

    <!-- RIGHT: pumpkin trio, wheat and the hero turkey -->
    ${wheat(340, 200, 1.05)}
    ${pumpkin(252, 207, 1.05, '#f79321')}
    ${pumpkin(276, 210, 0.7, '#e07a1e')}
    ${turkey(300, 182, 1.5, 0.0)}
  </svg>`;
}

/* ---- a small evergreen tree with snow caps ---- */
function tree(x, gy, s) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <rect x="-3" y="-6" width="6" height="9" rx="1.5" fill="#6b4423"/>
    <path d="M0,-46 L13,-26 L-13,-26 Z" fill="#2f6b45"/>
    <path d="M0,-32 L16,-9 L-16,-9 Z" fill="#357a4f"/>
    <path d="M0,-19 L19,6 L-19,6 Z" fill="#2f6b45"/>
    <path d="M0,-46 L6,-37 L-6,-37 Z" fill="#eaf4f0" opacity="0.92"/>
    <path d="M0,-32 L8,-22 L-8,-22 Z" fill="#eaf4f0" opacity="0.85"/>
    <path d="M0,-19 L9,-7 L-9,-7 Z" fill="#eaf4f0" opacity="0.8"/>
    <path d="M0,-52 l2.2,4.4 4.8,0.7 -3.5,3.4 0.8,4.8 -4.3,-2.3 -4.3,2.3 0.8,-4.8 -3.5,-3.4 4.8,-0.7 Z" fill="#f6c700"/>
  </g>`;
}

/* ---- Belgian National Day: day sky, tricolour bunting, confetti ---- */
/* ---- the Atomium: 9 chrome spheres as a cube standing on a vertex,
        rotating in real perspective (turntable about the vertical axis).
        Only horizontal position + apparent size change under a Y-axis
        spin, so it's driven cleanly with SMIL and scales with the viewBox. ---- */
function atomium(cx0, cy0) {
  const H = 27, h = 10, R = 19.5, rBase = 6.4, F = 48, DUR = '15s';
  const ring = (deg, yUp) => {
    const a = deg * Math.PI / 180, X = R * Math.cos(a), Z = R * Math.sin(a);
    const sx = [], rr = [], zr = [];
    for (let f = 0; f <= F; f++) {
      const p = (f / F) * 2 * Math.PI;
      const xr = X * Math.cos(p) + Z * Math.sin(p);
      const zz = -X * Math.sin(p) + Z * Math.cos(p);
      sx.push((cx0 + xr).toFixed(1));
      rr.push((rBase * (1 + 0.24 * zz / R)).toFixed(2));
      zr.push(zz);
    }
    return { x: cx0 + X, y: cy0 - yUp, sx, rr, zr };
  };
  const N = {
    top:    { x: cx0, y: cy0 - H }, bottom: { x: cx0, y: cy0 + H }, center: { x: cx0, y: cy0 },
    u0: ring(90, h), u1: ring(210, h), u2: ring(330, h),
    l0: ring(30, -h), l1: ring(150, -h), l2: ring(270, -h),
  };
  const zrAt = (n, f) => (n.zr ? n.zr[f] : 0);
  const anim = (attr, vals) => `<animate attributeName="${attr}" dur="${DUR}" repeatCount="indefinite" values="${vals.join(';')}"/>`;

  const edges = [
    ['top','u0'],['top','u1'],['top','u2'],
    ['bottom','l0'],['bottom','l1'],['bottom','l2'],
    ['u0','l0'],['u0','l1'],['u1','l1'],['u1','l2'],['u2','l2'],['u2','l0'],
    ['center','top'],['center','bottom'],
    ['center','u0'],['center','u1'],['center','u2'],['center','l0'],['center','l1'],['center','l2'],
  ];
  // each tube rendered as a back copy (behind centre) and a front copy, gated by
  // its average depth so paint order always matches which side it's on
  let backTubes = '', frontTubes = '';
  edges.forEach(([ka, kb]) => {
    const A = N[ka], B = N[kb], base = [], back = [], front = [];
    for (let f = 0; f <= F; f++) {
      const avg = (zrAt(A, f) + zrAt(B, f)) / 2;
      const o = 0.5 + 0.5 * (avg + R) / (2 * R);
      base.push(o); back.push((avg < 0 ? o : 0).toFixed(2)); front.push((avg >= 0 ? o : 0).toFixed(2));
    }
    const line = (opArr) => `<line x1="${A.x}" y1="${A.y}" x2="${B.x}" y2="${B.y}" stroke="#8299ad" stroke-width="2.9" stroke-linecap="round" opacity="${opArr[0]}">${A.sx ? anim('x1', A.sx) : ''}${B.sx ? anim('x2', B.sx) : ''}${anim('opacity', opArr)}</line>`;
    backTubes += line(back); frontTubes += line(front);
  });

  const sSphere = (n) => `<circle cx="${n.x}" cy="${n.y}" r="${rBase}" fill="url(#atomG)" stroke="#5e7286" stroke-width="0.5"/>`;
  const mSphere = (n, opArr) => `<circle cx="${n.sx[0]}" cy="${n.y}" r="${n.rr[0]}" fill="url(#atomG)" stroke="#5e7286" stroke-width="0.5" opacity="${opArr[0]}">${anim('cx', n.sx)}${anim('r', n.rr)}${anim('opacity', opArr)}</circle>`;
  const RINGS = [N.u0, N.u1, N.u2, N.l0, N.l1, N.l2];
  let backSpheres = '', frontSpheres = '';
  RINGS.forEach((n) => {
    const dop = n.zr.map((z) => 0.78 + 0.22 * (z + R) / (2 * R));
    backSpheres  += mSphere(n, n.zr.map((z, i) => (z <  0 ? dop[i] : 0).toFixed(2)));
    frontSpheres += mSphere(n, n.zr.map((z, i) => (z >= 0 ? dop[i] : 0).toFixed(2)));
  });

  // back layer → centre/top/bottom → front layer
  return `<g>${backTubes}${backSpheres}${sSphere(N.center)}${sSphere(N.top)}${sSphere(N.bottom)}${frontTubes}${frontSpheres}</g>`;
}

/* ---- Belgian National Day: dusk over Brussels — fireworks, Atomium,
        the Grand-Place spire, a waving tricolour and confetti ---- */
function belgianScene() {
  const tri = ['#1a1a1a', '#f6c700', '#ef4123'];

  // twinkling stars high in the dusk
  let stars = '';
  for (let i = 0; i < 14; i++) {
    const x = rnd(10, 350), y = rnd(6, 90), r = rnd(0.8, 1.7), dl = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${dl.toFixed(2)}s"/>`;
  }

  // fireworks bursting overhead (kept clear of the centre badge)
  const FW = [
    ['#f6c700',  74, 50, 0.0],
    ['#ffffff', 150, 66, 0.7],
    ['#ef4123', 240, 44, 1.3],
    ['#f6c700', 300, 74, 2.0],
  ];
  const N = 16;
  const bursts = FW.map(([c, cx, cy, dl]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*8).toFixed(1)}" y1="${(Math.sin(a)*8).toFixed(1)}" x2="${(Math.cos(a)*27).toFixed(1)}" y2="${(Math.sin(a)*27).toFixed(1)}" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*31).toFixed(1)}" cy="${(Math.sin(a)*31).toFixed(1)}" r="1.7" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${dl}s"><circle r="3" fill="#fff"/>${rays}</g></g>`;
  }).join('');

  // Brussels skyline silhouette with gold-lit windows
  const SKY = '#0e2136';
  const building = (x, top, w) => {
    let win = '';
    const cols = Math.max(1, Math.floor((w - 6) / 8));
    const rows = Math.max(1, Math.floor((224 - top - 8) / 11));
    for (let c = 0; c < cols; c++) for (let r = 0; r < rows; r++) {
      if (Math.random() < 0.5) {
        win += `<rect x="${(x+5+c*8).toFixed(1)}" y="${(top+7+r*11).toFixed(1)}" width="2.6" height="3.6" fill="${Math.random()<0.85?'#f6c700':'#fff2c2'}" opacity="${rnd(0.45,1).toFixed(2)}"/>`;
      }
    }
    return `<rect x="${x}" y="${top}" width="${w}" height="${224-top}" fill="${SKY}"/>${win}`;
  };
  const buildings = [ [0,170,34], [40,158,26], [70,176,18], [156,186,60], [222,166,28], [252,178,24], [330,168,34] ]
    .map((b) => building(...b)).join('');

  // Grand-Place town-hall block + gothic spire
  let hallWin = '';
  for (let i = 0; i < 8; i++) hallWin += `<rect x="${94+ (i%4)*13}" y="${162 + Math.floor(i/4)*16}" width="3" height="6" rx="1.5" fill="#f6c700" opacity="${rnd(0.6,1).toFixed(2)}"/>`;
  const townhall = `
    <rect x="88" y="150" width="66" height="74" fill="${SKY}"/>
    <rect x="115" y="112" width="16" height="44" fill="${SKY}"/>
    <path d="M115,112 L131,112 L123,88 Z" fill="${SKY}"/>
    <circle cx="123" cy="85" r="2.4" fill="#f6c700"/>
    <rect x="120" y="120" width="6" height="9" rx="3" fill="#f6c700" opacity="0.9"/>
    ${hallWin}`;

  // waving tricolour on a pole rising from the plaza
  const flag = `
    <g transform="translate(40,182)">
      <line x1="0" y1="40" x2="0" y2="-82" stroke="#c9cdd6" stroke-width="2.4" stroke-linecap="round"/>
      <circle cx="0" cy="-82" r="2.8" fill="#f6c700"/>
      <g transform="translate(2,-80)">
        <g class="beflag">
          <rect x="0" y="0" width="15" height="28" fill="#1a1a1a"/>
          <rect x="15" y="0" width="15" height="28" fill="#f6c700"/>
          <rect x="30" y="0" width="15" height="28" fill="#ef4123"/>
        </g>
      </g>
    </g>`;

  // light confetti drifting in the foreground
  let confetti = '';
  for (let i = 0; i < 12; i++) {
    const x = rnd(12, 348), c = tri[Math.floor(rnd(0, 3))];
    const dur = rnd(3.8, 6.5), delay = -rnd(0, dur), w = rnd(4, 6.5);
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="${(-w/2).toFixed(1)}" y="-2" width="${w.toFixed(1)}" height="4" rx="1" fill="${c}"/></g></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Belgian National Day fireworks over the Brussels skyline">
    <defs>
      <linearGradient id="skyBe" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#1c1740"/><stop offset="0.5" stop-color="#4a2f63"/><stop offset="0.82" stop-color="#a34a54"/><stop offset="1" stop-color="#e08a4e"/>
      </linearGradient>
      <radialGradient id="atomG" cx="0.36" cy="0.30" r="0.85">
        <stop offset="0" stop-color="#f6fafc"/><stop offset="0.3" stop-color="#cdd9e3"/><stop offset="0.64" stop-color="#93a8bb"/><stop offset="0.88" stop-color="#63788d"/><stop offset="1" stop-color="#4f6478"/>
      </radialGradient>
    </defs>
    <rect width="360" height="220" fill="url(#skyBe)"/>
    ${stars}
    ${bursts}
    ${buildings}
    ${townhall}
    ${atomium(300, 150)}
    ${flag}
    ${confetti}
  </svg>`;
}

/* ---- a wrapped gift box with gold ribbon + bow ---- */
function giftBox(sz, c) {
  const h = sz / 2;
  return `<rect x="${-h}" y="${-h}" width="${sz}" height="${sz}" rx="1.5" fill="${c}"/>` +
    `<rect x="${-h}" y="-1" width="${sz}" height="2" fill="#f6c700"/>` +
    `<rect x="-1" y="${-h}" width="2" height="${sz}" fill="#f6c700"/>` +
    `<circle cx="-2.2" cy="${-h}" r="1.7" fill="#f6c700"/><circle cx="2.2" cy="${-h}" r="1.7" fill="#f6c700"/>`;
}

/* ---- Santa's sleigh + a two-reindeer team, flying right ---- */
function santaTeam() {
  const reindeer = (rx, rudolph) => `<g transform="translate(${rx},0)">
    <line x1="-6" y1="4" x2="-8" y2="10" stroke="#6b4423" stroke-width="1.4" stroke-linecap="round"/>
    <line x1="-2" y1="5" x2="-3" y2="11" stroke="#6b4423" stroke-width="1.4" stroke-linecap="round"/>
    <line x1="4" y1="5" x2="5" y2="11" stroke="#6b4423" stroke-width="1.4" stroke-linecap="round"/>
    <line x1="7" y1="4" x2="9" y2="10" stroke="#6b4423" stroke-width="1.4" stroke-linecap="round"/>
    <path d="M-8,0 l-3.5,2.5" stroke="#6b4423" stroke-width="1.3" stroke-linecap="round"/>
    <ellipse cx="0" cy="1" rx="9" ry="4.8" fill="#9c6a34"/>
    <ellipse cx="9.5" cy="-4" rx="4" ry="3.3" fill="#9c6a34"/>
    <path d="M8,-7 l-1.6,-4 M8.5,-7 l1.5,-3.6 M11.5,-7 l0.2,-4.2 M11.5,-7 l2.3,-3" stroke="#6b4423" stroke-width="1" stroke-linecap="round" fill="none"/>
    <circle cx="13" cy="-3.4" r="${rudolph ? 1.9 : 1.1}" fill="${rudolph ? '#ef4123' : '#3a2416'}"/>
  </g>`;

  const rig = `
    <path d="M14,-4 Q 30,-7 48,-6" stroke="#6b4423" stroke-width="0.9" fill="none"/>
    <g transform="translate(-6,2)">
      <path d="M-15,10 L8,10 C16,10 20.5,5 20.5,-1 C20.5,-5.5 15,-5.5 15,0" stroke="#8a5a12" stroke-width="2.6" fill="none" stroke-linecap="round"/>
      <path d="M-15,-8 L-15,7 Q-15,9 -12,9 L11,9 Q15,9 15,4.5 L15,-2 Q15,-6 9,-6 Q0,-6 -6,-8 Z" fill="#d99321"/>
      <path d="M15,4.5 C18,4.5 19,1 18,-2" stroke="#b9791a" stroke-width="1.4" fill="none" stroke-linecap="round"/>
      <rect x="-15" y="-1.6" width="30" height="2.4" rx="1" fill="#f6c700"/>
      <g transform="translate(-9,-4) scale(0.6)">${giftBox(9, '#357a4f')}</g>
      <g transform="translate(-3.5,-6) scale(0.55)">${giftBox(9, '#6699cc')}</g>
      <ellipse cx="-1" cy="-2" rx="5" ry="6" fill="#ef4123"/>
      <rect x="-5.5" y="2" width="9" height="3.4" rx="1.4" fill="#2a2a2a"/>
      <rect x="-2.6" y="2.4" width="3" height="2.6" fill="#f6c700"/>
      <path d="M-4.5,-8 Q-1,-3 2.5,-8 Q-1,-6.6 -4.5,-8 Z" fill="#fff"/>
      <circle cx="-1" cy="-10" r="3.6" fill="#ffd9b8"/>
      <rect x="-5" y="-11.6" width="8" height="1.8" rx="0.9" fill="#fff"/>
      <path d="M-5,-11 L1,-11 L-6,-17 Z" fill="#ef4123"/>
      <circle cx="-6.4" cy="-17" r="1.5" fill="#fff"/>
    </g>
    ${reindeer(28, false)}
    ${reindeer(50, true)}`;

  return `<g class="sleighFly"><g transform="translate(0,58) scale(1.2)"><g class="sleighBob">${rig}</g></g></g>`;
}

/* ---- Christmas (general): wintry night, snow, evergreens, flying Santa ---- */
function christmasScene() {
  let snow = '';
  for (let i = 0; i < 34; i++) {
    const x = rnd(6, 354), r = rnd(1, 2.6), dur = rnd(4.5, 9), delay = -rnd(0, dur), o = rnd(0.5, 1);
    snow += `<circle class="snow" cx="${x.toFixed(1)}" cy="0" r="${r.toFixed(1)}" fill="#fff" opacity="${o.toFixed(2)}" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"/>`;
  }
  // a couple of presents tumbling down from the sky
  const drops = [ [110, '#357a4f', 5.5, -1.5], [232, '#ef4123', 6, -3.4], [300, '#6699cc', 5, -0.6] ];
  let gifts = '';
  drops.forEach(([x, c, dur, delay]) => {
    gifts += `<g transform="translate(${x},0)"><g class="giftfall" style="animation-duration:${dur}s;animation-delay:${delay}s">${giftBox(11, c)}</g></g>`;
  });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Christmas snow, evergreens and Santa's sleigh">
    <defs><linearGradient id="skyXm" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#16335c"/><stop offset="0.55" stop-color="#28507a"/><stop offset="1" stop-color="#3f6d95"/>
    </linearGradient>
    <radialGradient id="moonXm" cx="0.78" cy="0.24" r="0.4">
      <stop offset="0" stop-color="#dfeeff" stop-opacity="0.9"/><stop offset="1" stop-color="#dfeeff" stop-opacity="0"/>
    </radialGradient></defs>
    <rect width="360" height="220" fill="url(#skyXm)"/>
    <circle class="glow" cx="286" cy="50" r="70" fill="url(#moonXm)"/>
    <circle cx="286" cy="50" r="15" fill="#f2f7ff" opacity="0.95"/>
    ${snow}
    ${santaTeam()}
    <path d="M-10 200 Q 180 178 370 200 V 220 H -10 Z" fill="#e9f1f8"/>
    <path d="M-10 210 Q 180 194 370 210 V 220 H -10 Z" fill="#fbfdff"/>
    ${tree(58, 204, 1.15)}
    ${tree(300, 206, 1.35)}
    ${tree(340, 208, 0.9)}
    ${gifts}
  </svg>`;
}

/* ---- a sagging string of triangle pennants (positions computed along
        the quadratic so the flags hang off the actual curve) ---- */
function pennantSwag(x0, y0, x1, y1, sag, cols, delay) {
  const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2 + sag;
  const n = Math.max(4, Math.round(Math.hypot(x1 - x0, y1 - y0) / 24));
  let pens = '';
  for (let i = 1; i < n; i++) {
    const t = i / n;
    const bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
    const by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
    const tx = 2 * (1 - t) * (cx - x0) + 2 * t * (x1 - cx);
    const ty = 2 * (1 - t) * (cy - y0) + 2 * t * (y1 - cy);
    const ang = Math.atan2(ty, tx) * 180 / Math.PI;
    pens += `<g transform="translate(${bx.toFixed(1)},${by.toFixed(1)}) rotate(${ang.toFixed(1)})"><path d="M-7,0 L7,0 L0,15 Z" fill="${cols[i % cols.length]}"/></g>`;
  }
  return `<g class="bunting" style="animation-delay:${delay}s">
    <path d="M${x0},${y0} Q ${cx},${cy} ${x1},${y1}" stroke="rgba(255,255,255,.6)" stroke-width="1.4" fill="none"/>
    ${pens}
  </g>`;
}

/* ---- a bobbing party-goer silhouette with raised arms ---- */
function dancer(x, y, s, c, delay, dur) {
  return `<g transform="translate(${x},${y}) scale(${s})"><g class="dancer" style="animation-delay:${delay}s;animation-duration:${dur}s">
    <circle cx="0" cy="-27" r="6" fill="${c}"/>
    <path d="M-9.5,0 C -9.5,-15 9.5,-15 9.5,0 Z" fill="${c}"/>
    <path d="M-7,-16 C -12,-21 -14.5,-27 -13.5,-33" stroke="${c}" stroke-width="3.4" stroke-linecap="round" fill="none"/>
    <path d="M7,-16 C 12,-21 14.5,-27 13.5,-33" stroke="${c}" stroke-width="3.4" stroke-linecap="round" fill="none"/>
    <circle cx="-13.5" cy="-34.5" r="2.4" fill="${c}"/>
    <circle cx="13.5" cy="-34.5" r="2.4" fill="${c}"/>
  </g></g>`;
}

/* ---- Carnival: hot Rio night — Sugarloaf, roaming spotlights, pennant
        swags, feather fans, serpentine streamers, balloons and confetti ---- */
function carnivalScene() {
  const cols = ['#f6c700', '#ef4123', '#2fb457', '#2a7de1', '#b44fd8', '#ff8a3c'];

  const swags =
    pennantSwag(-8, 10, 150, 4, 34, cols, 0) +
    pennantSwag(130, 2, 300, 12, 30, ['#2fb457', '#2a7de1', '#b44fd8', '#ff8a3c', '#f6c700', '#ef4123'], 0.8) +
    pennantSwag(250, 8, 368, 0, 26, ['#b44fd8', '#ff8a3c', '#f6c700', '#ef4123', '#2fb457', '#2a7de1'], 1.6);

  // spotlight beams sweeping up from the street
  const beam = (bx, dur, dl) => `<g transform="translate(${bx},224)"><g class="fansway" style="animation-duration:${dur}s;animation-delay:${dl}s"><polygon points="0,0 -50,-240 50,-240" fill="url(#beamCv)"/></g></g>`;
  const beams = beam(96, 5.2, 0) + beam(268, 6.4, -2.4);

  // serpentine streamers spiralling down
  let streamers = '';
  for (let i = 0; i < 8; i++) {
    const x = rnd(14, 346), c = cols[i % cols.length], dur = rnd(5, 8), delay = -rnd(0, dur);
    streamers += `<g transform="translate(${x.toFixed(1)},0)"><g class="streamer" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s">
      <path d="M0,0 C 7,9 -7,18 0,27 C 7,36 -7,45 0,54" stroke="${c}" stroke-width="3.2" fill="none" stroke-linecap="round"/>
    </g></g>`;
  }

  // confetti blizzard — rects and dots
  let confetti = '';
  for (let i = 0; i < 30; i++) {
    const x = rnd(8, 352), c = cols[Math.floor(rnd(0, cols.length))];
    const dur = rnd(3.2, 6.2), delay = -rnd(0, dur);
    const bit = i % 3 === 0 ? `<circle r="2.4" fill="${c}"/>` : `<rect x="-3" y="-1.8" width="6" height="3.6" rx="1" fill="${c}"/>`;
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s">${bit}</g></g>`;
  }

  // balloons drifting up past the party
  let balloons = '';
  [[38, '#f6c700', 9, -1], [70, '#b44fd8', 10.5, -6.5], [292, '#ef4123', 8.4, -3], [326, '#2fb457', 11, -8]].forEach(([x, c, dur, delay]) => {
    balloons += `<g transform="translate(${x},262)"><g class="balloonUp" style="animation-duration:${dur}s;animation-delay:${delay}s">
      <ellipse rx="9" ry="11" fill="${c}"/><path d="M0,11 l-3,4.5 l6,0 Z" fill="${c}"/>
      <path d="M0,15.5 q4,9 -1,17" stroke="rgba(255,255,255,.5)" stroke-width="1.1" fill="none"/>
      <ellipse cx="-3" cy="-3.5" rx="2.4" ry="3.8" fill="rgba(255,255,255,.35)"/>
    </g></g>`;
  });

  // a dancing street crowd — back row lighter and smaller, front row bold
  let crowd = '';
  [[16,0.62],[52,0.58],[86,0.65],[122,0.6],[158,0.63],[196,0.58],[232,0.64],[268,0.6],[304,0.65],[342,0.6]].forEach(([x, s], i) => {
    crowd += dancer(x + rnd(-4, 4), 216, s, '#3a1550', (-rnd(0, 0.9)).toFixed(2), (0.85 + (i % 3) * 0.1).toFixed(2));
  });
  [[34,0.9],[104,0.82],[176,0.88],[248,0.84],[322,0.92]].forEach(([x, s], i) => {
    crowd += dancer(x + rnd(-5, 5), 226, s, '#1f0a36', (-rnd(0, 0.9)).toFixed(2), (0.8 + (i % 3) * 0.12).toFixed(2));
  });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Carnival night in Rio with pennants, feather fans, streamers and confetti">
    <defs>
      <linearGradient id="skyCv" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#2b1055"/><stop offset="0.55" stop-color="#7a2a8a"/><stop offset="1" stop-color="#d84a8b"/>
      </linearGradient>
      <linearGradient id="beamCv" x1="0" y1="1" x2="0" y2="0">
        <stop offset="0" stop-color="#fff" stop-opacity="0.30"/><stop offset="1" stop-color="#fff" stop-opacity="0"/>
      </linearGradient>
    </defs>
    <rect width="360" height="220" fill="url(#skyCv)"/>
    <!-- Sugarloaf silhouettes -->
    <path d="M244,220 Q 250,168 266,162 Q 282,168 288,220 Z" fill="#2a0e45" opacity="0.8"/>
    <path d="M282,220 Q 292,142 316,136 Q 340,142 350,220 Z" fill="#1f0a36" opacity="0.9"/>
    ${beams}
    ${swags}
    ${streamers}
    ${balloons}
    <path d="M-10,214 Q 180,200 370,214 V 220 H -10 Z" fill="#1f0a36"/>
    ${crowd}
    ${confetti}
  </svg>`;
}

/* ---- Brazil Independence Day: green-and-gold fireworks over rolling
        hills, and the Brazilian flag rippling on its pole ---- */
function brazilScene() {
  // twinkling stars
  let stars = '';
  for (let i = 0; i < 20; i++) {
    const x = rnd(12, 348), y = rnd(8, 140), r = rnd(0.9, 2), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // fireworks in the national colours
  const FW = [
    ['#ffdf00', 250,  42, 0.0],
    ['#ffffff', 314, 100, 0.6],
    ['#35c46a', 108, 158, 1.1],
    ['#ffdf00', 286, 166, 1.7],
    ['#35c46a', 226,  72, 2.1],
  ];
  const NR = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < NR; i++) {
      const a = (i / NR) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*26).toFixed(1)}" y2="${(Math.sin(a)*26).toFixed(1)}" stroke="${c}" stroke-width="1.7" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*30).toFixed(1)}" cy="${(Math.sin(a)*30).toFixed(1)}" r="1.8" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  // ---- the flag: 10:7 ratio, yellow rhombus, blue globe with band + stars ----
  const W = 150, H = 105;                       // module = 7.5 on the official 20×14 grid
  const inset = 1.7 * 7.5, R = 3.5 * 7.5;       // rhombus margin + globe radius
  let cloth = `<rect width="${W}" height="${H}" fill="#009C3B"/>`;
  cloth += `<polygon points="${W/2},${inset} ${W-inset},${H/2} ${W/2},${H-inset} ${inset},${H/2}" fill="#FFDF00"/>`;
  cloth += `<circle cx="${W/2}" cy="${H/2}" r="${R}" fill="#002776"/>`;
  cloth += `<path d="M${(W/2-R-2).toFixed(1)},${(H/2+10).toFixed(1)} Q ${W/2},${(H/2-15).toFixed(1)} ${(W/2+R+2).toFixed(1)},${(H/2-4).toFixed(1)}" stroke="#fff" stroke-width="8" fill="none" clip-path="url(#brGlobe)"/>`;
  // a scatter of stars in the lower globe (plus Pará's lone star above the band)
  [[68,40.5,1.2],[60,62,1.4],[70,68,1.1],[79,64,1.5],[88,70,1.2],[74,75,1.1],[64,73,0.9],[85,60,1.0],[92,66,0.9]].forEach(([sx,sy,sr]) => {
    cloth += `<circle cx="${sx}" cy="${sy}" r="${sr}" fill="#fff" clip-path="url(#brGlobe)"/>`;
  });
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(255,255,255,.25)" stroke-width="0.6"/>`;

  // slice into vertical strips so the cloth ripples; hoist edge stays pinned
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="brcp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.8 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#brcp${i})"><use href="#brflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Brazilian Independence Day — the Brazilian flag waving under green and gold fireworks">
    <defs>
      <linearGradient id="skyBr" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#0a1f33"/><stop offset="0.55" stop-color="#0e3c3a"/><stop offset="1" stop-color="#136a40"/>
      </linearGradient>
      <clipPath id="brGlobe"><circle cx="${W/2}" cy="${H/2}" r="${R}"/></clipPath>
      <g id="brflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyBr)"/>
    ${stars}
    ${bursts}
    <path d="M-10,192 Q 70,162 170,186 T 370,180 V 220 H -10 Z" fill="#07301c" opacity="0.85"/>
    <path d="M-10,206 Q 180,186 370,206 V 220 H -10 Z" fill="#052414"/>
    <line x1="44" y1="212" x2="44" y2="10" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="8" r="3" fill="#FFDF00"/>
    <g transform="translate(45,16)">${strips}</g>
  </svg>`;
}

/* ---- a huaso and china dancing the cueca, white handkerchiefs aloft ---- */
function cuecaPair(x, y, s, c, delay) {
  const hanky = (hx, hy, flip, dl) => `<g transform="translate(${hx},${hy})${flip ? ' scale(-1,1)' : ''}"><g class="hanky" style="animation-delay:${dl}s">
    <line x1="0" y1="0" x2="3" y2="-5.5" stroke="#fff" stroke-width="1.1"/>
    <path d="M3,-5.5 Q 10,-11 14,-4.5 Q 8.5,1 3,-5.5 Z" fill="#fff" opacity="0.95"/>
  </g></g>`;
  return `<g transform="translate(${x},${y}) scale(${s})">
    <!-- huaso: chupalla hat, short manta, riding boots -->
    <g class="dancer" style="animation-delay:${delay}s;animation-duration:0.95s">
      <g transform="translate(-19,0)">
        <line x1="-4" y1="0" x2="-4.5" y2="-13" stroke="${c}" stroke-width="3.2" stroke-linecap="round"/>
        <line x1="4" y1="0" x2="4.5" y2="-13" stroke="${c}" stroke-width="3.2" stroke-linecap="round"/>
        <path d="M-10.5,-12 L10.5,-12 L6,-30 L-6,-30 Z" fill="${c}"/>
        <circle cx="0" cy="-34" r="4.4" fill="${c}"/>
        <rect x="-3.8" y="-41.5" width="7.6" height="4.5" rx="1.6" fill="${c}"/>
        <ellipse cx="0" cy="-37.6" rx="9.5" ry="1.9" fill="${c}"/>
        <path d="M5,-29 Q 11,-34 13.5,-41" stroke="${c}" stroke-width="2.6" fill="none" stroke-linecap="round"/>
        <path d="M-5,-28 Q -9,-24 -10,-19" stroke="${c}" stroke-width="2.6" fill="none" stroke-linecap="round"/>
        ${hanky(13.5, -41, false, delay)}
      </g>
    </g>
    <!-- china: flared dress, bun and a copihue-red flower -->
    <g class="dancer" style="animation-delay:${(delay - 0.45).toFixed(2)}s;animation-duration:0.95s">
      <g transform="translate(19,0)">
        <path d="M0,-17 C 11,-15 13,-4 16.5,0 L-16.5,0 C -13,-4 -11,-15 0,-17 Z" fill="${c}"/>
        <path d="M-3.4,-16 L3.4,-16 L2.6,-26.5 L-2.6,-26.5 Z" fill="${c}"/>
        <circle cx="0" cy="-30.5" r="4.1" fill="${c}"/>
        <circle cx="3.6" cy="-33.6" r="2.1" fill="${c}"/>
        <circle cx="5.2" cy="-31.4" r="1.4" fill="#D52B1E"/>
        <path d="M-3,-26 Q -8,-31 -10.5,-38" stroke="${c}" stroke-width="2.4" fill="none" stroke-linecap="round"/>
        <path d="M3,-25 Q 7,-22 8,-17" stroke="${c}" stroke-width="2.4" fill="none" stroke-linecap="round"/>
        ${hanky(-10.5, -38, true, (delay - 0.45).toFixed(2))}
      </g>
    </g>
  </g>`;
}

/* ---- a fonda ramada: wooden posts, straw roof, a little flag on the ridge ---- */
function ramada(x, gy, s) {
  let straw = '';
  for (let i = 0; i < 9; i++) straw += `<line x1="${-27 + i * 6.5}" y1="-31" x2="${-24 + i * 6.5}" y2="-42" stroke="#a87e2e" stroke-width="1.1"/>`;
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <line x1="-24" y1="0" x2="-24" y2="-32" stroke="#6b4423" stroke-width="2.8"/>
    <line x1="24" y1="0" x2="24" y2="-32" stroke="#6b4423" stroke-width="2.8"/>
    <path d="M-31,-30 L31,-30 L25,-43 L-25,-43 Z" fill="#c9a24a"/>
    ${straw}
    <path d="M-31,-30 L31,-30 L31,-27.4 L-31,-27.4 Z" fill="#8a5a12"/>
    <rect x="-20" y="-14" width="40" height="14" fill="#8a5a12"/>
    <rect x="-20" y="-14" width="40" height="3" fill="#a87e2e"/>
    <line x1="0" y1="-43" x2="0" y2="-54" stroke="#6b4423" stroke-width="1.4"/>
    <g transform="translate(0.7,-54)">
      <rect width="10" height="3.4" fill="#fff"/><rect y="3.4" width="10" height="3.4" fill="#D52B1E"/><rect width="4" height="3.4" fill="#0039A6"/>
    </g>
  </g>`;
}

/* ---- Fiestas Patrias: a spring day in the Chilean countryside — volantines
        (fighter kites) over the snow-capped Andes, tricolour pennants, a fonda
        ramada, cueca dancers and the Chilean flag rippling on its pole ---- */
function fiestasPatriasScene() {
  // puffy spring clouds drifting
  const cloud = (x, y, s, dur, dl) => `<g transform="translate(${x},${y})"><g class="drift" style="animation-duration:${dur}s;animation-delay:${dl}s"><g transform="scale(${s})" fill="#fff" opacity="0.9">
    <ellipse cx="0" cy="0" rx="17" ry="6.5"/><circle cx="-7" cy="-4" r="5.5"/><circle cx="4" cy="-5.5" r="7"/>
  </g></g></g>`;
  const clouds = cloud(150, 34, 1, 9, 0) + cloud(268, 22, 0.75, 11, -4) + cloud(318, 58, 0.6, 8, -2);

  // volantines aloft for the Dieciocho
  const kites =
    kite(256, 46, 1.0, '#D52B1E', 0, 5.6) +
    kite(320, 96, 0.75, '#0039A6', -2, 6.2) +
    kite(200, 26, 0.62, '#f6c700', -3.4, 5.2) +
    kite(146, 56, 0.55, '#2fb457', -1.2, 6.8);

  // tricolour pennant swags
  const swags =
    pennantSwag(-8, 6, 148, 0, 26, ['#D52B1E', '#f4f7fa', '#0039A6'], 0) +
    pennantSwag(238, 2, 368, 8, 24, ['#0039A6', '#f4f7fa', '#D52B1E'], 1.2);

  // the Andes cordillera with snow caps
  const cap = (px, py) => `<path d="M${px - 11},${py + 9} L${px},${py} L${px + 11},${py + 9} L${px + 6},${py + 6} L${px + 1},${py + 10} L${px - 5},${py + 5} Z" fill="#f6fafd"/>`;
  const andes = `
    <path d="M-10,162 L42,118 L92,152 L136,116 L184,154 L228,110 L276,150 L318,120 L370,158 V 220 H -10 Z" fill="#8fa7c0"/>
    ${cap(42, 118)}${cap(136, 116)}${cap(228, 110)}${cap(318, 120)}
    <path d="M-10,176 L64,146 L124,170 L204,142 L262,168 L330,146 L370,164 V 220 H -10 Z" fill="#5e7a99"/>`;

  // ---- the flag: 3:2, white over red, blue canton with the lone star ----
  const W = 150, H = 100;
  const star = (cx, cy, r) => {
    let p = '';
    for (let k = 0; k < 10; k++) {
      const a = -Math.PI / 2 + k * Math.PI / 5, rr = k % 2 ? r * 0.42 : r;
      p += `${(cx + rr * Math.cos(a)).toFixed(2)},${(cy + rr * Math.sin(a)).toFixed(2)} `;
    }
    return `<polygon points="${p.trim()}" fill="#ffffff"/>`;
  };
  let cloth = `<rect width="${W}" height="${H / 2 + 0.3}" fill="#ffffff"/><rect y="${H / 2}" width="${W}" height="${H / 2}" fill="#D52B1E"/><rect width="${H / 2}" height="${H / 2}" fill="#0039A6"/>`;
  cloth += star(25, 25, 15);
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.22)" stroke-width="0.6"/>`;

  // slice into vertical strips so the cloth ripples; hoist edge stays pinned
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="clcp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#clcp${i})"><use href="#clflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Fiestas Patrias — the Chilean flag waving with kites over the Andes, cueca dancers and a fonda">
    <defs>
      <linearGradient id="skyCl18" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#5e97cf"/><stop offset="0.55" stop-color="#a5c8e6"/><stop offset="1" stop-color="#e8e3cd"/>
      </linearGradient>
      <g id="clflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyCl18)"/>
    ${clouds}
    ${kites}
    ${andes}
    ${swags}
    <path d="M-10,196 Q 180,182 370,196 V 220 H -10 Z" fill="#7a9a3a"/>
    <path d="M-10,208 Q 180,197 370,208 V 220 H -10 Z" fill="#5e7a2a"/>
    ${ramada(304, 206, 1.05)}
    ${cuecaPair(236, 205, 0.88, '#3f2a17', -0.2)}
    ${cuecaPair(112, 207, 0.72, '#4a3524', -0.7)}
    <line x1="44" y1="212" x2="44" y2="10" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="8" r="3" fill="#D52B1E"/>
    <g transform="translate(45,16)">${strips}</g>
  </svg>`;
}

/* ---- an evergreen dressed for a Chilean summer Christmas ---- */
function xmasTreeCl(x, gy, s) {
  const LIGHTS = [[-5, -49, '#f6c700'], [6, -40, '#ef4123'], [-8, -37, '#2a7de1'], [2, -30, '#f6c700'], [12, -20, '#e84a8a'], [-12, -22, '#ef4123'], [0, -12, '#2a7de1'], [15, -7, '#f6c700'], [-16, -6, '#ef4123'], [7, -15, '#2fb457']];
  let lights = '';
  LIGHTS.forEach(([lx, ly, c], i) => {
    lights += `<circle class="twinkle" cx="${lx}" cy="${ly}" r="2" fill="${c}" style="animation-delay:${(i * 0.22).toFixed(2)}s"/>`;
  });
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <rect x="-3.4" y="-7" width="6.8" height="9" rx="1.6" fill="#6b4423"/>
    <path d="M0,-56 L14,-33 L-14,-33 Z" fill="#2f6b45"/>
    <path d="M0,-42 L17.5,-14 L-17.5,-14 Z" fill="#357a4f"/>
    <path d="M0,-28 L21,2 L-21,2 Z" fill="#2f6b45"/>
    ${lights}
    <path d="M0,-63 l2.2,4.4 4.8,0.7 -3.5,3.4 0.8,4.8 -4.3,-2.3 -4.3,2.3 0.8,-4.8 -3.5,-3.4 4.8,-0.7 Z" fill="#f6c700"/>
  </g>`;
}

/* ---- a plaza palm silhouette (Christmas is midsummer in Chile) ---- */
function palmCl(x, gy, s, c) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <path d="M-2.6,0 C -1.4,-12 0.6,-23 -0.6,-33 L3.6,-33 C 3.8,-23 4.4,-12 4.6,0 Z" fill="${c}"/>
    <g transform="translate(1.5,-33)" stroke="${c}" stroke-width="3.2" fill="none" stroke-linecap="round">
      <path d="M0,0 Q -13,-7 -23,-1"/>
      <path d="M0,0 Q -9,-13 -19,-13"/>
      <path d="M0,0 Q 13,-7 23,-1"/>
      <path d="M0,0 Q 9,-13 19,-13"/>
      <path d="M0,0 Q -2,-15 -9,-18"/>
      <path d="M0,0 Q 2,-15 9,-18"/>
    </g>
    <circle cx="-2" cy="-31" r="1.9" fill="${c}"/><circle cx="5.5" cy="-30" r="1.9" fill="${c}"/>
  </g>`;
}

/* ---- Christmas in Chile: a warm midsummer dusk — the Southern Cross rising,
        string lights over the plaza, a lit tree among palms, and Santa
        crossing high over the Andes ---- */
function chileChristmasScene() {
  let stars = '';
  for (let i = 0; i < 20; i++) {
    const x = rnd(10, 350), y = rnd(6, 92), r = rnd(0.8, 1.8), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${i % 4 ? '#fff' : '#ffe9a0'}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }
  // the Southern Cross (Crux), bright and low in the summer sky
  let crux = '';
  [[318, 18, 2.2], [312, 52, 2.4], [297, 36, 1.9], [330, 32, 1.7], [321, 40, 1.1]].forEach(([sx, sy, sr], i) => {
    crux += `<circle class="twinkle" cx="${sx}" cy="${sy}" r="${sr}" fill="#fff" style="animation-delay:${(i * 0.4).toFixed(1)}s"/>`;
  });

  // string-light swags over the plaza
  const bulbSwag = (x0, y0, x1, y1, sag, delay) => {
    const cols = ['#f6c700', '#ef4123', '#2a7de1', '#2fb457', '#e84a8a'];
    const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2 + sag;
    const n = Math.max(5, Math.round(Math.hypot(x1 - x0, y1 - y0) / 18));
    let bulbs = '';
    for (let i = 1; i < n; i++) {
      const t = i / n;
      const bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
      const by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
      bulbs += `<circle class="twinkle" cx="${bx.toFixed(1)}" cy="${(by + 3).toFixed(1)}" r="2.2" fill="${cols[i % cols.length]}" style="animation-delay:${(i * 0.18).toFixed(2)}s"/>`;
    }
    return `<g class="bunting" style="animation-delay:${delay}s">
      <path d="M${x0},${y0} Q ${cx},${cy} ${x1},${y1}" stroke="rgba(255,255,255,.45)" stroke-width="1.2" fill="none"/>
      ${bulbs}
    </g>`;
  };
  const swags = bulbSwag(-8, 8, 132, 2, 22, 0) + bulbSwag(228, 4, 368, 10, 20, 1.1);

  // the Andes at dusk, snow caps blushing pink
  const cap = (px, py) => `<path d="M${px - 12},${py + 10} L${px},${py} L${px + 12},${py + 10} L${px + 6},${py + 7} L${px + 1},${py + 11} L${px - 5},${py + 6} Z" fill="#f2dce8" opacity="0.9"/>`;
  const andes = `
    <path d="M-10,152 L48,110 L104,146 L168,104 L230,144 L292,100 L370,146 V 220 H -10 Z" fill="#3c2a52"/>
    ${cap(48, 110)}${cap(168, 104)}${cap(292, 100)}`;

  // low Santiago rooftops with lit windows
  const SKY = '#241536';
  const building = (x, top, w) => {
    let win = '';
    const cols = Math.max(1, Math.floor((w - 6) / 8));
    const rows = Math.max(1, Math.floor((200 - top - 6) / 11));
    for (let c = 0; c < cols; c++) for (let r = 0; r < rows; r++) {
      if (Math.random() < 0.5) {
        win += `<rect x="${(x + 5 + c * 8).toFixed(1)}" y="${(top + 6 + r * 11).toFixed(1)}" width="2.6" height="3.6" fill="#f6c700" opacity="${rnd(0.45, 1).toFixed(2)}"/>`;
      }
    }
    return `<rect x="${x}" y="${top}" width="${w}" height="${200 - top}" fill="${SKY}"/>${win}`;
  };
  const buildings = [[122, 164, 24], [152, 176, 20], [196, 160, 26], [228, 174, 20]].map((b) => building(...b)).join('');

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Christmas in Chile — a summer-evening plaza with a lit tree, palms and Santa crossing over the Andes">
    <defs><linearGradient id="skyClXm" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#1a2f52"/><stop offset="0.5" stop-color="#4a3766"/><stop offset="0.82" stop-color="#8a4a5e"/><stop offset="1" stop-color="#e08a4e"/>
    </linearGradient></defs>
    <rect width="360" height="220" fill="url(#skyClXm)"/>
    ${stars}
    ${crux}
    ${andes}
    ${santaTeam()}
    ${buildings}
    ${swags}
    <path d="M-10,198 Q 180,188 370,198 V 220 H -10 Z" fill="#2e1c44"/>
    <rect y="208" width="360" height="12" fill="#241536"/>
    ${xmasTreeCl(84, 209, 1.5)}
    <g transform="translate(58,206)">${giftBox(10, '#ef4123')}</g>
    <g transform="translate(112,207)">${giftBox(8.5, '#2a7de1')}</g>
    <g transform="translate(74,210)">${giftBox(9, '#2fb457')}</g>
    ${palmCl(284, 208, 1.05, '#1c102e')}
    ${palmCl(330, 210, 0.85, '#241536')}
    ${palmCl(252, 211, 0.68, '#1c102e')}
  </svg>`;
}

/* ---- a clay diya lamp with a flickering flame ---- */
function diya(x, y, s, delay) {
  return `<g transform="translate(${x},${y}) scale(${s})">
    <ellipse class="glow" cx="0" cy="-6" rx="9" ry="10" fill="rgba(255,182,30,.3)" style="animation-delay:${delay}s"/>
    <g class="flame" style="animation-delay:${delay}s">
      <path d="M0,-13.5 C 3.6,-8.5 3.8,-4 0,-1.5 C -3.8,-4 -3.6,-8.5 0,-13.5 Z" fill="#ffb61e"/>
      <path d="M0,-9.5 C 1.9,-6.8 1.9,-3.8 0,-2.2 C -1.9,-3.8 -1.9,-6.8 0,-9.5 Z" fill="#fff3c4"/>
    </g>
    <path d="M-11,-1 C -10.5,6 10.5,6 11,-1 Z" fill="#b5541f"/>
    <ellipse cx="0" cy="-1" rx="11" ry="2.4" fill="#8a3d14"/>
  </g>`;
}

/* ---- a sagging marigold garland (buds strung along the quadratic) ---- */
function marigoldSwag(x0, y0, x1, y1, sag, delay) {
  const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2 + sag;
  const n = Math.max(5, Math.round(Math.hypot(x1 - x0, y1 - y0) / 14));
  let buds = '';
  for (let i = 0; i <= n; i++) {
    const t = i / n;
    const bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
    const by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
    buds += `<circle cx="${bx.toFixed(1)}" cy="${by.toFixed(1)}" r="${i % 2 ? 3.2 : 4}" fill="${i % 2 ? '#ffb61e' : '#f2721c'}"/>`;
  }
  return `<g class="bunting" style="animation-delay:${delay}s">
    <path d="M${x0},${y0} Q ${cx},${cy} ${x1},${y1}" stroke="#3f7a4f" stroke-width="1.4" fill="none"/>
    ${buds}
  </g>`;
}

/* ---- a chalk-powder rangoli, flattened into floor perspective ---- */
function rangoli(x, y, s) {
  let petals = '';
  for (let i = 0; i < 12; i++) {
    petals += `<g transform="rotate(${i * 30})"><ellipse cx="0" cy="-13.5" rx="3.6" ry="6.2" fill="${i % 2 ? '#e84a8a' : '#ffb61e'}"/></g>`;
  }
  let dots = '';
  for (let i = 0; i < 16; i++) {
    const a = (i / 16) * Math.PI * 2;
    dots += `<circle cx="${(23 * Math.cos(a)).toFixed(1)}" cy="${(23 * Math.sin(a)).toFixed(1)}" r="1.7" fill="${i % 2 ? '#7ad1c0' : '#ff7a3c'}"/>`;
  }
  return `<g transform="translate(${x},${y}) scale(${s},${(s * 0.5).toFixed(2)})" opacity="0.95">
    <circle r="26" fill="rgba(255,182,30,.10)"/>
    <circle r="20" fill="none" stroke="#ff7a3c" stroke-width="1.6"/>
    ${petals}${dots}
    <circle r="6.5" fill="#e84a8a"/><circle r="3" fill="#ffb61e"/>
  </g>`;
}

/* ---- Diwali: festival of lights — fireworks, marigold garlands, a dome
        skyline, a floor rangoli and a row of flickering diyas ---- */
function diwaliScene() {
  let stars = '';
  for (let i = 0; i < 18; i++) {
    const x = rnd(10, 350), y = rnd(6, 84), r = rnd(0.8, 1.8), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const FW = [
    ['#ffb61e',  84,  52, 0.0],
    ['#ffffff', 178,  34, 1.4],
    ['#ff7a3c', 276,  58, 0.7],
    ['#e84a8a', 322, 116, 2.0],
    ['#ffb61e',  40, 118, 2.5],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*25).toFixed(1)}" y2="${(Math.sin(a)*25).toFixed(1)}" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*29).toFixed(1)}" cy="${(Math.sin(a)*29).toFixed(1)}" r="1.7" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  const garlands =
    marigoldSwag(-8, 8, 126, 2, 24, 0) +
    marigoldSwag(116, 0, 246, 8, 22, 0.9) +
    marigoldSwag(236, 6, 368, -2, 26, 1.7);

  // palace skyline silhouettes with lit windows
  const SKY = '#241245';
  const palace = (x, s) => `<g transform="translate(${x},192) scale(${s})">
    <g fill="${SKY}">
      <rect x="-20" y="-26" width="40" height="26"/>
      <path d="M0,-54 C 13,-46 15,-31 0,-25 C -15,-31 -13,-46 0,-54 Z"/>
      <line x1="0" y1="-54" x2="0" y2="-60" stroke="${SKY}" stroke-width="1.8"/>
      <rect x="-27" y="-34" width="5" height="34"/>
      <rect x="22" y="-34" width="5" height="34"/>
      <path d="M-24.5,-42 C -21,-38.5 -21,-35.5 -24.5,-34 C -28,-35.5 -28,-38.5 -24.5,-42 Z"/>
      <path d="M24.5,-42 C 28,-38.5 28,-35.5 24.5,-34 C 21,-35.5 21,-38.5 24.5,-42 Z"/>
    </g>
    <rect x="-12" y="-18" width="5.5" height="12" rx="2.7" fill="#ffb61e" opacity="0.95"/>
    <rect x="6.5" y="-18" width="5.5" height="12" rx="2.7" fill="#ffb61e" opacity="0.8"/>
  </g>`;

  let diyas = '';
  [[24, 1], [64, 0.82], [104, 1.02], [142, 0.8], [218, 0.8], [256, 1.02], [296, 0.82], [336, 1]].forEach(([x, s], i) => {
    diyas += diya(x, 203, s, (i * 0.16).toFixed(2));
  });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Diwali night with fireworks, marigold garlands, a rangoli and rows of lit diyas">
    <defs><linearGradient id="skyDw" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#150f33"/><stop offset="0.55" stop-color="#3a1c5c"/><stop offset="1" stop-color="#7a2e5c"/>
    </linearGradient></defs>
    <rect width="360" height="220" fill="url(#skyDw)"/>
    ${stars}
    ${bursts}
    ${palace(60, 1)}
    ${palace(302, 0.85)}
    <g fill="${SKY}" opacity="0.85"><rect x="112" y="176" width="26" height="16"/><rect x="232" y="178" width="22" height="14"/></g>
    ${garlands}
    <path d="M-10,196 Q 180,186 370,196 V 220 H -10 Z" fill="#1a0e33"/>
    <rect y="206" width="360" height="14" fill="#120a26"/>
    ${rangoli(180, 209, 0.9)}
    ${diyas}
  </svg>`;
}

/* ---- the India Gate silhouette ---- */
function indiaGate(x, y, s) {
  return `<g transform="translate(${x},${y}) scale(${s})" fill="#3d2244">
    <rect x="-36" y="28" width="72" height="7" rx="1"/>
    <rect x="-30" y="21" width="60" height="8"/>
    <path d="M-23,21 L-23,-20 Q-23,-28 -15,-28 L15,-28 Q23,-28 23,-20 L23,21 L13,21 L13,-8 Q13,-16 0,-16 Q-13,-16 -13,-8 L-13,21 Z"/>
    <rect x="-27" y="-35" width="54" height="8"/>
    <rect x="-19" y="-43" width="38" height="8"/>
    <path d="M-9,-43 L9,-43 L7,-50 L-7,-50 Z"/>
    <path d="M0,-58 C 5,-55 5.5,-51.5 0,-50 C -5.5,-51.5 -5,-55 0,-58 Z"/>
  </g>`;
}

/* ---- a paper fighter kite with a curling tail ---- */
function kite(x, y, s, c, delay, dur) {
  return `<g transform="translate(${x},${y}) scale(${s})"><g class="kite" style="animation-delay:${delay}s;animation-duration:${dur}s">
    <polygon points="0,-15 11,0 0,19 -11,0" fill="${c}"/>
    <polygon points="0,-15 11,0 0,19 -11,0" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="0.8"/>
    <line x1="0" y1="-15" x2="0" y2="19" stroke="rgba(255,255,255,.5)" stroke-width="0.8"/>
    <line x1="-11" y1="0" x2="11" y2="0" stroke="rgba(255,255,255,.5)" stroke-width="0.8"/>
    <path d="M0,19 C 6,28 -6,36 0,45 C 5,52 -3,58 1,64" stroke="${c}" stroke-width="1.4" fill="none" opacity="0.85" stroke-linecap="round"/>
  </g></g>`;
}

/* ---- Indian Independence Day: saffron dawn over India Gate, fighter
        kites aloft and the tricolour rippling on its pole ---- */
function indiaIndependenceScene() {
  // a distant V of birds crossing the dawn
  let birds = '';
  [[228,44],[244,40],[260,46],[122,60],[138,56]].forEach(([bx,by],i) => {
    birds += `<path class="twinkle" style="animation-delay:${(i*0.35).toFixed(2)}s" d="M${bx},${by} q4,-4 8,0 q4,-4 8,0" stroke="#6b3a2e" stroke-width="1.3" fill="none" stroke-linecap="round"/>`;
  });

  const kites =
    kite(256, 52, 1.0, '#f2721c', 0, 5.4) +
    kite(322, 96, 0.78, '#2fb457', -1.8, 6.4) +
    kite(226, 122, 0.62, '#e84a8a', -3.2, 5.8) +
    kite(126, 44, 0.7, '#2a7de1', -2.4, 6.0);

  // ---- the flag: 3:2 tricolour with the 24-spoke Ashoka Chakra ----
  const W = 150, H = 99, SH = 33;
  let cloth = `<rect width="${W}" height="${SH + 0.3}" fill="#FF9933"/><rect y="${SH}" width="${W}" height="${SH + 0.3}" fill="#ffffff"/><rect y="${2 * SH}" width="${W}" height="${SH}" fill="#138808"/>`;
  let chakra = `<circle cx="75" cy="49.5" r="12.4" fill="none" stroke="#06038D" stroke-width="1.7"/><circle cx="75" cy="49.5" r="2" fill="#06038D"/>`;
  for (let i = 0; i < 24; i++) {
    const a = i * 15 * Math.PI / 180;
    chakra += `<line x1="75" y1="49.5" x2="${(75 + 11.3 * Math.cos(a)).toFixed(2)}" y2="${(49.5 + 11.3 * Math.sin(a)).toFixed(2)}" stroke="#06038D" stroke-width="0.8"/>`;
  }
  cloth += chakra + `<rect width="${W}" height="${H}" fill="none" stroke="rgba(255,255,255,.3)" stroke-width="0.6"/>`;

  // slice into vertical strips so the cloth ripples; hoist edge stays pinned
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="incp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#incp${i})"><use href="#inflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Indian Independence Day — the tricolour waving at dawn with kites over India Gate">
    <defs>
      <linearGradient id="skyIn" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#2f4d7d"/><stop offset="0.5" stop-color="#b8674e"/><stop offset="0.8" stop-color="#e8935a"/><stop offset="1" stop-color="#f6c778"/>
      </linearGradient>
      <radialGradient id="sunIn" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#fff3c4" stop-opacity="0.95"/><stop offset="1" stop-color="#fff3c4" stop-opacity="0"/>
      </radialGradient>
      <g id="inflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyIn)"/>
    <circle class="glow" cx="294" cy="150" r="64" fill="url(#sunIn)"/>
    <circle cx="294" cy="152" r="13" fill="#ffe9b0" opacity="0.95"/>
    ${birds}
    ${kites}
    <path d="M-10,196 Q 180,184 370,196 V 220 H -10 Z" fill="#4a2a44" opacity="0.9"/>
    <path d="M-10,208 Q 180,196 370,208 V 220 H -10 Z" fill="#33193a"/>
    ${indiaGate(300, 164, 1.1)}
    <line x1="44" y1="212" x2="44" y2="10" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="8" r="3" fill="#FF9933"/>
    <g transform="translate(45,16)">${strips}</g>
  </svg>`;
}

/* ---- a hanging red lantern with gold caps, ribs and a tassel ---- */
function lanternCn(x, len, s, delay, fu) {
  const body = `
    <line x1="0" y1="${-len}" x2="0" y2="0" stroke="#f2b83c" stroke-width="1.2"/>
    <rect x="-5" y="0" width="10" height="4" rx="1.4" fill="#f6c700"/>
    <ellipse cx="0" cy="17" rx="14.5" ry="14" fill="#e03a2a"/>
    <ellipse cx="0" cy="17" rx="9.5" ry="14" fill="none" stroke="#b52519" stroke-width="1"/>
    <ellipse cx="0" cy="17" rx="4.5" ry="14" fill="none" stroke="#b52519" stroke-width="1"/>
    <ellipse cx="0" cy="17" rx="14.5" ry="14" fill="none" stroke="#8a1414" stroke-width="1.2"/>
    <ellipse cx="-5" cy="11" rx="3" ry="5" fill="rgba(255,220,150,.30)"/>
    <rect x="-4" y="29.5" width="8" height="3.6" rx="1.4" fill="#f6c700"/>
    <line x1="0" y1="33" x2="0" y2="38.5" stroke="#f6c700" stroke-width="1.1"/>
    <path d="M0,38.5 l3,3.4 l-3,3.4 l-3,-3.4 Z" fill="#f6c700"/>
    <path d="M-2,44.5 q-1.2,6 -0.2,9.5 M0,45.3 q0.5,6 0,10 M2,44.5 q1.2,6 0.2,9.5" stroke="#d8350f" stroke-width="1.2" fill="none" stroke-linecap="round"/>
    ${fu ? `<text x="0" y="22" text-anchor="middle" font-size="13" font-weight="700" fill="#f6c700" font-family="'Noto Sans SC','PingFang SC','Microsoft YaHei',sans-serif">\u798f</text>` : ''}`;
  return `<g transform="translate(${x},${len})"><g class="lanternSway" style="animation-delay:${delay}s"><g transform="scale(${s})">${body}</g></g></g>`;
}

/* ---- a hanging string of firecrackers ---- */
function firecrackerCn(x, delay) {
  let rows = '';
  for (let i = 0; i < 6; i++) {
    const side = i % 2 ? 1.5 : -8.5;
    rows += `<rect x="${side}" y="${8 + i * 8}" width="7" height="6" rx="1.2" fill="#d8350f" stroke="#8a1414" stroke-width="0.6"/>
      <line x1="${side + 1}" y1="${11 + i * 8}" x2="${side + 6}" y2="${11 + i * 8}" stroke="#f6c700" stroke-width="0.9"/>`;
  }
  return `<g transform="translate(${x},0)"><g class="lanternSway" style="animation-delay:${delay}s">
    <line x1="0" y1="0" x2="0" y2="${8 + 6 * 8}" stroke="#f2b83c" stroke-width="1"/>
    ${rows}
    <path d="M0,${9 + 6 * 8} l3.4,4 l-3.4,4 l-3.4,-4 Z" fill="#f6c700"/>
  </g></g>`;
}

/* ---- an auspicious cloud (xiangyun) drifting sideways ---- */
function cloudCn(x, y, s, o, dur, delay) {
  return `<g transform="translate(${x},${y})"><g class="drift" style="animation-duration:${dur}s;animation-delay:${delay}s"><g transform="scale(${s})" opacity="${o}">
    <g fill="#a02828">
      <circle cx="-14" cy="2" r="7"/><circle cx="0" cy="-2.5" r="10"/><circle cx="14" cy="2" r="7"/>
      <rect x="-19" y="3" width="38" height="6" rx="3"/>
    </g>
    <path d="M-15,3 a4.2,4.2 0 1 1 4.2,4.2 M-1,-3 a5.2,5.2 0 1 1 5.2,5.2" stroke="#c8564a" stroke-width="1.3" fill="none" stroke-linecap="round"/>
  </g></g></g>`;
}

/* ---- a tiered pagoda silhouette with upturned eaves ---- */
function pagodaCn(x, gy, s, c) {
  const roof = (w, y) => `<path d="M${-w - 7},${y} Q ${-w - 1},${y - 2.5} ${(-w * 0.62).toFixed(1)},${y - 6} Q 0,${y - 10.5} ${(w * 0.62).toFixed(1)},${y - 6} Q ${w + 1},${y - 2.5} ${w + 7},${y} Q 0,${y - 7.5} ${-w - 7},${y} Z" fill="${c}"/>`;
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <rect x="-20" y="-14" width="40" height="14" fill="${c}"/>
    <rect x="-8" y="-10" width="16" height="10" rx="1" fill="#f6c700" opacity="0.5"/>
    ${roof(30, -14)}
    <rect x="-15" y="-30" width="30" height="9" fill="${c}"/>
    ${roof(22, -30)}
    <line x1="0" y1="-38" x2="0" y2="-50" stroke="${c}" stroke-width="2"/>
    ${roof(13, -42)}
    <circle cx="0" cy="-51.5" r="2" fill="${c}"/>
  </g>`;
}

/* ---- the dragon dance: a golden dragon undulating across the sky,
        chasing its flaming pearl ---- */
function dragonCn() {
  const SEG = 14, GAP = 12.5;
  // tail plume first so the body paints over it
  let parts = `<g transform="translate(-9,0)"><g class="dragSeg" style="animation-delay:0.16s">
      <path d="M6,0 C -2,-6.5 -11,-4.5 -15,0 C -11,4.5 -2,6.5 6,0 Z" fill="#d8350f"/>
      <path d="M2,0 C -3,-3.5 -9,-2.5 -12,0 C -9,2.5 -3,3.5 2,0 Z" fill="#f6c700"/>
    </g></g>`;
  for (let i = 0; i < SEG; i++) {
    const x = i * GAP, t = i / (SEG - 1);
    const r = 3.6 + 5 * t;
    const fill = i % 2 ? '#e8a020' : '#f2b83c';
    const fin = r > 4.6 ? `<path d="M-3,${(-r + 1.5).toFixed(1)} Q 0,${(-r - 5).toFixed(1)} 3,${(-r + 1.5).toFixed(1)} Z" fill="#d8350f"/>` : '';
    parts += `<g transform="translate(${x},0)"><g class="dragSeg" style="animation-delay:${(-i * 0.16).toFixed(2)}s">
      ${fin}
      <circle r="${r.toFixed(1)}" fill="${fill}" stroke="#b5541f" stroke-width="0.8"/>
      <circle cy="${(r * 0.38).toFixed(1)}" r="${(r * 0.45).toFixed(1)}" fill="#f6dc9c" opacity="0.8"/>
    </g></g>`;
  }
  const hx = SEG * GAP + 4;
  const head = `<g transform="translate(${hx},0)"><g class="dragSeg" style="animation-delay:${(-SEG * 0.16).toFixed(2)}s">
    <path d="M-9,-6.5 C -17,-13 -21.5,-4.5 -15,0 C -21.5,4.5 -17,13 -9,6.5 Z" fill="#d8350f"/>
    <ellipse rx="10" ry="7.4" fill="#f2b83c" stroke="#b5541f" stroke-width="0.8"/>
    <path d="M8,-3.5 C 14,-4.5 17.5,-1.8 17.5,0.4 C 17.5,2.8 14,4.4 8,3.4 Z" fill="#e8a020"/>
    <circle cx="15.8" cy="-1.2" r="1" fill="#7a2e12"/>
    <path d="M8,3.4 C 12,6.4 15,7.4 17.5,7 C 15.5,9.6 10,9 7,6 Z" fill="#d8350f"/>
    <path d="M-3,-6 C -5,-13 -2,-17 3,-18 M2,-6.5 C 1,-12 4,-16 8,-16.5" stroke="#e8dcc0" stroke-width="2" fill="none" stroke-linecap="round"/>
    <circle cx="3" cy="-2.6" r="2.3" fill="#fff"/><circle cx="3.9" cy="-2.6" r="1.2" fill="#1a1a1a"/>
    <path d="M13,1.2 C 20,0.5 23,4.5 21,8.5 M13,-2.4 C 21,-4.5 25,-1.5 24,2.5" stroke="#f6c700" stroke-width="1.1" fill="none" stroke-linecap="round"/>
  </g></g>`;
  const pearl = `<g transform="translate(${hx + 31},-5)"><g class="dragSeg" style="animation-delay:${(-(SEG + 2) * 0.16).toFixed(2)}s">
    <circle class="glow" r="8" fill="rgba(246,199,0,.30)"/>
    <circle r="4.2" fill="#ffe9a0" stroke="#e8a020" stroke-width="1"/>
    <path d="M-5.5,-3 q-3,3 -1.5,7 M5.5,-3 q3,3 1.5,7" stroke="#f6c700" stroke-width="1" fill="none" stroke-linecap="round" opacity="0.7"/>
  </g></g>`;
  return `<g class="dragonCross"><g transform="translate(0,104)">${parts}${head}${pearl}</g></g>`;
}

/* ---- Chinese New Year: a red-and-gold night — the dragon dance chasing
        its pearl through auspicious clouds, swaying lanterns, firecrackers,
        plum-blossom petals and pagoda rooftops ---- */
function chineseNewYearScene() {
  let stars = '';
  for (let i = 0; i < 16; i++) {
    const x = rnd(10, 350), y = rnd(6, 82), r = rnd(0.8, 1.8), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${i % 3 ? '#f6c700' : '#fff'}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const FW = [
    ['#f6c700', 138,  34, 0.0],
    ['#ffffff', 226,  40, 1.4],
    ['#ff9a3c', 330, 110, 0.7],
    ['#f6c700',  36, 118, 2.0],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*24).toFixed(1)}" y2="${(Math.sin(a)*24).toFixed(1)}" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*28).toFixed(1)}" cy="${(Math.sin(a)*28).toFixed(1)}" r="1.7" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  // plum-blossom petals drifting down
  let petals = '';
  for (let i = 0; i < 10; i++) {
    const x = rnd(10, 350), s = rnd(0.8, 1.3), dur = rnd(5, 9), delay = -rnd(0, dur);
    petals += `<g transform="translate(${x.toFixed(1)},0) scale(${s.toFixed(2)})"><g class="leaf" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s">
      <path d="M0,-4.2 C 3.2,-2.2 3.2,2.2 0,4.2 C -3.2,2.2 -3.2,-2.2 0,-4.2 Z" fill="${i % 2 ? '#f2a0b4' : '#e87a94'}"/>
    </g></g>`;
  }

  const clouds =
    cloudCn(118, 76, 1.0, 0.8, 8, 0) +
    cloudCn(252, 62, 0.8, 0.7, 9, -3.5) +
    cloudCn(56, 136, 0.9, 0.75, 10, -6) +
    cloudCn(306, 148, 1.05, 0.8, 8.5, -2);

  const hangings =
    lanternCn(30, 10, 1.15, 0, true) +
    lanternCn(66, 4, 0.8, -1.2, false) +
    lanternCn(296, 4, 0.8, -0.6, false) +
    lanternCn(332, 10, 1.15, -1.8, true) +
    firecrackerCn(104, -0.9) +
    firecrackerCn(258, -2.1);

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Chinese New Year — a golden dragon dance among lanterns, firecrackers and plum blossoms">
    <defs><linearGradient id="skyCny" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#2e0810"/><stop offset="0.55" stop-color="#6b1418"/><stop offset="1" stop-color="#9c2418"/>
    </linearGradient></defs>
    <rect width="360" height="220" fill="url(#skyCny)"/>
    ${stars}
    ${bursts}
    ${clouds}
    ${dragonCn()}
    <path d="M-10,206 Q 180,198 370,206 V 220 H -10 Z" fill="#2a070c"/>
    <rect y="212" width="360" height="8" fill="#1e0508"/>
    ${pagodaCn(62, 214, 1.0, '#3a0a10')}
    ${pagodaCn(210, 216, 0.7, '#33090e')}
    ${pagodaCn(315, 215, 0.88, '#3a0a10')}
    ${hangings}
    ${petals}
  </svg>`;
}

/* ---- the Oriental Pearl Tower silhouette ---- */
function pearlTowerCn(x, gy, s, c) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <g fill="${c}">
      <rect x="-1.4" y="-116" width="2.8" height="15"/>
      <circle cy="-94" r="8"/>
      <rect x="-2.4" y="-87" width="4.8" height="20"/>
      <circle cy="-55" r="13"/>
      <rect x="-3" y="-44" width="6" height="44"/>
      <path d="M-4,-46 L-17,0 L-12,0 L-2,-42 Z"/>
      <path d="M4,-46 L17,0 L12,0 L2,-42 Z"/>
      <circle cy="-9" r="6"/>
    </g>
    <circle cy="-94" r="2.4" fill="#ffde3c" opacity="0.9"/>
    <circle cy="-55" r="3.4" fill="#ff7a4a" opacity="0.9"/>
  </g>`;
}

/* ---- National Day / Golden Week: the five-star red flag rippling over
        a lit-up Pudong skyline, with doves, lanterns and gold confetti ---- */
function chinaNationalScene() {
  let stars = '';
  for (let i = 0; i < 18; i++) {
    const x = rnd(10, 350), y = rnd(6, 120), r = rnd(0.8, 1.8), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const FW = [
    ['#ffde3c', 252,  40, 0.0],
    ['#ffffff', 316,  96, 0.6],
    ['#ef4123', 226,  70, 1.2],
    ['#ffde3c', 296, 150, 1.8],
    ['#ff9a3c', 150,  30, 2.2],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*26).toFixed(1)}" y2="${(Math.sin(a)*26).toFixed(1)}" stroke="${c}" stroke-width="1.7" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*30).toFixed(1)}" cy="${(Math.sin(a)*30).toFixed(1)}" r="1.8" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  // doves released over the city
  let doves = '';
  [[196, 60], [216, 52], [238, 62], [136, 84], [158, 78]].forEach(([bx, by], i) => {
    doves += `<path class="twinkle" style="animation-delay:${(i * 0.35).toFixed(2)}s" d="M${bx},${by} q5,-5 10,0 q5,-5 10,0" stroke="#e8eef6" stroke-width="1.5" fill="none" stroke-linecap="round"/>`;
  });

  // ---- the flag: 3:2, five gold stars — small stars point at the big one ----
  const W = 150, H = 100, U = 5;
  const star5 = (cx, cy, r, rot) => {
    let p = '';
    for (let k = 0; k < 10; k++) {
      const a = (rot + k * 36) * Math.PI / 180, rr = k % 2 ? r * 0.42 : r;
      p += `${(cx + rr * Math.cos(a)).toFixed(2)},${(cy + rr * Math.sin(a)).toFixed(2)} `;
    }
    return `<polygon points="${p.trim()}" fill="#FFDE00"/>`;
  };
  const BX = 5 * U, BY = 5 * U;
  let cloth = `<rect width="${W}" height="${H}" fill="#DE2910"/>`;
  cloth += star5(BX, BY, 3 * U, -90);
  [[10 * U, 2 * U], [12 * U, 4 * U], [12 * U, 7 * U], [10 * U, 9 * U]].forEach(([sx, sy]) => {
    const rot = Math.atan2(BY - sy, BX - sx) * 180 / Math.PI;
    cloth += star5(sx, sy, U, rot);
  });
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(255,255,255,.25)" stroke-width="0.6"/>`;

  // slice into vertical strips so the cloth ripples; hoist edge stays pinned
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="cncp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#cncp${i})"><use href="#cnflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  // Pudong-style skyline with lit gold windows
  const SKY = '#0c1c33';
  const building = (x, top, w) => {
    let win = '';
    const cols = Math.max(1, Math.floor((w - 6) / 8));
    const rows = Math.max(1, Math.floor((224 - top - 8) / 11));
    for (let c = 0; c < cols; c++) for (let r = 0; r < rows; r++) {
      if (Math.random() < 0.5) {
        win += `<rect x="${(x + 5 + c * 8).toFixed(1)}" y="${(top + 7 + r * 11).toFixed(1)}" width="2.6" height="3.6" fill="${Math.random() < 0.85 ? '#ffde3c' : '#fff2c2'}" opacity="${rnd(0.45, 1).toFixed(2)}"/>`;
      }
    }
    return `<rect x="${x}" y="${top}" width="${w}" height="${224 - top}" fill="${SKY}"/>${win}`;
  };
  const buildings = [[86, 168, 26], [118, 152, 30], [154, 176, 22], [206, 160, 28], [240, 174, 22], [340, 164, 26]]
    .map((b) => building(...b)).join('');

  // gold + red confetti drifting down in the foreground
  let confetti = '';
  for (let i = 0; i < 14; i++) {
    const x = rnd(12, 348), c = i % 3 === 2 ? '#ef4123' : '#ffde3c';
    const dur = rnd(3.8, 6.5), delay = -rnd(0, dur), w = rnd(4, 6.5);
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="${(-w / 2).toFixed(1)}" y="-2" width="${w.toFixed(1)}" height="4" rx="1" fill="${c}"/></g></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Chinese National Day — the five-star red flag waving over a lit skyline with fireworks">
    <defs>
      <linearGradient id="skyCnN" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#0a1428"/><stop offset="0.6" stop-color="#182a4a"/><stop offset="1" stop-color="#3a2038"/>
      </linearGradient>
      <g id="cnflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyCnN)"/>
    ${stars}
    ${bursts}
    ${doves}
    ${buildings}
    ${pearlTowerCn(310, 224, 1.0, SKY)}
    <path d="M-10,206 Q 180,200 370,206 V 220 H -10 Z" fill="#081120"/>
    <g stroke="#ffde3c" stroke-width="1.2" opacity="0.35" stroke-linecap="round">
      <line x1="120" y1="212" x2="132" y2="212"/><line x1="228" y1="215" x2="242" y2="215"/><line x1="300" y1="211" x2="312" y2="211"/>
    </g>
    ${lanternCn(322, 4, 0.72, -0.8, false)}
    ${lanternCn(348, 8, 0.6, -2.2, false)}
    <line x1="44" y1="212" x2="44" y2="10" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="8" r="3" fill="#FFDE00"/>
    <g transform="translate(45,16)">${strips}</g>
    ${confetti}
  </svg>`;
}

/* ---- National Day: the Singapore flag rippling over the Marina Bay skyline
        (Marina Bay Sands, ArtScience Museum) with red, white and gold fireworks ---- */
function singaporeScene() {
  let stars = '';
  for (let i = 0; i < 16; i++) {
    const x = rnd(10, 350), y = rnd(6, 100), r = rnd(0.7, 1.6), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const FW = [
    ['#ffffff', 250,  38, 0.0],
    ['#ED2939', 314,  92, 0.7],
    ['#ffffff', 176,  30, 1.4],
    ['#ED2939', 292, 148, 2.0],
    ['#ffde3c', 140,  58, 2.5],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a)*7).toFixed(1)}" y1="${(Math.sin(a)*7).toFixed(1)}" x2="${(Math.cos(a)*26).toFixed(1)}" y2="${(Math.sin(a)*26).toFixed(1)}" stroke="${c}" stroke-width="1.7" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a)*30).toFixed(1)}" cy="${(Math.sin(a)*30).toFixed(1)}" r="1.8" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  // ---- the flag: 3:2, red over white, crescent + five stars on the red half ----
  const W = 150, H = 100, U = 5;
  const star5 = (cx, cy, r, rot) => {
    let p = '';
    for (let k = 0; k < 10; k++) {
      const a = (rot + k * 36) * Math.PI / 180, rr = k % 2 ? r * 0.42 : r;
      p += `${(cx + rr * Math.cos(a)).toFixed(2)},${(cy + rr * Math.sin(a)).toFixed(2)} `;
    }
    return `<polygon points="${p.trim()}" fill="#fff"/>`;
  };
  let cloth = `<rect width="${W}" height="${H / 2}" fill="#ED2939"/><rect y="${H / 2}" width="${W}" height="${H / 2}" fill="#fff"/>`;
  cloth += `<circle cx="${7.6 * U}" cy="${5 * U}" r="${3.3 * U}" fill="#fff"/><circle cx="${9.2 * U}" cy="${5 * U}" r="${2.85 * U}" fill="#ED2939"/>`;
  [-90, -18, 54, 126, 198].forEach((a) => {
    const rad = a * Math.PI / 180, R = 2.9 * U, ccx = 14.4 * U + R * Math.cos(rad), ccy = 5 * U + R * Math.sin(rad);
    cloth += star5(ccx, ccy, U, a);
  });
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.18)" stroke-width="0.6"/>`;

  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="sgcp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#sgcp${i})"><use href="#sgflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  // skyline: generic lit towers, Marina Bay Sands and the ArtScience lotus
  const SKY = '#0c1c33';
  const building = (x, top, w) => {
    let win = '';
    const cols = Math.max(1, Math.floor((w - 6) / 8));
    const rows = Math.max(1, Math.floor((224 - top - 8) / 11));
    for (let c = 0; c < cols; c++) for (let r = 0; r < rows; r++) {
      if (Math.random() < 0.5) {
        win += `<rect x="${(x + 5 + c * 8).toFixed(1)}" y="${(top + 7 + r * 11).toFixed(1)}" width="2.6" height="3.6" fill="${Math.random() < 0.85 ? '#ffde3c' : '#fff2c2'}" opacity="${rnd(0.45, 1).toFixed(2)}"/>`;
      }
    }
    return `<rect x="${x}" y="${top}" width="${w}" height="${224 - top}" fill="${SKY}"/>${win}`;
  };
  const buildings = [[60, 172, 22], [246, 158, 24], [278, 176, 20], [326, 162, 26]]
    .map((b) => building(...b)).join('');

  const mbsCn = (x, gy, s, c) => `<g transform="translate(${x},${gy}) scale(${s})"><g fill="${c}">
    <rect x="-30" y="-86" width="11" height="86"/>
    <rect x="-6.5" y="-100" width="11" height="100"/>
    <rect x="17" y="-82" width="11" height="82"/>
    <path d="M-33,-92 Q-8,-110 26,-88 L26,-79 Q-8,-99 -33,-83 Z"/>
  </g>
    <circle cx="-24.5" cy="-86" r="1.6" fill="#ffde3c" opacity="0.85"/>
    <circle cx="-1" cy="-100" r="1.6" fill="#ffde3c" opacity="0.85"/>
    <circle cx="22.5" cy="-82" r="1.6" fill="#ffde3c" opacity="0.85"/>
  </g>`;

  const artScienceCn = (x, gy, s, c) => `<g transform="translate(${x},${gy}) scale(${s})">
    <path d="M0,0 C-16,-2 -20,-16 -12,-24 C-6,-30 6,-30 12,-24 C20,-16 16,-2 0,0 Z" fill="${c}"/>
    <path d="M0,-2 C-4,-10 -3,-18 0,-24 C3,-18 4,-10 0,-2 Z" fill="${c}" opacity="0.55"/>
  </g>`;

  // Gardens by the Bay — a small Supertree Grove, lit up at night
  const supertreeCn = (x, gy, s, h, c, lit) => {
    let lights = '';
    for (let i = 0; i < 6; i++) {
      const a = rnd(0, Math.PI * 2), r = rnd(6, 12.5);
      lights += `<circle class="twinkle" cx="${(Math.cos(a) * r).toFixed(1)}" cy="${(-h + 4 + Math.sin(a) * r * 0.38).toFixed(1)}" r="0.9" fill="${lit}" style="animation-delay:${rnd(0, 2).toFixed(2)}s"/>`;
    }
    return `<g transform="translate(${x},${gy}) scale(${s})">
      <rect x="-1.8" y="${-h}" width="3.6" height="${h}" fill="${c}"/>
      <path d="M-13,${4 - h} C-13,${-4 - h} 13,${-4 - h} 13,${4 - h} C13,${8 - h} 7,${10 - h} 0,${10 - h} C-7,${10 - h} -13,${8 - h} -13,${4 - h} Z" fill="${c}"/>
      ${lights}
    </g>`;
  };

  // the Merlion, spouting water into the bay
  const merlionCn = (x, gy, s, c) => `<g transform="translate(${x},${gy}) scale(${s})">
    <rect x="-5" y="-2" width="10" height="4" fill="${c}"/>
    <path d="M-6,-2 C-6,-10 -2,-15 4,-15 C8,-15 10,-12 8,-9 C11,-9 12,-6 9,-4 C7,-2 2,-2 -1,-3 C-3,-2.4 -5,-2 -6,-2 Z" fill="${c}"/>
    <circle cx="2" cy="-19" r="5.2" fill="${c}"/>
    <g fill="${c}"><polygon points="-2.6,-22.5 -1.2,-25.5 0.4,-22.7"/><polygon points="0.6,-23.8 2,-27 3.6,-23.4"/><polygon points="3.6,-23 5,-25.8 6.2,-22.2"/></g>
    <circle cx="6.4" cy="-18.6" r="1.1" fill="${c}"/>
    <path d="M7.2,-19.4 C13,-18 16,-13 15,-6" stroke="#dfe9f5" stroke-width="1.3" fill="none" stroke-linecap="round" opacity="0.85"/>
    <circle class="twinkle" cx="15.6" cy="-6" r="1" fill="#eaf3ff" style="animation-delay:0.4s"/>
    <circle class="twinkle" cx="12.5" cy="-11.5" r="0.8" fill="#eaf3ff" style="animation-delay:1s"/>
  </g>`;

  // Vanda Miss Joaquim — Singapore's national orchid, tucked into the foreground
  const orchidCn = (x, gy, s) => `<g transform="translate(${x},${gy}) scale(${s})">
    <g fill="#c04a86">
      <ellipse cx="0" cy="-6" rx="3.2" ry="1.8"/>
      <ellipse cx="-3" cy="-3" rx="3.2" ry="1.8" transform="rotate(-45 -3 -3)"/>
      <ellipse cx="3" cy="-3" rx="3.2" ry="1.8" transform="rotate(45 3 -3)"/>
      <ellipse cx="-2" cy="0.5" rx="3" ry="1.6" transform="rotate(-100 -2 0.5)"/>
      <ellipse cx="2" cy="0.5" rx="3" ry="1.6" transform="rotate(100 2 0.5)"/>
    </g>
    <circle cx="0" cy="-2" r="1.4" fill="#f4c94a"/>
  </g>`;

  // gentle red & white confetti drifting in the foreground
  let confetti = '';
  for (let i = 0; i < 12; i++) {
    const x = rnd(12, 348), c = i % 2 === 0 ? '#ED2939' : '#ffffff';
    const dur = rnd(3.8, 6.5), delay = -rnd(0, dur), w = rnd(4, 6.5);
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="${(-w / 2).toFixed(1)}" y="-2" width="${w.toFixed(1)}" height="4" rx="1" fill="${c}"/></g></g>`;
  }

  // bay water catching light from the skyline
  let ripples = '';
  [[40, 213, 30], [110, 217, 26], [190, 212, 34], [260, 216, 24], [320, 213, 28]].forEach(([x, y, w], i) => {
    ripples += `<line class="twinkle" x1="${x}" y1="${y}" x2="${x + w}" y2="${y}" stroke="#ffde3c" stroke-width="1" opacity="0.3" style="animation-delay:${(i * 0.4).toFixed(2)}s"/>`;
  });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Singapore National Day — the Singapore flag waving over the Marina Bay skyline with fireworks">
    <defs>
      <linearGradient id="skySg" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#0a1428"/><stop offset="0.6" stop-color="#182a4a"/><stop offset="1" stop-color="#3a1e3a"/>
      </linearGradient>
      <g id="sgflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skySg)"/>
    ${stars}
    ${bursts}
    ${buildings}
    ${supertreeCn(300, 224, 0.85, 40, SKY, '#ffb35c')}
    ${supertreeCn(318, 224, 1.05, 52, SKY, '#ffde3c')}
    ${supertreeCn(340, 224, 0.7, 32, SKY, '#ff9a6a')}
    ${artScienceCn(150, 224, 1.05, SKY)}
    ${mbsCn(232, 224, 1.0, SKY)}
    <path d="M-10,206 Q 180,200 370,206 V 220 H -10 Z" fill="#081120"/>
    ${ripples}
    ${merlionCn(191, 214, 0.9, '#e7ebf0')}
    ${orchidCn(26, 219, 0.85)}
    ${orchidCn(336, 219, 0.75)}
    <line x1="44" y1="212" x2="44" y2="10" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="8" r="3" fill="#ffde3c"/>
    <g transform="translate(45,16)">${strips}</g>
    ${confetti}
  </svg>`;
}

/* ---- the Hungarian Parliament (Orsz\u00e1gh\u00e1z): symmetric neo-Gothic
        river fa\u00e7ade, twin spired pavilions, a serrated pinnacle roofline
        and the great central dome, all lit gold ---- */
function parliament(cx, gy, s, pal) {
  pal = pal || {};
  const STONE = pal.stone || '#16294c', DARK = pal.dark || '#0b1830', GW = pal.win || '#f6c700',
        FIN = pal.finial || '#f6c700', BASE = pal.base || '#0b1830', BAND = pal.band || '#f6c700';
  const winRow = (x0, x1, y, n, w, h) => {
    let o = ''; const step = (x1 - x0) / n;
    for (let i = 0; i < n; i++) {
      const x = x0 + step * i + step / 2 - w / 2, op = rnd(0.5, 1).toFixed(2);
      o += `<rect x="${x.toFixed(1)}" y="${y.toFixed(1)}" width="${w}" height="${h}" fill="${GW}" opacity="${op}"/>`;
      o += `<path d="M${x.toFixed(1)},${y.toFixed(1)} q${(w / 2).toFixed(1)},${(-w).toFixed(1)} ${w},0 Z" fill="${GW}" opacity="${op}"/>`;
    }
    return o;
  };
  const spire = (x, baseY, h, w) => `<path d="M${x - w},${baseY} L${x + w},${baseY} L${x},${baseY - h} Z" fill="${STONE}"/><circle cx="${x}" cy="${baseY - h - 1.5}" r="1.3" fill="${FIN}"/>`;
  let pins = '';
  for (let x = -90; x <= 90; x += 7.5) pins += `<path d="M${(x - 2).toFixed(1)},-50 L${(x + 2).toFixed(1)},-50 L${x.toFixed(1)},-58 Z" fill="${STONE}"/>`;
  const dome = `
    <rect x="-26" y="-72" width="52" height="6" fill="${STONE}"/>
    <rect x="-16" y="-84" width="32" height="12" fill="${STONE}"/>
    <path d="M-19,-84 C -19,-106 -8,-120 0,-123 C 8,-120 19,-106 19,-84 Z" fill="${STONE}"/>
    <path d="M-12,-86 C -12,-104 -6,-114 0,-117" stroke="${DARK}" stroke-width="0.8" fill="none"/>
    <path d="M12,-86 C 12,-104 6,-114 0,-117" stroke="${DARK}" stroke-width="0.8" fill="none"/>
    <line x1="0" y1="-86" x2="0" y2="-120" stroke="${DARK}" stroke-width="0.8"/>
    <rect x="-9" y="-72" width="18" height="6" fill="${BAND}" opacity="0.85"/>
    <rect x="-3.5" y="-133" width="7" height="10" fill="${STONE}"/>
    <line x1="0" y1="-133" x2="0" y2="-143" stroke="${STONE}" stroke-width="2"/>
    <circle cx="0" cy="-144" r="2" fill="${FIN}"/>`;
  return `<g transform="translate(${cx},${gy}) scale(${s})">
    <rect x="-100" y="-8" width="200" height="14" fill="${BASE}"/>
    <rect x="-94" y="-50" width="188" height="42" fill="${STONE}"/>
    ${pins}
    <rect x="-96" y="-62" width="24" height="54" fill="${STONE}"/>
    <rect x="72" y="-62" width="24" height="54" fill="${STONE}"/>
    ${spire(-84, -62, 16, 4)} ${spire(84, -62, 16, 4)}
    <rect x="-28" y="-72" width="56" height="64" fill="${STONE}"/>
    ${dome}
    ${winRow(-94, -72, -40, 3, 4.5, 11)}
    ${winRow(72, 94, -40, 3, 4.5, 11)}
    ${winRow(-26, 26, -46, 3, 5.5, 15)}
    ${winRow(-72, -28, -40, 5, 4, 11)}
    ${winRow(28, 72, -40, 5, 4, 11)}
    ${winRow(-90, 90, -20, 20, 2.6, 7)}
  </g>`;
}

/* ---- the Sz\u00e9chenyi Chain Bridge (L\u00e1nch\u00edd): two triumphal-arch pylons,
        the sweeping main cable and a lamp-lit deck over the Danube ---- */
function chainBridge(cx, gy, s) {
  const DK = '#0c1c34', GW = '#f6c700';
  const pylon = (px) => `
    <rect x="${px - 7}" y="-34" width="14" height="34" fill="${DK}"/>
    <rect x="${px - 8}" y="-38" width="16" height="5" fill="${DK}"/>
    <rect x="${px - 2.5}" y="-30" width="5" height="11" rx="2.5" fill="${GW}" opacity="0.5"/>
    <circle cx="${px}" cy="-40" r="1.4" fill="${GW}"/>`;
  const cable = `<path d="M-60,-4 Q -45,-30 -30,-34 Q -15,-38 0,-14 Q 15,-38 30,-34 Q 45,-30 60,-4" stroke="${DK}" stroke-width="1.8" fill="none"/>`;
  const hpts = [[-24, -20], [-16, -24], [-8, -17], [0, -14], [8, -17], [16, -24], [24, -20]];
  const hang = hpts.map(([hx, ty]) => `<line x1="${hx}" y1="0" x2="${hx}" y2="${ty}" stroke="${DK}" stroke-width="0.7"/>`).join('');
  let lights = '';
  for (let x = -58; x <= 58; x += 10) lights += `<circle cx="${x}" cy="-3" r="1" fill="${GW}" opacity="0.7"/>`;
  return `<g transform="translate(${cx},${gy}) scale(${s})" opacity="0.94">
    ${cable}${hang}
    <rect x="-62" y="-1.5" width="124" height="3" fill="${DK}"/>
    ${pylon(-30)}${pylon(30)}${lights}
  </g>`;
}

/* ---- the Holy Crown of Hungary (Szent Korona): the gold circlet, closed
        arches, jewelled band and the famously bent surmounting cross ---- */
function holyCrown(x, y, s) {
  const G1 = '#f6c700', G2 = '#d9a400', EN = '#1e4164';
  let jewels = ''; const jc = ['#CD2A3E', '#3f8f57', '#2a7de1', '#CD2A3E', '#3f8f57'];
  for (let i = 0; i < 5; i++) jewels += `<circle cx="${-16 + i * 8}" cy="2" r="1.5" fill="${jc[i]}"/>`;
  return `<g transform="translate(${x},${y}) scale(${s})">
    <circle class="glow" r="30" fill="url(#crownGlow)"/>
    <path d="M-20,7 Q0,13 20,7 L20,-3 Q0,3 -20,-3 Z" fill="${G1}"/>
    <path d="M-20,-3 Q0,3 20,-3" stroke="${G2}" stroke-width="0.8" fill="none"/>
    <path d="M-14,-1 l0,-5 M-7,1 l0,-6 M0,2 l0,-6 M7,1 l0,-6 M14,-1 l0,-5" stroke="${G1}" stroke-width="1.4" stroke-linecap="round"/>
    ${jewels}
    <path d="M-19,-1 Q0,-30 19,-1" stroke="${G1}" stroke-width="3.4" fill="none"/>
    <path d="M-11,0 Q0,-24 11,0" stroke="${G2}" stroke-width="2.6" fill="none"/>
    <circle cx="0" cy="-24" r="3.2" fill="${G1}"/>
    <g transform="translate(0,-27) rotate(17)">
      <rect x="-1.4" y="-11" width="2.8" height="12" rx="0.6" fill="${G1}"/>
      <rect x="-5" y="-7.4" width="10" height="2.8" rx="0.6" fill="${G1}"/>
    </g>
    <rect x="-5.5" y="-3.5" width="11" height="9" rx="1.6" fill="${EN}" stroke="${G1}" stroke-width="0.9"/>
    <circle cx="0" cy="1" r="2" fill="#CD2A3E"/>
    <line x1="-20" y1="6" x2="-22" y2="15" stroke="${G1}" stroke-width="1"/><circle cx="-22" cy="16.5" r="1.6" fill="#CD2A3E"/>
    <line x1="20" y1="6" x2="22" y2="15" stroke="${G1}" stroke-width="1"/><circle cx="22" cy="16.5" r="1.6" fill="#3f8f57"/>
  </g>`;
}

/* ---- St. Stephen's / State Foundation Day (Aug 20): Budapest's famous
        fireworks over the Danube \u2014 the Parliament and Chain Bridge lit gold,
        the Holy Crown glowing above, and the tricolour rippling on its pole ---- */
function hungaryFoundationScene() {
  const RED = '#CD2A3E', GRN = '#43704d', GOLD = '#f6c700';
  const FW = [
    [RED,       96,  44, 0.0],
    ['#ffffff', 156, 30, 0.7],
    [GRN,       248, 54, 1.2],
    [GOLD,      302, 38, 1.8],
    [RED,       206, 86, 2.3],
  ];
  const N = 16;
  const bursts = FW.map(([c, cx, cy, dl]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a) * 8).toFixed(1)}" y1="${(Math.sin(a) * 8).toFixed(1)}" x2="${(Math.cos(a) * 27).toFixed(1)}" y2="${(Math.sin(a) * 27).toFixed(1)}" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a) * 31).toFixed(1)}" cy="${(Math.sin(a) * 31).toFixed(1)}" r="1.7" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${dl}s"><circle r="3" fill="#fff"/>${rays}</g></g>`;
  }).join('');

  let stars = '';
  for (let i = 0; i < 24; i++) {
    const x = rnd(10, 350), y = rnd(8, 104), r = rnd(1, 2.1), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // shimmering reflections on the Danube
  let refl = ''; const rc = [GOLD, '#fff2c2', GOLD, '#ffd98a', '#ffe7a0'];
  for (let i = 0; i < 18; i++) {
    const x = rnd(24, 336), w = rnd(2, 5), h = rnd(8, 26), d = rnd(0, 2.4), o = rnd(0.22, 0.55);
    refl += `<rect class="twinkle" x="${x.toFixed(1)}" y="189" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="${rc[i % rc.length]}" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // tricolour cloth, sliced into rippling strips
  const W = 150, H = 100, SH = 100 / 3;
  let cloth = `<rect width="${W}" height="${(SH + 0.3).toFixed(2)}" fill="${RED}"/><rect y="${SH.toFixed(2)}" width="${W}" height="${(SH + 0.3).toFixed(2)}" fill="#ffffff"/><rect y="${(2 * SH).toFixed(2)}" width="${W}" height="${SH.toFixed(2)}" fill="${GRN}"/>`;
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(255,255,255,.28)" stroke-width="0.6"/>`;
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="hu20cp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#hu20cp${i})"><use href="#hu20flagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="St. Stephen's Day \u2014 fireworks over the Hungarian Parliament on the Danube, the Holy Crown glowing above, and the tricolour flag">
    <defs>
      <linearGradient id="skyHu20" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#0d1a34"/><stop offset="0.55" stop-color="#1b2e51"/><stop offset="0.82" stop-color="#3a3358"/><stop offset="1" stop-color="#5a3a52"/>
      </linearGradient>
      <linearGradient id="danube" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#15253f"/><stop offset="1" stop-color="#0a1526"/>
      </linearGradient>
      <radialGradient id="crownGlow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#fff0b8" stop-opacity="0.9"/><stop offset="1" stop-color="#fff0b8" stop-opacity="0"/>
      </radialGradient>
      <g id="hu20flagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyHu20)"/>
    ${stars}
    ${holyCrown(150, 46, 1)}
    ${bursts}
    ${chainBridge(302, 189, 0.9)}
    ${parliament(196, 214, 0.82)}
    <rect y="186" width="360" height="40" fill="url(#danube)"/>
    ${refl}
    <line x1="44" y1="214" x2="44" y2="12" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="10" r="3" fill="${GOLD}"/>
    <g transform="translate(45,18)">${strips}</g>
  </svg>`;
}

/* ---- a Hungarian tricolour ribbon tail with a swallowtail notch ---- */
function tricolourTail(rot) {
  const strip = (dx, c) => `<path d="M${dx},0 h4 v28 l-2,-5 l-2,5 Z" fill="${c}"/>`;
  return `<g transform="rotate(${rot})">${strip(-6, '#CD2A3E')}${strip(-2, '#ffffff')}${strip(2, '#43704d')}</g>`;
}

/* ---- the kok\u00e1rda: the pleated red-white-green cockade worn on March 15,
        with a gold centre button and hanging tricolour ribbons ---- */
function kokarda(x, y, s, delay) {
  const RED = '#CD2A3E', GRN = '#43704d', R = 20;
  let pleats = ''; const P = 30;
  for (let i = 0; i < P; i++) {
    const a = (i / P) * Math.PI * 2;
    pleats += `<line x1="0" y1="0" x2="${(R * Math.cos(a)).toFixed(1)}" y2="${(R * Math.sin(a)).toFixed(1)}" stroke="rgba(20,20,20,.14)" stroke-width="0.7"/>`;
  }
  const rosette = `
    <circle r="${R}" fill="${RED}"/>
    <circle r="${(R * 0.66).toFixed(1)}" fill="#ffffff"/>
    <circle r="${(R * 0.36).toFixed(1)}" fill="${GRN}"/>
    ${pleats}
    <circle r="${(R * 0.13).toFixed(1)}" fill="#43704d"/>
    <circle r="${(R * 0.13).toFixed(1)}" fill="none" stroke="#2f5138" stroke-width="0.7"/>
    <path d="M${(-R * 0.7).toFixed(1)},${(-R * 0.4).toFixed(1)} A ${R},${R} 0 0 1 ${(R * 0.4).toFixed(1)},${(-R * 0.7).toFixed(1)}" stroke="rgba(255,255,255,.35)" stroke-width="1.4" fill="none"/>`;
  return `<g transform="translate(${x},${y}) scale(${s})"><g class="cockade" style="animation-delay:${delay}s">
    <g transform="translate(0,${(R - 5).toFixed(1)})">${tricolourTail(-15)}${tricolourTail(15)}</g>
    ${rosette}
  </g></g>`;
}

/* ---- a gliding white dove with an olive sprig ---- */
function dove(x, y, s, delay) {
  return `<g transform="translate(${x},${y}) scale(${s})"><g class="dove" style="animation-duration:${rnd(4.6, 6.2).toFixed(1)}s;animation-delay:${delay}s">
    <path d="M-10,2 C -4,-3 6,-3 12,-1 C 16,0 18,2 15,4 C 10,7 0,7 -6,5 Z" fill="#fdfdff"/>
    <path d="M-10,2 L-18,-1 L-16,3 L-19,6 L-10,5 Z" fill="#eef1f6"/>
    <circle cx="13" cy="-2" r="3.1" fill="#fdfdff"/>
    <path d="M16,-2.4 l4.4,1 l-4.2,1.6 Z" fill="#f2a63c"/>
    <circle cx="13.6" cy="-3" r="0.7" fill="#1a1a1a"/>
    <g class="doveW"><path d="M0,0 C 3,-15 11,-19 6,-6 C 4,-2 2,-1 0,0 Z" fill="#ffffff" stroke="#e3e8f0" stroke-width="0.5"/></g>
    <path d="M19,-0.6 q4,1.4 7.5,-0.6" stroke="#5a8a3a" stroke-width="0.9" fill="none"/><circle cx="26" cy="-1.4" r="1" fill="#6d9c3a"/><circle cx="23" cy="-0.2" r="1" fill="#6d9c3a"/>
  </g></g>`;
}

/* ---- a soft white spring cloud drifting sideways ---- */
function cloudWhite(x, y, s, o, dur, delay) {
  return `<g transform="translate(${x},${y})"><g class="drift" style="animation-duration:${dur}s;animation-delay:${delay}s"><g transform="scale(${s})" opacity="${o}" fill="#ffffff">
    <circle cx="-15" cy="4" r="8"/><circle cx="-2" cy="0" r="11"/><circle cx="12" cy="3" r="8.5"/><circle cx="24" cy="6" r="6.5"/><rect x="-21" y="6" width="49" height="8" rx="4"/>
  </g></g></g>`;
}

/* ---- a neoclassical columned fa\u00e7ade \u2014 the Hungarian National Museum,
        where Pet\u0151fi's generation proclaimed the revolution in 1848 ---- */
function museum(cx, gy, s) {
  const LT = '#efe7d6', MD = '#dccfb6', DK = '#b7a684', SH = '#c9bb9d', GOLD = '#f6c700';
  const nCol = 6, span = 112, x0 = -span / 2, gap = span / (nCol - 1), colH = 44, colW = 8;
  let cols = '';
  for (let i = 0; i < nCol; i++) {
    const x = x0 + gap * i;
    cols += `<rect x="${(x - colW / 2).toFixed(1)}" y="${-colH}" width="${colW}" height="${colH}" fill="${LT}"/>`;
    cols += `<g stroke="${MD}" stroke-width="0.7">`;
    for (let f = -2; f <= 2; f++) cols += `<line x1="${(x + f * 1.6).toFixed(1)}" y1="${-colH + 3}" x2="${(x + f * 1.6).toFixed(1)}" y2="-4"/>`;
    cols += `</g>`;
    cols += `<rect x="${(x - colW / 2 - 1.2).toFixed(1)}" y="${-colH - 3}" width="${colW + 2.4}" height="3.5" fill="${LT}"/>`;
    cols += `<rect x="${(x - colW / 2 - 1.4).toFixed(1)}" y="-4" width="${colW + 2.8}" height="4" fill="${MD}"/>`;
  }
  const he = span / 2 + 8;
  return `<g transform="translate(${cx},${gy}) scale(${s})">
    <rect x="-84" y="-6" width="168" height="6" fill="${MD}"/>
    <rect x="-78" y="-11" width="156" height="5" fill="${LT}"/>
    <rect x="-72" y="-15" width="144" height="4" fill="${MD}"/>
    <rect x="-70" y="-18" width="140" height="3" fill="${LT}"/>
    <rect x="-58" y="${-colH - 4}" width="116" height="${colH + 4}" fill="${DK}"/>
    ${cols}
    <rect x="${-he}" y="${-colH - 10}" width="${2 * he}" height="6.5" fill="${LT}"/>
    <rect x="${-he}" y="${-colH - 3.5}" width="${2 * he}" height="2.5" fill="${SH}"/>
    <path d="M${-he},${-colH - 10} L0,${-colH - 31} L${he},${-colH - 10} Z" fill="${LT}"/>
    <path d="M${-he + 7},${-colH - 12} L0,${-colH - 27} L${he - 7},${-colH - 12} Z" fill="${SH}"/>
    <circle cx="0" cy="${-colH - 33}" r="2.4" fill="${GOLD}"/>
    <circle cx="${-he}" cy="${-colH - 10}" r="1.6" fill="${LT}"/>
    <circle cx="${he}" cy="${-colH - 10}" r="1.6" fill="${LT}"/>
  </g>`;
}

/* ---- National Day / 1848 Revolution (Mar 15): a bright spring morning \u2014
        tricolour bunting and kok\u00e1rda cockades, doves of liberty over the
        National Museum, blossom on the breeze and the flag on its pole ---- */
function hungaryRevolutionScene() {
  const RED = '#CD2A3E', GRN = '#43704d', GOLD = '#f6c700';
  const cols = [RED, '#ffffff', GRN];
  const clouds = cloudWhite(74, 46, 1.0, 0.92, 9, 0) + cloudWhite(258, 34, 1.25, 0.82, 11, -3) + cloudWhite(322, 74, 0.8, 0.75, 10, -6);
  const bunt = pennantSwag(-14, 16, 180, 30, 18, cols, 0) + pennantSwag(180, 30, 376, 16, 18, cols, -0.6);
  const doves = dove(118, 60, 0.92, 0) + dove(232, 42, 0.72, -1.1) + dove(300, 78, 0.82, -2.2);

  let petals = ''; const pc = ['#f6c9d6', '#ffffff', '#f3b6c8', '#fbdce6', '#ffd9e2'];
  for (let i = 0; i < 18; i++) {
    const x = rnd(8, 352), dur = rnd(4.5, 8), delay = -rnd(0, dur), r = rnd(1.6, 3), c = pc[i % pc.length];
    petals += `<g transform="translate(${x.toFixed(1)},0)"><g class="petal" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><ellipse rx="${r.toFixed(1)}" ry="${(r * 0.6).toFixed(1)}" fill="${c}"/></g></g>`;
  }

  // shimmering daylight reflections on the Danube
  let reflDay = ''; const rcd = ['#eaf4fb', '#d2e7f4', '#bcdcee', '#f2f8fc'];
  for (let i = 0; i < 15; i++) {
    const x = rnd(20, 342), w = rnd(3, 7), h = rnd(5, 15), d = rnd(0, 2.4), o = rnd(0.2, 0.5);
    reflDay += `<rect class="twinkle" x="${x.toFixed(1)}" y="188" width="${w.toFixed(1)}" height="${h.toFixed(1)}" rx="1" fill="${rcd[i % rcd.length]}" opacity="${o.toFixed(2)}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  // tricolour cloth, sliced into rippling strips
  const W = 150, H = 100, SH = 100 / 3;
  let cloth = `<rect width="${W}" height="${(SH + 0.3).toFixed(2)}" fill="${RED}"/><rect y="${SH.toFixed(2)}" width="${W}" height="${(SH + 0.3).toFixed(2)}" fill="#ffffff"/><rect y="${(2 * SH).toFixed(2)}" width="${W}" height="${SH.toFixed(2)}" fill="${GRN}"/>`;
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.14)" stroke-width="0.6"/>`;
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="hu15cp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#hu15cp${i})"><use href="#hu15flagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="March 15 National Day \u2014 tricolour bunting, kok\u00e1rda cockades and doves over the Hungarian National Museum on a spring morning">
    <defs>
      <linearGradient id="skyHu15" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#6fb2e6"/><stop offset="0.55" stop-color="#a7d0ef"/><stop offset="1" stop-color="#e9f3f2"/>
      </linearGradient>
      <linearGradient id="lawnHu" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#8fb15e"/><stop offset="1" stop-color="#6d9247"/>
      </linearGradient>
      <linearGradient id="danubeDay" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#86b9d8"/><stop offset="1" stop-color="#5f97bf"/>
      </linearGradient>
      <g id="hu15flagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyHu15)"/>
    ${clouds}
    ${doves}
    ${parliament(205, 216, 0.78, { stone: '#e9e6dd', dark: '#b3ac9c', win: '#6f8aa6', finial: '#f6c700', base: '#cfc9ba', band: '#cdc7b8' })}
    <path d="M-10,184 Q 120,189 250,185 T 400,186 V 216 H -10 Z" fill="url(#danubeDay)"/>
    ${reflDay}
    <path d="M-10,210 Q 180,206 370,210 V 220 H -10 Z" fill="url(#lawnHu)"/>
    <line x1="44" y1="214" x2="44" y2="12" stroke="#b7bcc6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="10" r="3" fill="${GOLD}"/>
    <g transform="translate(45,18)">${strips}</g>
    ${kokarda(300, 138, 1.18, 0)}
    ${kokarda(96, 150, 0.72, -1.4)}
    ${bunt}
    ${petals}
  </svg>`;
}

/* ---- the escudo de España: quartered shield (Castile, León, Aragón, Navarre)
        with the Granada pomegranate in point and the Bourbon inescutcheon,
        flanked by the crowned Pillars of Hercules with PLVS VLTRA scrolls,
        beneath the Spanish royal crown ---- */
function escudo(cx, cy, s) {
  const RED = '#c60b1e', GOLD = '#f4c400', GOLDD = '#c69a1e', BLUE = '#1e57b0', LION = '#b34a86', WHT = '#f3eee0', CHN = '#eccb52';

  // --- royal crown ---
  const crown = `<g>
    <path d="M-8.5,-18.6 Q0,-15.4 8.5,-18.6 L7.6,-22 -7.6,-22 Z" fill="#b30f1c"/>
    <rect x="-9.4" y="-18.8" width="18.8" height="2.5" rx="1.2" fill="${GOLD}"/>
    <g fill="${GOLD}"><circle cx="-9" cy="-19.4" r="1.5"/><circle cx="9" cy="-19.4" r="1.5"/><circle cx="-4.5" cy="-20.5" r="1.1"/><circle cx="4.5" cy="-20.5" r="1.1"/><circle cx="0" cy="-21" r="1.1"/></g>
    <path d="M-8.6,-20 Q0,-31 8.6,-20" fill="none" stroke="${GOLD}" stroke-width="1.5"/>
    <path d="M-5.6,-20.6 Q0,-28.6 5.6,-20.6" fill="none" stroke="${GOLD}" stroke-width="1.2" opacity="0.85"/>
    <circle cx="0" cy="-30.4" r="1.7" fill="${GOLD}"/>
    <rect x="-0.6" y="-35" width="1.2" height="4.4" rx="0.4" fill="${GOLD}"/><rect x="-2" y="-33.6" width="4" height="1.2" rx="0.4" fill="${GOLD}"/>
    <g fill="${RED}"><circle cx="-4.8" cy="-17.6" r="0.7"/><circle cx="0" cy="-17" r="0.7"/><circle cx="4.8" cy="-17.6" r="0.7"/></g>
  </g>`;

  // --- a Pillar of Hercules with its crown ---
  const pillar = (px, royal) => `<g transform="translate(${px},0)">
    <rect x="-2.4" y="-11" width="4.8" height="26" fill="${WHT}" stroke="${GOLDD}" stroke-width="0.4"/>
    <rect x="-3.4" y="-13.2" width="6.8" height="2.6" rx="0.6" fill="${WHT}" stroke="${GOLDD}" stroke-width="0.4"/>
    <rect x="-3.4" y="14.4" width="6.8" height="2.8" rx="0.6" fill="${WHT}" stroke="${GOLDD}" stroke-width="0.4"/>
    <g stroke="${GOLDD}" stroke-width="0.4"><line x1="-1.1" y1="-10.6" x2="-1.1" y2="14"/><line x1="1.1" y1="-10.6" x2="1.1" y2="14"/></g>
    ${royal
      ? `<path d="M-3,-14 Q0,-12.2 3,-14 L2.6,-16.6 -2.6,-16.6 Z" fill="${RED}"/><rect x="-3.4" y="-14.2" width="6.8" height="1.4" rx="0.6" fill="${GOLD}"/><path d="M-2.8,-15.4 Q0,-19.4 2.8,-15.4" fill="none" stroke="${GOLD}" stroke-width="0.9"/><circle cx="0" cy="-19.2" r="0.9" fill="${GOLD}"/>`
      : `<rect x="-3.2" y="-16.6" width="6.4" height="1.4" rx="0.6" fill="${GOLD}"/><path d="M-3,-15.2 l0,-2.6 1.5,1.2 1.5,-2 1.5,2 1.5,-1.2 0,2.6 Z" fill="${GOLD}"/>`}
  </g>`;

  // --- shield with clipped quarters ---
  const CLIP = 'esShieldClip';
  const shieldPath = 'M-13,-16 H13 V3 C13,11 8,17 0,21 C-8,17 -13,11 -13,3 Z';
  const castle = (x, y) => `<g transform="translate(${x},${y})" fill="${GOLD}">
    <rect x="-3.4" y="-0.6" width="6.8" height="4.6"/>
    <rect x="-3.4" y="-2.4" width="1.8" height="2"/><rect x="-0.9" y="-2.4" width="1.8" height="2"/><rect x="1.6" y="-2.4" width="1.8" height="2"/>
    <rect x="-0.9" y="0.8" width="1.8" height="3.2" fill="${RED}"/>
  </g>`;
  const lion = (x, y) => `<g transform="translate(${x},${y}) scale(0.9)" fill="${LION}">
    <path d="M-3.2,4.2 Q-4.4,0 -3,-2.6 Q-2,-4.6 0.4,-4.8 Q1.6,-6.2 3.2,-5.6 Q2.2,-4.4 2.8,-3.6 Q4.2,-2.6 3.8,-0.8 L2.4,-1.4 Q3,0 2,0.8 L3.6,3.2 1.8,2.4 2.4,4.4 0.8,3 0.4,4.6 -0.6,2.8 -1.6,4.4 -1.8,2.2 Z"/>
  </g>`;
  const q3 = () => { // Aragón — red pallets on gold
    let bars = `<rect x="-13" y="-1" width="13" height="22" fill="${GOLD}"/>`;
    for (const bx of [-11.4, -8.4, -5.4, -2.4]) bars += `<rect x="${bx}" y="-1" width="1.5" height="22" fill="${RED}"/>`;
    return bars;
  };
  const q4 = () => { // Navarre — gold chains on red
    let ch = `<rect x="0" y="-1" width="13" height="22" fill="${RED}"/>`;
    const c = [6.5, 8];
    ch += `<g stroke="${CHN}" stroke-width="1" fill="none">`;
    for (let a = 0; a < 8; a++) { const ang = a * Math.PI / 4; ch += `<line x1="${c[0]}" y1="${c[1]}" x2="${(c[0] + Math.cos(ang) * 6).toFixed(1)}" y2="${(c[1] + Math.sin(ang) * 6).toFixed(1)}"/>`; }
    ch += `</g><circle cx="${c[0]}" cy="${c[1]}" r="1.5" fill="none" stroke="${CHN}" stroke-width="1"/>`;
    return ch;
  };
  const shield = `
    <clipPath id="${CLIP}"><path d="${shieldPath}"/></clipPath>
    <path d="${shieldPath}" fill="${WHT}"/>
    <g clip-path="url(#${CLIP})">
      <rect x="-13" y="-16" width="13" height="15" fill="${RED}"/>
      <rect x="0" y="-16" width="13" height="15" fill="${WHT}"/>
      ${q3()}${q4()}
      <path d="M-5,9 H5 V15 Q0,20 -5,15 Z" fill="${WHT}"/>
      <g transform="translate(0,13)"><circle r="2.4" fill="#c40f2a"/><path d="M0,-2.4 v-1.4" stroke="#2f7d34" stroke-width="1" stroke-linecap="round"/><g fill="${GOLD}"><circle cx="-0.8" cy="-0.4" r="0.5"/><circle cx="0.8" cy="-0.4" r="0.5"/><circle cx="0" cy="0.8" r="0.5"/></g></g>
      ${castle(-6.5, -8)}
      ${lion(6.5, -8)}
    </g>
    <path d="${shieldPath}" fill="none" stroke="${GOLDD}" stroke-width="0.8"/>
    <g transform="translate(0,-1)">
      <ellipse rx="3.6" ry="4.4" fill="${BLUE}" stroke="${GOLD}" stroke-width="0.6"/>
      <g fill="${GOLD}"><path d="M0,-2.4 C-1,-1.2 -1,0 0,0.6 C1,0 1,-1.2 0,-2.4 Z"/><circle cx="0" cy="-2.6" r="0.5"/><path d="M-1.8,1.6 C-2.2,-0.2 -0.8,0.2 -0.4,1.2 Z"/><path d="M1.8,1.6 C2.2,-0.2 0.8,0.2 0.4,1.2 Z"/></g>
    </g>`;

  // --- PLVS VLTRA scrolls weaving across the pillars ---
  const scrolls = `
    <path d="M-24,2 Q-17,-2 -13,3 Q-9,7 -3,4" fill="none" stroke="${RED}" stroke-width="3.4" stroke-linecap="round"/>
    <path d="M24,2 Q17,-2 13,3 Q9,7 3,4" fill="none" stroke="${RED}" stroke-width="3.4" stroke-linecap="round"/>`;

  return `<g transform="translate(${cx},${cy}) scale(${s})">
    ${pillar(-19, false)}
    ${pillar(19, true)}
    ${scrolls}
    ${shield}
    ${crown}
  </g>`;
}

/* ---- the Puerta de Alcalá: a neoclassical triumphal gate, three central
        semicircular arches flanked by two rectangular gates, an attic and
        trophy finials ---- */
function puertaAlcala(cx, gy, s, stone, dark) {
  return `<g transform="translate(${cx},${gy}) scale(${s})">
    <g fill="${stone}">
      <rect x="-79" y="-6" width="158" height="6" rx="1"/>
      <rect x="-74" y="-58" width="148" height="52"/>
      <rect x="-70" y="-74" width="140" height="16"/>
      <rect x="-75" y="-79" width="150" height="6" rx="1"/>
      <polygon points="-42,-79 -35,-92 -28,-79"/>
      <polygon points="28,-79 35,-92 42,-79"/>
      <rect x="-2" y="-95" width="4" height="16"/><circle cx="0" cy="-96" r="2.4"/>
    </g>
    <g fill="${dark}">
      <path d="M-46,-6 V-37 a13,13 0 0 1 26,0 V-6 Z"/>
      <path d="M-13,-6 V-40 a13,13 0 0 1 26,0 V-6 Z"/>
      <path d="M20,-6 V-37 a13,13 0 0 1 26,0 V-6 Z"/>
      <rect x="-70" y="-30" width="16" height="24" rx="1"/>
      <rect x="54" y="-30" width="16" height="24" rx="1"/>
    </g>
    <g fill="${stone}">
      <rect x="-51" y="-58" width="4.5" height="52"/>
      <rect x="-18" y="-58" width="4.5" height="52"/>
      <rect x="15.5" y="-58" width="4.5" height="52"/>
      <rect x="47" y="-58" width="4.5" height="52"/>
    </g>
    <g fill="rgba(255,255,255,.16)"><rect x="-74" y="-74" width="148" height="2"/></g>
  </g>`;
}

/* ---- the Patrulla Águila flypast: three jets in formation, each laying a
        red / gold / red smoke trail across the sky ---- */
function jetFormation(gx, gy, s) {
  const trail = (ty, g) => `<polygon points="-11,${ty - 6.6} -250,${ty - 1.7} -250,${ty + 1.7} -11,${ty + 6.6}" fill="url(#${g})" opacity="0.3"/><polygon points="-11,${ty - 3.6} -250,${ty - 0.6} -250,${ty + 0.6} -11,${ty + 3.6}" fill="url(#${g})"/>`;
  const jet = (jy) => `<g transform="translate(0,${jy})">
      <path d="M3,-1.4 L-9,-8.6 -12,-8.1 -3,-1.2 Z" fill="#c7d1dd"/>
      <path d="M3,1.4 L-9,8.6 -12,8.1 -3,1.2 Z" fill="#c7d1dd"/>
      <path d="M-7.5,-1 L-13,-4.8 -14.4,-4.5 -9.6,-0.9 Z" fill="#c7d1dd"/>
      <path d="M-7.5,1 L-13,4.8 -14.4,4.5 -9.6,0.9 Z" fill="#c7d1dd"/>
      <path d="M13,0 L1,-2 -11,-1.6 -12.6,0 -11,1.6 1,2 Z" fill="#eef2f7" stroke="#a4afbd" stroke-width="0.4"/>
      <path d="M-8,0 L-13.6,-3.6 -11.4,-0.3 Z" fill="#dbe2ea"/>
      <ellipse cx="5.6" cy="0" rx="3.1" ry="1.35" fill="#3a5b86"/>
      <ellipse cx="6.3" cy="-0.35" rx="1.3" ry="0.65" fill="#9ab8dc"/>
      <circle cx="12.8" cy="0" r="0.8" fill="#cdd6e0"/>
    </g>`;
  return `<g transform="translate(${gx},${gy}) scale(${s})"><g class="jetFly">
    ${trail(-12,'trR')}${trail(0,'trY')}${trail(12,'trR')}
    ${jet(-12)}${jet(0)}${jet(12)}
  </g></g>`;
}

/* ---- Fiesta Nacional de España / Día de la Hispanidad: a bright October
        morning over Madrid — the Patrulla Águila trailing rojigualda smoke
        above the Puerta de Alcalá, with the flag rippling on its pole ---- */
function spainNationalScene() {
  const clouds = cloudWhite(72, 44, 1.0, 0.9, 10, 0) + cloudWhite(252, 30, 1.2, 0.8, 12, -4) + cloudWhite(322, 66, 0.7, 0.75, 9, -2);

  let confetti = '';
  for (let i = 0; i < 10; i++) {
    const x = rnd(12, 348), c = i % 2 ? '#c1272d' : '#f6b301';
    const dur = rnd(4, 6.8), delay = -rnd(0, dur), w = rnd(4, 6.5);
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="${(-w / 2).toFixed(1)}" y="-2" width="${w.toFixed(1)}" height="4" rx="1" fill="${c}"/></g></g>`;
  }

  // ---- the rojigualda: red / gold / red (1:2:1) with the escudo on the hoist third ----
  const W = 150, H = 100;
  let cloth = `<rect width="${W}" height="${H * 0.25 + 0.3}" fill="#c60b1e"/><rect y="${H * 0.25}" width="${W}" height="${H * 0.5}" fill="#ffc400"/><rect y="${H * 0.75}" width="${W}" height="${H * 0.25}" fill="#c60b1e"/>`;
  cloth += escudo(52, 56.5, 0.86);
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.18)" stroke-width="0.6"/>`;
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="escp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#escp${i})"><use href="#esflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Fiesta Nacional de España — the Patrulla Águila trailing red and gold smoke over the Puerta de Alcalá, with the Spanish flag waving">
    <defs>
      <linearGradient id="skyEs" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#4c92d6"/><stop offset="0.55" stop-color="#9fcbec"/><stop offset="1" stop-color="#e6eff7"/>
      </linearGradient>
      <linearGradient id="trR" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#c1272d" stop-opacity="0"/><stop offset="0.4" stop-color="#c1272d" stop-opacity="0.9"/><stop offset="1" stop-color="#c1272d" stop-opacity="0.9"/></linearGradient>
      <linearGradient id="trY" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#f6b301" stop-opacity="0"/><stop offset="0.4" stop-color="#f6b301" stop-opacity="0.95"/><stop offset="1" stop-color="#f6b301" stop-opacity="0.95"/></linearGradient>
      <g id="esflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyEs)"/>
    ${clouds}
    ${jetFormation(64, 54, 1.15)}
    ${puertaAlcala(208, 200, 1.0, '#d9ccb2', '#8f8168')}
    <path d="M-10,198 Q 180,192 370,198 V 220 H -10 Z" fill="#c9b79b"/>
    <path d="M-10,210 Q 180,205 370,210 V 220 H -10 Z" fill="#b3a184"/>
    <line x1="44" y1="212" x2="44" y2="8" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="6" r="3" fill="#ffc400"/>
    <g transform="translate(45,14)">${strips}</g>
    ${confetti}
  </svg>`;
}

/* ---- the Star of Bethlehem: a slow-spinning gold star with a glowing halo
        and a long guiding tail leading the Kings ---- */
function starBeth(cx, cy, s) {
  return `<g transform="translate(${cx},${cy}) scale(${s})">
    <g class="glow"><circle r="30" fill="url(#epGlow)"/></g>
    <path d="M0,8 L3.2,66 -3.2,66 Z" fill="url(#epTail)"/>
    <g class="starSpin">
      <path d="M0,-24 L4,-4 24,0 4,4 0,24 -4,4 -24,0 -4,-4 Z" fill="#fff2c8"/>
      <path d="M0,-13 L2.4,-2.4 13,0 2.4,2.4 0,13 -2.4,2.4 -13,0 -2.4,-2.4 Z" fill="#fffdf3"/>
    </g>
    <circle r="3.2" fill="#fffdf3"/>
    <circle class="twinkle" cx="-16" cy="-13" r="1.2" fill="#fff" style="animation-delay:0.3s"/>
    <circle class="twinkle" cx="17" cy="11" r="1" fill="#fff" style="animation-delay:1.1s"/>
  </g>`;
}

/* ---- a Reyes Mago on a camel: crowned rider bearing a gift, camel with two
        humps, gently swaying as the caravan follows the star ---- */
function kingCamel(x, gy, s, robe, gift, delay) {
  return `<g transform="translate(${x},${gy}) scale(${s})"><g class="camelWalk" style="animation-delay:${delay}s">
    <g fill="#332d55">
      <rect x="-13" y="-9" width="2.6" height="15" rx="1"/><rect x="-7" y="-9" width="2.6" height="15" rx="1"/>
      <rect x="7" y="-9" width="2.6" height="15" rx="1"/><rect x="13" y="-9" width="2.6" height="15" rx="1"/>
      <path d="M-18,-13 Q-16,-21 -10,-19 Q-6,-27 0,-19 Q6,-27 12,-18 L19,-15 Q22,-14 20,-11 L-16,-10 Z"/>
      <path d="M17,-15 Q26,-17 26,-28 Q26,-33 21.5,-33 Q23,-30 20.5,-27 Q18,-20 15,-17 Z"/>
      <path d="M-18,-12 Q-23,-9 -21.5,-4" stroke="#332d55" stroke-width="1.6" fill="none" stroke-linecap="round"/>
    </g>
    <g transform="translate(-1,-23)">
      <path d="M-6,2 Q-7,-8 0,-9 Q7,-8 6,2 Z" fill="${robe}"/>
      <circle cx="0" cy="-11" r="4" fill="#514572"/>
      <path d="M-4.4,-13 L-4.4,-16.2 -1.4,-14 0,-17.6 1.4,-14 4.4,-16.2 4.4,-13 Z" fill="#f6b301"/>
      <g transform="translate(7.5,-3)"><rect x="-2.4" y="-2.4" width="4.8" height="4.8" rx="0.6" fill="${gift}"/><rect x="-2.4" y="-0.6" width="4.8" height="1.2" fill="#f6b301"/><rect x="-0.6" y="-2.4" width="1.2" height="4.8" fill="#f6b301"/></g>
    </g>
  </g></g>`;
}

/* ---- a night-time Spanish pueblo silhouette with a church belfry ---- */
function pueblo(x, gy, s) {
  const house = (hx, w, h) => {
    let win = '';
    const rows = Math.max(1, Math.floor(h / 10));
    for (let r = 0; r < rows; r++) {
      if (Math.random() < 0.55) win += `<rect x="${(hx + w / 2 - 1.4).toFixed(1)}" y="${(-h + 5 + r * 10).toFixed(1)}" width="2.8" height="3.4" fill="#f6b301" opacity="${rnd(0.5, 1).toFixed(2)}"/>`;
    }
    return `<rect x="${hx}" y="${-h}" width="${w}" height="${h}" fill="#302a52"/>${win}`;
  };
  return `<g transform="translate(${x},${gy}) scale(${s})">
    ${house(-46, 16, 22)}${house(-30, 14, 30)}${house(-16, 12, 20)}${house(40, 15, 26)}${house(55, 13, 18)}
    <g fill="#302a52">
      <rect x="0" y="-42" width="14" height="42"/>
      <polygon points="0,-42 7,-54 14,-42"/>
      <rect x="5.4" y="-62" width="3.2" height="9"/>
      <rect x="4" y="-66" width="6" height="1.8"/>
      <rect x="6.2" y="-72" width="1.6" height="6"/><rect x="4.6" y="-70" width="4.8" height="1.6"/>
    </g>
    <path d="M4.5,-38 a2.5,2.5 0 0 1 5,0 v6 h-5 Z" fill="#f6b301" opacity="0.85"/>
  </g>`;
}

/* ---- Epiphany / Día de Reyes: a winter night as the Cabalgata processes —
        the Three Kings on camels following the Star of Bethlehem over a lit
        pueblo, candy raining down and rojigualda bunting overhead ---- */
function epiphanyScene() {
  let stars = '';
  for (let i = 0; i < 20; i++) {
    const x = rnd(8, 352), y = rnd(6, 120), r = rnd(0.6, 1.5), d = rnd(0, 2.4);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const cols = ['#c1272d', '#f6b301', '#c1272d'];
  const bunt = pennantSwag(-14, 16, 180, 30, 16, cols, 0) + pennantSwag(180, 30, 376, 16, 16, cols, -0.6);

  // caramelos thrown from the floats
  const cc = ['#c1272d', '#f6b301', '#2a5db0', '#1f8a4c', '#e05a9c', '#f07d2a'];
  let candy = '';
  for (let i = 0; i < 15; i++) {
    const x = rnd(10, 350), c = cc[i % cc.length], dur = rnd(3.6, 6.2), delay = -rnd(0, dur);
    const shape = Math.random() < 0.5
      ? `<circle r="2.3" fill="${c}"/><polygon points="-4,-2 -4,2 -2.3,0" fill="${c}"/><polygon points="4,-2 4,2 2.3,0" fill="${c}"/>`
      : `<rect x="-2" y="-2" width="4" height="4" rx="0.8" fill="${c}"/>`;
    candy += `<g transform="translate(${x.toFixed(1)},0)"><g class="streamer" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s">${shape}</g></g>`;
  }

  const shootS = `<g transform="translate(74,24)"><g class="shoot">
    <path d="M-27,-12 L1.6,-1.8 -1.6,1.8 Z" fill="url(#epStreak)"/>
    <path d="M0,-5 L1.4,-1.4 5,0 1.4,1.4 0,5 -1.4,1.4 -5,0 -1.4,-1.4 Z" fill="#fffdf3"/>
    <circle r="1.1" fill="#fff"/>
  </g></g>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Día de Reyes — the Three Kings on camels following the Star of Bethlehem over a Spanish pueblo, with candy raining down">
    <defs>
      <linearGradient id="skyEp" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#1b2b5c"/><stop offset="0.55" stop-color="#3c3773"/><stop offset="1" stop-color="#7a5480"/>
      </linearGradient>
      <radialGradient id="epGlow"><stop offset="0" stop-color="#fff2c8" stop-opacity="0.9"/><stop offset="0.5" stop-color="#f6d67a" stop-opacity="0.35"/><stop offset="1" stop-color="#f6d67a" stop-opacity="0"/></radialGradient>
      <linearGradient id="epTail" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#fff2c8" stop-opacity="0.7"/><stop offset="1" stop-color="#fff2c8" stop-opacity="0"/></linearGradient>
      <linearGradient id="epStreak" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#fffdf3" stop-opacity="0"/><stop offset="1" stop-color="#fffdf3" stop-opacity="0.85"/></linearGradient>
    </defs>
    <rect width="360" height="220" fill="url(#skyEp)"/>
    ${stars}
    ${shootS}
    ${starBeth(238, 52, 1.05)}
    <path d="M-10,190 Q 90,168 220,182 Q 300,190 370,178 V 220 H -10 Z" fill="#2b2650"/>
    ${pueblo(64, 190, 0.92)}
    <path d="M-10,206 Q 180,192 370,204 V 220 H -10 Z" fill="#221d40"/>
    ${kingCamel(126, 210, 0.82, '#a23244', '#f6b301', -0.9)}
    ${kingCamel(176, 213, 0.94, '#3358a0', '#e8e2d0', -0.3)}
    ${kingCamel(224, 210, 0.82, '#2a8a5c', '#c1272d', -1.5)}
    ${bunt}
    ${candy}
  </svg>`;
}

/* ============================================================
   BARE Dubai (UAE) — Eid al-Fitr & Eid al-Adha
   Shared Islamic / Gulf motifs: the hilal (crescent + star), the fanoos
   lantern, an onion-domed mosque, date palms and a dromedary caravan.
   ============================================================ */

/* ---- a crescent (waxing) as a path: outer radius r, inner cut ir ---- */
const crescentPath = (r, ir) => `M0,${(-r).toFixed(2)} A ${r},${r} 0 1,0 0,${r.toFixed(2)} A ${ir},${ir} 0 1,1 0,${(-r).toFixed(2)} Z`;

/* ---- the hilal: a glowing gold crescent cradling a five-point star ---- */
function hilal(cx, cy, r, glowId, delay, tilt) {
  const ir = r * 0.8, sr = r * 0.32;
  let sp = '';
  for (let k = 0; k < 10; k++) {
    const a = (-90 + k * 36) * Math.PI / 180, rr = k % 2 ? sr * 0.42 : sr;
    sp += `${(rr * Math.cos(a)).toFixed(2)},${(rr * Math.sin(a)).toFixed(2)} `;
  }
  return `<g transform="translate(${cx},${cy})">
    <g class="glow" style="animation-delay:${delay}s"><circle r="${(r * 2.2).toFixed(1)}" fill="url(#${glowId})"/></g>
    <g transform="rotate(${tilt})">
      <path d="${crescentPath(r, ir)}" fill="#ffe6a3"/>
      <path d="${crescentPath(r, ir * 0.97)}" fill="none" stroke="#fff6dd" stroke-width="0.7" opacity="0.55"/>
      <g transform="translate(${(r * 0.86).toFixed(1)},${(-r * 0.1).toFixed(1)})"><polygon points="${sp.trim()}" fill="#fff3cf"/></g>
    </g>
  </g>`;
}

/* ---- a fanoos: the ornate hanging Ramadan/Eid lantern, jewel-glass panels,
        gold metalwork, a warm flame inside, gently swaying ---- */
function fanoos(x, topY, len, s, glass, delay) {
  return `<g transform="translate(${x},${topY})"><g class="lanternSway" style="animation-delay:${delay}s">
    <line x1="0" y1="0" x2="0" y2="${len}" stroke="#c8932f" stroke-width="1"/>
    <g transform="translate(0,${len}) scale(${s})">
      <ellipse class="glow" cx="0" cy="7" rx="15" ry="18" fill="rgba(255,206,110,.30)" style="animation-delay:${delay}s"/>
      <circle cx="0" cy="-15" r="1.9" fill="#d9a441"/>
      <path d="M-7,-6 L-4,-13 L0,-9 L4,-13 L7,-6 Z" fill="#d9a441"/>
      <rect x="-8.5" y="-6" width="17" height="3" rx="1.5" fill="#c8932f"/>
      <path d="M-8,-3 L8,-3 L10.5,13 L0,20 L-10.5,13 Z" fill="${glass}" opacity="0.92"/>
      <path d="M-8,-3 L8,-3 L6,3 L-6,3 Z" fill="#fff" opacity="0.14"/>
      <g stroke="#f6d98a" stroke-width="0.7" opacity="0.7" fill="none">
        <line x1="-4" y1="-3" x2="-5.4" y2="14"/><line x1="0" y1="-3" x2="0" y2="19"/><line x1="4" y1="-3" x2="5.4" y2="14"/>
        <line x1="-9" y1="5.5" x2="9" y2="5.5"/>
        <path d="M-6,-3 Q0,3 6,-3"/>
      </g>
      <g class="flame"><path d="M0,11 C 2.6,7 2.7,3.5 0,1.4 C -2.7,3.5 -2.6,7 0,11 Z" fill="#fff3c4"/></g>
      <path d="M-10.5,13 L10.5,13 L6,19 L-6,19 Z" fill="#c8932f"/>
      <line x1="0" y1="20" x2="0" y2="27" stroke="#d9a441" stroke-width="1"/>
      <circle cx="0" cy="28.5" r="1.7" fill="#d9a441"/>
    </g>
  </g></g>`;
}

/* ---- an onion-domed mosque: central dome + crescent finial, two minarets,
        lit arched windows ---- */
function mosque(x, gy, s, c, lit) {
  const minaret = (mx, h) => `<g transform="translate(${mx},0)">
    <rect x="-2.6" y="${-h}" width="5.2" height="${h}" fill="${c}"/>
    <rect x="-3.8" y="${-h + 20}" width="7.6" height="2.2" fill="${c}"/>
    <path d="M-4.4,${-h} Q0,${-h - 6} 4.4,${-h} Z" fill="${c}"/>
    <ellipse cx="0" cy="${-h - 6}" rx="4" ry="5.4" fill="${c}"/>
    <g transform="translate(0,${-h - 13}) scale(0.42) rotate(18)"><path d="${crescentPath(4, 3.2)}" fill="${lit}"/></g>
    <rect x="-1" y="${-h + 26}" width="2" height="4" rx="1" fill="${lit}" opacity="0.8"/>
  </g>`;
  return `<g transform="translate(${x},${gy}) scale(${s})">
    ${minaret(-34, 58)}${minaret(34, 58)}
    <rect x="-30" y="-30" width="60" height="30" fill="${c}"/>
    <path d="M-22,-29 C -25,-53 -12,-64 0,-64 C 12,-64 25,-53 22,-29 Z" fill="${c}"/>
    <line x1="0" y1="-64" x2="0" y2="-71" stroke="${c}" stroke-width="2"/>
    <g transform="translate(0,-75) scale(0.7) rotate(18)"><path d="${crescentPath(4.2, 3.3)}" fill="${lit}"/></g>
    <path d="M-7,0 L-7,-15 Q0,-24 7,-15 L7,0 Z" fill="${lit}" opacity="0.9"/>
    <path d="M-21,0 L-21,-9 Q-17.5,-14 -14,-9 L-14,0 Z" fill="${lit}" opacity="0.6"/>
    <path d="M14,0 L14,-9 Q17.5,-14 21,-9 L21,0 Z" fill="${lit}" opacity="0.6"/>
  </g>`;
}

/* ---- scatter of lit windows over a dark building block ---- */
function litWindows(x, top, w, h, lit) {
  let s = '';
  const cols = Math.max(1, Math.floor((w - 4) / 7));
  const rows = Math.max(1, Math.floor((h - 6) / 9));
  for (let c = 0; c < cols; c++) for (let r = 0; r < rows; r++) {
    if (Math.random() < 0.5) s += `<rect x="${(x + 3 + c * 7).toFixed(1)}" y="${(top + 4 + r * 9).toFixed(1)}" width="2.3" height="3.3" fill="${lit}" opacity="${rnd(0.4, 1).toFixed(2)}"/>`;
  }
  return s;
}

/* ---- Burj Khalifa: a tall tapering, stepped spire with a needle ---- */
function burjKhalifa(x, gy, s, c, lit) {
  let win = '';
  for (let i = 0; i < 22; i++) {
    const y = -18 - i * 8, w = 13 - i * 0.5;
    if (Math.random() < 0.7) win += `<rect x="${(-w / 2 + rnd(0, w - 2)).toFixed(1)}" y="${y.toFixed(1)}" width="1.8" height="2.6" fill="${lit}" opacity="${rnd(0.4, 1).toFixed(2)}"/>`;
  }
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <polygon points="-11,0 -9,-60 -6,-104 -4,-146 -1.4,-188 0,-198 1.4,-188 4,-146 6,-104 9,-60 11,0" fill="${c}"/>
    <line x1="0" y1="-198" x2="0" y2="-224" stroke="${c}" stroke-width="1.5"/>
    ${win}
  </g>`;
}

/* ---- Burj Al Arab: the billowing sail on its mast ---- */
function burjAlArab(x, gy, s, c, lit) {
  let win = '';
  for (let i = 0; i < 12; i++) win += `<rect x="${rnd(2, 20).toFixed(1)}" y="${(-8 - i * 7).toFixed(1)}" width="1.8" height="2.4" fill="${lit}" opacity="${rnd(0.4, 1).toFixed(2)}"/>`;
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <path d="M0,0 L0,-96 Q1,-104 6,-101 L30,-30 Q37,-6 27,0 Z" fill="${c}"/>
    <path d="M0,-96 Q1,-104 6,-101 L26,-42 Q10,-70 0,-90 Z" fill="${c}" opacity="0.55"/>
    <line x1="0.5" y1="0" x2="0.5" y2="-102" stroke="${c}" stroke-width="1.6"/>
    ${win}
  </g>`;
}

/* ---- a string of small warm bulbs strung along a quadratic swag ---- */
function bulbSwag(x0, y0, x1, y1, sag, delay) {
  const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2 + sag;
  const n = Math.max(6, Math.round(Math.hypot(x1 - x0, y1 - y0) / 16));
  const cols = ['#ffd24a', '#ffe9a8', '#ffb35c', '#fff2cc'];
  let bulbs = '';
  for (let i = 0; i <= n; i++) {
    const t = i / n;
    const bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
    const by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
    bulbs += `<circle class="twinkle" cx="${bx.toFixed(1)}" cy="${(by + 2).toFixed(1)}" r="1.7" fill="${cols[i % cols.length]}" style="animation-delay:${(i * 0.18).toFixed(2)}s"/>`;
  }
  return `<g class="bunting" style="animation-delay:${delay}s">
    <path d="M${x0},${y0} Q ${cx},${cy} ${x1},${y1}" stroke="rgba(255,235,180,.35)" stroke-width="0.8" fill="none"/>
    ${bulbs}
  </g>`;
}

/* ---- a small dish of dates — the fast is broken with dates ---- */
function datesDish(x, y, s) {
  let dates = '';
  [[-9, -2], [-3, -3.4], [3, -3.4], [9, -2], [-5, -5.6], [1, -6], [6, -5.4]].forEach(([dx, dy]) => {
    dates += `<ellipse cx="${dx}" cy="${dy}" rx="3.1" ry="4.2" fill="#5c2f1a" transform="rotate(${rnd(-18, 18).toFixed(0)} ${dx} ${dy})"/><ellipse cx="${dx - 0.7}" cy="${dy - 1}" rx="1" ry="1.7" fill="#8a4b2b" opacity="0.7"/>`;
  });
  return `<g transform="translate(${x},${y}) scale(${s})">
    ${dates}
    <path d="M-16,-1 C -15,5 15,5 16,-1 Z" fill="#d9a441"/>
    <ellipse cx="0" cy="-1" rx="16" ry="3" fill="#e9c46a"/>
    <ellipse cx="0" cy="-1.4" rx="11" ry="1.8" fill="#c8932f" opacity="0.5"/>
  </g>`;
}

/* ---- Eid al-Fitr: Dubai after iftar — the hilal over a lit skyline
        (Burj Khalifa, Burj Al Arab, a domed mosque), fanoos lanterns,
        string lights, gold fireworks, dates, and the UAE flag rippling ---- */
function eidAlFitrScene() {
  let stars = '';
  for (let i = 0; i < 20; i++) {
    const x = rnd(10, 350), y = rnd(6, 96), r = rnd(0.7, 1.7), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }

  const FW = [
    ['#ffd24a', 118, 46, 0.0],
    ['#ffffff', 210, 32, 1.3],
    ['#7fe0c4', 286, 60, 0.7],
    ['#ffb35c', 66, 92, 2.1],
  ];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a) * 7).toFixed(1)}" y1="${(Math.sin(a) * 7).toFixed(1)}" x2="${(Math.cos(a) * 24).toFixed(1)}" y2="${(Math.sin(a) * 24).toFixed(1)}" stroke="${c}" stroke-width="1.5" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a) * 28).toFixed(1)}" cy="${(Math.sin(a) * 28).toFixed(1)}" r="1.6" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  // ---- UAE flag: red hoist band, then green / white / black stripes ----
  const W = 150, H = 78, RED = '#d21f3c', GRN = '#00843d', BLK = '#1a1a1a', band = W * 0.24, sw = H / 3;
  let cloth = `<rect width="${W}" height="${H}" fill="#fff"/>`;
  cloth += `<rect x="${band}" width="${W - band}" height="${sw}" fill="${GRN}"/>`;
  cloth += `<rect x="${band}" y="${2 * sw}" width="${W - band}" height="${sw}" fill="${BLK}"/>`;
  cloth += `<rect width="${band}" height="${H}" fill="${RED}"/>`;
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.18)" stroke-width="0.6"/>`;
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="efcp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.6 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#efcp${i})"><use href="#efflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  const SKY = '#0d1f3a';
  const blocks = [[64, 170, 22], [92, 158, 18], [248, 166, 22], [300, 176, 20], [330, 160, 26]];
  const buildings = blocks.map(([x, top, w]) => `<rect x="${x}" y="${top}" width="${w}" height="${220 - top}" fill="${SKY}"/>${litWindows(x, top, w, 220 - top, '#ffde8a')}`).join('');

  const lanterns = fanoos(96, 6, 22, 0.92, '#2a9d6f', 0) +
    fanoos(150, 6, 15, 1.05, '#c23a52', 0.7) +
    fanoos(214, 6, 30, 0.85, '#2f6fb0', 1.3) +
    fanoos(268, 6, 12, 0.95, '#e0a534', 0.35);

  let sparkle = '';
  for (let i = 0; i < 12; i++) {
    const x = rnd(14, 346), dur = rnd(4, 7), delay = -rnd(0, dur);
    sparkle += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="-1.6" y="-1.6" width="3.2" height="3.2" rx="0.6" fill="${i % 3 ? '#ffd24a' : '#fff2cc'}" transform="rotate(45)"/></g></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Eid al-Fitr — the crescent moon over a festive Dubai skyline with fanoos lanterns, string lights and the UAE flag">
    <defs>
      <linearGradient id="skyEf" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#0b1330"/><stop offset="0.55" stop-color="#25214e"/><stop offset="1" stop-color="#5a2b52"/>
      </linearGradient>
      <radialGradient id="moonGlowEf" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,229,163,.55)"/><stop offset="1" stop-color="rgba(255,229,163,0)"/>
      </radialGradient>
      <g id="efflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyEf)"/>
    ${stars}
    ${hilal(300, 46, 20, 'moonGlowEf', 0, -20)}
    ${bursts}
    ${buildings}
    ${burjAlArab(300, 220, 0.82, SKY, '#ffde8a')}
    ${mosque(120, 192, 0.62, SKY, '#ffd88a')}
    ${burjKhalifa(196, 200, 0.7, SKY, '#ffde8a')}
    <path d="M-10,196 Q 180,188 370,196 V 220 H -10 Z" fill="#0a1224"/>
    <rect y="208" width="360" height="12" fill="#070d1a"/>
    ${bulbSwag(-6, 20, 128, 12, 22, 0)}
    ${bulbSwag(232, 12, 368, 22, 24, 0.6)}
    ${lanterns}
    ${datesDish(316, 210, 0.9)}
    <line x1="46" y1="212" x2="46" y2="12" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="46" cy="10" r="3" fill="#ffd24a"/>
    <g transform="translate(47,18)">${strips}</g>
    ${sparkle}
  </svg>`;
}

/* ---- a curved date-palm silhouette with drooping fronds + a date cluster ---- */
function datePalm(x, gy, s, c) {
  const frond = (rot, len) => `<path d="M0,0 Q ${(len * 0.5).toFixed(0)},${(-len * 0.18).toFixed(0)} ${len},${(len * 0.32).toFixed(0)}" transform="rotate(${rot})" stroke="${c}" stroke-width="2.4" fill="none" stroke-linecap="round"/>`;
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <path d="M-2.4,0 C -1,-16 1,-30 -1.6,-44 L2.6,-44 C 3.2,-30 3.8,-16 4,0 Z" fill="${c}"/>
    <g transform="translate(0.5,-44)">
      ${frond(-150, 30)}${frond(-115, 34)}${frond(-80, 32)}${frond(-40, 30)}
      ${frond(-10, 28)}${frond(30, 30)}${frond(70, 32)}${frond(120, 30)}
      <circle cx="0" cy="2" r="2.4" fill="${c}"/>
      <g fill="#6b3f1f"><circle cx="-3" cy="4" r="1.4"/><circle cx="0" cy="5.4" r="1.4"/><circle cx="3" cy="4" r="1.4"/><circle cx="-1.4" cy="6.6" r="1.3"/><circle cx="1.6" cy="6.6" r="1.3"/></g>
    </g>
  </g>`;
}

/* ---- a dromedary (single-hump) camel walking, with a draped saddle cloth ---- */
function camel(x, gy, s, blanket, delay) {
  return `<g transform="translate(${x},${gy}) scale(${s})"><g class="camelWalk" style="animation-delay:${delay}s">
    <g fill="#241a30">
      <rect x="-14" y="-15" width="2.6" height="16" rx="1.1"/>
      <rect x="-7" y="-15" width="2.6" height="16" rx="1.1"/>
      <rect x="7" y="-15" width="2.6" height="16" rx="1.1"/>
      <rect x="13" y="-15" width="2.6" height="16" rx="1.1"/>
      <path d="M-16,-20 C -18,-30 -10,-33 -4,-32 C -2,-40 8,-40 10,-32 C 16,-31 19,-26 18,-19 C 6,-17 -6,-17 -16,-20 Z"/>
      <path d="M14,-30 C 20,-33 21,-42 25,-47 C 27,-50 30,-49 30,-46 C 29,-44 30,-42 31,-41 C 32,-40 31,-38 29,-38 C 27,-40 25,-38 23,-35 C 21,-32 18,-30 15,-29 Z"/>
      <path d="M26,-49 l1.6,-3.4 l1.6,3 Z"/>
      <path d="M-16,-22 C -20,-20 -21,-13 -18,-8" stroke="#241a30" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    </g>
    <path d="M-9,-31 C -4,-38 6,-38 10,-31 C 8,-26 -6,-26 -9,-31 Z" fill="${blanket}"/>
    <g fill="${blanket}"><rect x="-9.5" y="-27" width="1.6" height="4" rx="0.8"/><rect x="-5.5" y="-26" width="1.6" height="4" rx="0.8"/><rect x="6" y="-26" width="1.6" height="4" rx="0.8"/><rect x="9.5" y="-27" width="1.6" height="4" rx="0.8"/></g>
    <circle cx="29.4" cy="-45.4" r="0.9" fill="#0d0a14"/>
  </g></g>`;
}

/* ---- Eid al-Adha: a serene desert dawn — the hilal fading, rolling dunes,
        a domed mosque on the horizon, an oasis of date palms, and a camel
        caravan crossing toward the light. Doves of peace, drifting cloud. ---- */
function eidAlAdhaScene() {
  let stars = '';
  for (let i = 0; i < 12; i++) {
    const x = rnd(10, 350), y = rnd(4, 66), r = rnd(0.6, 1.4), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s" opacity="0.85"/>`;
  }

  // clouds drifting in the dawn
  const cloud = (cx, cy, sc, o, dur, dl) => `<g transform="translate(${cx},${cy})"><g class="drift" style="animation-duration:${dur}s;animation-delay:${dl}s"><g transform="scale(${sc})" opacity="${o}" fill="#ffd9b0">
    <circle cx="-14" cy="3" r="7"/><circle cx="-2" cy="0" r="10"/><circle cx="11" cy="3" r="7.5"/><rect x="-20" y="4" width="43" height="7" rx="3.5"/>
  </g></g></g>`;

  // gliding doves of peace
  const dove = (dx, dy, sc, dl) => `<g transform="translate(${dx},${dy}) scale(${sc})"><g class="dove" style="animation-duration:${rnd(4.8, 6.4).toFixed(1)}s;animation-delay:${dl}s">
    <path d="M-9,2 C -3,-3 6,-3 11,-1 C 15,0 17,2 14,4 C 9,7 0,7 -6,5 Z" fill="#fff6ec"/>
    <g class="doveW" style="animation-delay:${dl}s"><path d="M-2,0 C 1,-8 6,-11 4,-2 Z" fill="#ffe9d3"/></g>
  </g></g>`;

  const SUN = '#3a2540';
  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Eid al-Adha — a desert dawn with a domed mosque, date palms and a camel caravan crossing the dunes under the crescent moon">
    <defs>
      <linearGradient id="skyEa" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#141a44"/><stop offset="0.45" stop-color="#5a3a6b"/><stop offset="0.78" stop-color="#c96f5c"/><stop offset="1" stop-color="#f0a860"/>
      </linearGradient>
      <radialGradient id="moonGlowEa" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="rgba(255,236,196,.5)"/><stop offset="1" stop-color="rgba(255,236,196,0)"/>
      </radialGradient>
      <radialGradient id="dawnGlow" cx="0.5" cy="1" r="0.7">
        <stop offset="0" stop-color="rgba(255,214,150,.85)"/><stop offset="1" stop-color="rgba(255,214,150,0)"/>
      </radialGradient>
      <linearGradient id="dune1" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e59a5a"/><stop offset="1" stop-color="#c9743f"/></linearGradient>
      <linearGradient id="dune2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#c46a3c"/><stop offset="1" stop-color="#a4522c"/></linearGradient>
      <linearGradient id="dune3" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#8f4326"/><stop offset="1" stop-color="#6e2f1c"/></linearGradient>
    </defs>
    <rect width="360" height="220" fill="url(#skyEa)"/>
    ${stars}
    <ellipse cx="180" cy="150" rx="150" ry="80" fill="url(#dawnGlow)"/>
    ${hilal(70, 52, 17, 'moonGlowEa', 0, -18)}
    ${cloud(96, 44, 1, 0.55, 13, 0)}
    ${cloud(268, 34, 1.25, 0.5, 16, -4)}
    ${dove(232, 66, 0.9, 0)}
    ${dove(256, 82, 0.7, -1.4)}
    ${dove(212, 88, 0.62, -0.7)}
    <path d="M0,150 Q 90,132 180,144 T 360,140 V 220 H 0 Z" fill="url(#dune1)"/>
    ${mosque(180, 150, 0.6, SUN, '#ffd88a')}
    ${datePalm(40, 158, 1.15, '#3a2036')}
    ${datePalm(58, 160, 0.9, '#3a2036')}
    ${datePalm(320, 156, 1.05, '#3a2036')}
    <path d="M0,168 Q 100,150 210,166 T 360,160 V 220 H 0 Z" fill="url(#dune2)"/>
    ${camel(118, 196, 0.86, '#c23a52', -0.9)}
    ${camel(168, 199, 1, '#d9a441', -0.3)}
    ${camel(222, 196, 0.86, '#2a9d6f', -1.5)}
    <path d="M0,190 Q 120,176 240,190 T 360,186 V 220 H 0 Z" fill="url(#dune3)"/>
    <g stroke="#5a2718" stroke-width="1.4" stroke-linecap="round" opacity="0.6">
      <path d="M30,214 q3,-5 6,0"/><path d="M300,210 q3,-5 6,0"/><path d="M338,216 q3,-5 6,0"/>
    </g>
  </svg>`;
}

/* ---- a small 6-petal flower (forehead motif on the calavera) ---- */
function flower6(petalC, centerC) {
  let p = '';
  for (let i = 0; i < 6; i++) p += `<g transform="rotate(${60 * i})"><ellipse cx="0" cy="-6" rx="2.6" ry="4.2" fill="${petalC}"/></g>`;
  return `${p}<circle r="2.6" fill="${centerC}"/>`;
}

/* ---- a full cempasúchil (marigold) bloom — concentric petal rings ---- */
function mxMarigold(x, y, s) {
  const rings = [[14, -11, 2.6, 5, '#d9540c'], [12, -8.5, 2.4, 4.4, '#ef6a1e'], [10, -6, 2, 3.6, '#f7931e'], [8, -4, 1.7, 2.8, '#ffb61e']];
  let pet = '';
  rings.forEach(([n, cy, rx, ry, c]) => {
    for (let i = 0; i < n; i++) pet += `<g transform="rotate(${(360 / n * i).toFixed(1)})"><ellipse cx="0" cy="${cy}" rx="${rx}" ry="${ry}" fill="${c}"/></g>`;
  });
  return `<g transform="translate(${x},${y}) scale(${s})">${pet}<circle r="3" fill="#ffd23c"/><circle r="1.4" fill="#ef6a1e"/></g>`;
}

/* ---- a veladora: a glass devotional candle with glow + flickering flame ---- */
function veladora(x, y, s, delay) {
  return `<g transform="translate(${x},${y}) scale(${s})">
    <ellipse class="glow" cx="0" cy="-16" rx="9" ry="13" fill="rgba(255,196,80,.4)" style="animation-delay:${delay}"/>
    <rect x="-6.5" y="-11" width="13" height="21" rx="3" fill="#fff3d6" opacity="0.92" stroke="rgba(255,255,255,.5)" stroke-width="0.8"/>
    <rect x="-6.5" y="-11" width="13" height="7" rx="3" fill="rgba(255,170,50,.55)"/>
    <ellipse cx="0" cy="10" rx="6.5" ry="2" fill="#e0cba0"/>
    <g class="flame" style="animation-delay:${delay}">
      <path d="M0,-24 C 3.2,-18 3.2,-13.5 0,-11.5 C -3.2,-13.5 -3.2,-18 0,-24 Z" fill="#ffb61e"/>
      <path d="M0,-20.5 C 1.7,-16.5 1.7,-13.8 0,-12.3 C -1.7,-13.8 -1.7,-16.5 0,-20.5 Z" fill="#fff3c4"/>
    </g>
  </g>`;
}

/* ---- a sagging string of papel picado (cut-paper) banners ---- */
function papelPicado(x0, y0, x1, y1, sag, cols, delay) {
  const cx = (x0 + x1) / 2, cy = (y0 + y1) / 2 + sag;
  const n = Math.max(5, Math.round(Math.hypot(x1 - x0, y1 - y0) / 26));
  let panels = '';
  for (let i = 1; i < n; i++) {
    const t = i / n;
    const bx = (1 - t) * (1 - t) * x0 + 2 * (1 - t) * t * cx + t * t * x1;
    const by = (1 - t) * (1 - t) * y0 + 2 * (1 - t) * t * cy + t * t * y1;
    const c = cols[i % cols.length];
    panels += `<g transform="translate(${bx.toFixed(1)},${by.toFixed(1)})">
      <path d="M-10,0 L10,0 L10,15 L7.5,19 L5,15 L2.5,19 L0,15 L-2.5,19 L-5,15 L-7.5,19 L-10,15 Z" fill="${c}"/>
      <g fill="rgba(255,255,255,.5)"><circle cx="0" cy="5.5" r="2.1"/><circle cx="-4.6" cy="8.5" r="1"/><circle cx="4.6" cy="8.5" r="1"/><path d="M0,9.5 l1.9,2.4 -1.9,2.4 -1.9,-2.4 Z"/></g>
    </g>`;
  }
  return `<g class="bunting" style="animation-delay:${delay}s">
    <path d="M${x0},${y0} Q ${cx},${cy} ${x1},${y1}" stroke="rgba(255,255,255,.5)" stroke-width="1.2" fill="none"/>
    ${panels}
  </g>`;
}

/* ---- a decorated calavera (sugar skull): flower-filled eye sockets, a
        forehead bloom, temple scrolls, stitched grin and a beaded crown ---- */
function sugarSkull(x, y, s, pal) {
  const ink = '#3a2540', white = '#fbf7ff', A = pal.a, B = pal.b, C = pal.c;
  let beads = '';
  for (let k = 0; k <= 10; k++) {
    const ang = (200 + 140 * k / 10) * Math.PI / 180;
    beads += `<circle cx="${(Math.cos(ang) * 39).toFixed(1)}" cy="${(Math.sin(ang) * 46 - 6).toFixed(1)}" r="1.9" fill="${k % 2 ? A : C}"/>`;
  }
  const eye = (ex) => {
    let p = '';
    for (let i = 0; i < 8; i++) p += `<g transform="rotate(${45 * i})"><ellipse cx="0" cy="-8.2" rx="2.1" ry="3.6" fill="${B}"/></g>`;
    return `<g transform="translate(${ex},-13)"><circle r="12.5" fill="${A}"/>${p}<circle r="4.2" fill="${white}"/><circle r="2" fill="${B}"/></g>`;
  };
  let teeth = '';
  for (let i = -4; i <= 4; i++) teeth += `<line x1="${i * 5}" y1="20" x2="${i * 5}" y2="33" stroke="${ink}" stroke-width="1.9" stroke-linecap="round"/>`;
  return `<g transform="translate(${x},${y}) scale(${s})"><g class="turkey" style="animation-delay:${(Math.random() * 1.2).toFixed(2)}s">
    <path d="M0,-58 C 30,-58 45,-40 45,-14 C 45,-2 41,8 34,15 C 33,26 27,34 19,39 C 16,45 10,49 0,49 C -10,49 -16,45 -19,39 C -27,34 -33,26 -34,15 C -41,8 -45,-2 -45,-14 C -45,-40 -30,-58 0,-58 Z" fill="${white}" stroke="${ink}" stroke-width="2.4"/>
    ${beads}
    <g transform="translate(0,-44) scale(0.9)">${flower6(C, A)}</g>
    <path d="M-33,-24 q-6,4 -3,11 q4,-2 3,-8" fill="none" stroke="${B}" stroke-width="1.8" stroke-linecap="round"/>
    <path d="M33,-24 q6,4 3,11 q-4,-2 -3,-8" fill="none" stroke="${B}" stroke-width="1.8" stroke-linecap="round"/>
    ${eye(-19)}${eye(19)}
    <path d="M0,16 C -4.5,9 -5.5,4 -2.8,2 C -1,0.7 0,2.4 0,4.2 C 0,2.4 1,0.7 2.8,2 C 5.5,4 4.5,9 0,16 Z" fill="${ink}"/>
    <path d="M-22,26 Q0,30 22,26" fill="none" stroke="${ink}" stroke-width="2.4" stroke-linecap="round"/>
    ${teeth}
    <circle cx="-30" cy="9" r="3.4" fill="${A}" opacity="0.55"/>
    <circle cx="30" cy="9" r="3.4" fill="${A}" opacity="0.55"/>
  </g></g>`;
}

/* ---- Día de Muertos: an ofrenda by twilight — the mark framed by a
        cempasúchil arch, papel picado overhead, flower-eyed calaveras,
        veladora candles, marigolds and drifting petals ---- */
function diaDeMuertosScene() {
  const petCols = ['#f2721c', '#ffb61e', '#e5227a', '#d9540c'];
  const papCols = ['#e5227a', '#f7931e', '#26c6c6', '#ffd23c', '#7b3fb5', '#2fb457'];
  const skullPals = [{ a: '#e5227a', b: '#26c6c6', c: '#ffd23c' }, { a: '#7b3fb5', b: '#f7931e', c: '#2fb457' }, { a: '#2a7de1', b: '#e5227a', c: '#ffd23c' }];
  const rp = (a) => a[Math.floor(Math.random() * a.length)];

  let stars = '';
  for (let i = 0; i < 14; i++) {
    const x = rnd(10, 350), y = rnd(6, 70), r = rnd(0.7, 1.7), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="${i % 3 ? '#fff' : '#ffd88a'}" style="animation-delay:${d.toFixed(2)}s"/>`;
  }
  let petals = '';
  for (let i = 0; i < 16; i++) {
    const x = rnd(10, 350), dur = rnd(4.5, 8), delay = -rnd(0, dur), r = rnd(1.8, 3.2), c = petCols[i % petCols.length];
    petals += `<g transform="translate(${x.toFixed(1)},0)"><g class="petal" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><ellipse rx="${r.toFixed(1)}" ry="${(r * 0.55).toFixed(1)}" fill="${c}"/></g></g>`;
  }
  const papel = papelPicado(-10, 30, 185, 24, 10, papCols, 0) + papelPicado(185, 24, 370, 32, 12, papCols, 0.7)
    + papelPicado(-8, 12, 190, 6, 8, papCols, 0.4) + papelPicado(190, 6, 368, 14, 10, papCols, 1.1);
  const arch = marigoldSwag(58, 94, 302, 94, -48, 0.2);
  const sideG = marigoldSwag(-8, 150, 86, 150, 16, 0.6) + marigoldSwag(274, 150, 368, 150, 16, 0.9);

  let hem = '';
  for (let hx = 370; hx > -10; hx -= 15) hem += `Q ${(hx - 7.5).toFixed(0)},204 ${(hx - 15)},197 `;
  const altar = `<path d="M-10,196 H370 V220 H-10 Z" fill="#160a26"/>`
    + `<path d="M-10,187 H370 V197 ${hem} Z" fill="#4a1442"/>`
    + `<line x1="-10" y1="187" x2="370" y2="187" stroke="#f7931e" stroke-width="1.4" opacity="0.7"/>`;

  let blooms = '';
  [[46, 196, 0.75], [110, 199, 0.6], [250, 199, 0.6], [314, 196, 0.75], [180, 207, 0.85], [150, 203, 0.5], [210, 203, 0.5]].forEach(([bx, by, bs]) => { blooms += mxMarigold(bx, by, bs); });

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Día de Muertos ofrenda — a marigold arch, papel picado, decorated sugar skulls and flickering candles">
    <defs><linearGradient id="skyMx1" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#241038"/><stop offset="0.55" stop-color="#45184f"/><stop offset="1" stop-color="#7a2a48"/>
    </linearGradient></defs>
    <rect width="360" height="220" fill="url(#skyMx1)"/>
    ${stars}
    ${arch}
    ${papel}
    ${altar}
    ${sideG}
    ${sugarSkull(84, 158, 0.6, rp(skullPals))}
    ${sugarSkull(276, 158, 0.6, rp(skullPals))}
    ${veladora(126, 197, 0.95, '0s')}
    ${veladora(234, 197, 0.95, '0.5s')}
    ${veladora(150, 200, 0.72, '0.9s')}
    ${veladora(210, 200, 0.72, '0.3s')}
    ${blooms}
    ${petals}
  </svg>`;
}

/* ---- the eagle-and-serpent coat of arms, compact for the flag centre ---- */
function mexEmblem() {
  return `<g>
    <g fill="#3f7a4f"><ellipse cx="-5" cy="15" rx="4" ry="7"/><ellipse cx="5" cy="14" rx="4" ry="7"/><ellipse cx="0" cy="17" rx="5.5" ry="6"/></g>
    <path d="M2,5 L9,19 L6,19 L4,10 L2,19 L-1,17 Z" fill="#5a3a16"/>
    <path d="M-2,-6 C 6,-6 9,3 4,10 C 0,15 -6,12 -7,4 C -7.5,-1 -6,-6 -2,-6 Z" fill="#7a4a1e"/>
    <path d="M2,-3 C 8,-11 15,-13 19,-11 C 14,-6 10,0 6,4 Z" fill="#8a5a24"/>
    <path d="M-2,0 C -8,-6 -14,-6 -17,-3 C -12,-1 -8,4 -4,6 Z" fill="#6d4218"/>
    <path d="M0,2 C 5,-4 11,-6 15,-5" stroke="#caa23a" stroke-width="0.7" fill="none"/>
    <circle cx="-6" cy="-6" r="3" fill="#6d4218"/>
    <path d="M-8,-6 L-13.5,-4.8 L-8,-3 Z" fill="#e0a83a"/>
    <path d="M-13.5,-4.8 q-4,-2.5 -7.5,0.5 q-3,2.4 -6,0.2" stroke="#2fa35a" stroke-width="1.5" fill="none" stroke-linecap="round"/>
    <circle cx="-6.4" cy="-6.6" r="0.7" fill="#203018"/>
    <path d="M-11,20 Q0,27 11,20" fill="none" stroke="#3f7a4f" stroke-width="1.4"/>
    <path d="M-9,20 l-2,4 M9,20 l2,4" stroke="#ce1126" stroke-width="1.4" stroke-linecap="round"/>
  </g>`;
}

/* ---- the Catedral Metropolitana silhouette on the Zócalo ---- */
function catedral(x, gy, s) {
  const c = '#160b28';
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <g fill="${c}">
      <rect x="-40" y="-30" width="80" height="30"/>
      <rect x="-46" y="-44" width="16" height="44"/><rect x="30" y="-44" width="16" height="44"/>
      <rect x="-45" y="-56" width="14" height="12"/><rect x="31" y="-56" width="14" height="12"/>
      <path d="M-45,-56 L-38,-66 L-31,-56 Z"/><path d="M31,-56 L38,-66 L45,-56 Z"/>
      <rect x="-10" y="-46" width="20" height="16"/><path d="M-14,-46 Q0,-62 14,-46 Z"/>
      <circle cx="0" cy="-52" r="6"/><line x1="0" y1="-58" x2="0" y2="-64" stroke="${c}" stroke-width="2"/>
    </g>
    <g fill="#f7b53c" opacity="0.85"><rect x="-42" y="-24" width="4" height="8"/><rect x="35" y="-24" width="4" height="8"/><rect x="-3" y="-22" width="6" height="12" rx="3"/></g>
  </g>`;
}

/* ---- the Ángel de la Independencia — golden Victory glowing atop her column ---- */
function angelColumn(x, gy, s) {
  return `<g transform="translate(${x},${gy}) scale(${s})">
    <ellipse class="glow" cx="0" cy="-104" rx="22" ry="26" fill="rgba(255,205,90,.4)"/>
    <rect x="-15" y="-10" width="30" height="10" fill="#b9b09a"/>
    <rect x="-11" y="-20" width="22" height="10" fill="#cfc6ae"/>
    <rect x="-5.5" y="-88" width="11" height="68" fill="#e6dfc8"/>
    <rect x="-5.5" y="-88" width="3.4" height="68" fill="rgba(255,255,255,.45)"/>
    <rect x="-7.5" y="-94" width="15" height="6" fill="#cfc6ae"/>
    <g fill="#e0b23a">
      <path d="M-2,-96 C -11,-101 -15,-96 -13,-89 C -9,-92 -5,-92 -3,-93 Z"/>
      <path d="M2,-96 C 11,-101 15,-96 13,-89 C 9,-92 5,-92 3,-93 Z"/>
      <path d="M0,-98 C -4,-95 -4,-89 -2,-87 L2,-87 C 4,-89 4,-95 0,-98 Z"/>
      <circle cx="0" cy="-102" r="3.2"/>
      <path d="M0,-99 L-11,-106" stroke="#e0b23a" stroke-width="2.2" stroke-linecap="round"/>
      <circle cx="-12" cy="-107" r="3" fill="none" stroke="#e0b23a" stroke-width="1.6"/>
      <path d="M0,-99 L9,-107" stroke="#e0b23a" stroke-width="1.8" stroke-linecap="round"/>
    </g>
  </g>`;
}

/* ---- Independence Day (El Grito): the flag rippling under green-white-red
        fireworks, the Ángel de la Independencia and Catedral over the Zócalo,
        tricolour banners and confetti ---- */
function mexIndependenceScene() {
  const GRN = '#2fb457', RED = '#ce1126', GOLD = '#ffd23c';
  let stars = '';
  for (let i = 0; i < 18; i++) {
    const x = rnd(10, 350), y = rnd(6, 90), r = rnd(0.7, 1.7), d = rnd(0, 2.2);
    stars += `<circle class="twinkle" cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="${r.toFixed(1)}" fill="#fff" style="animation-delay:${d.toFixed(2)}s"/>`;
  }
  const FW = [[GRN, 250, 44, 0.0], ['#ffffff', 312, 92, 0.6], [RED, 104, 150, 1.1], [GOLD, 286, 168, 1.7], [GRN, 208, 64, 2.1]];
  const N = 15;
  const bursts = FW.map(([c, cx, cy, d]) => {
    let rays = '';
    for (let i = 0; i < N; i++) {
      const a = (i / N) * Math.PI * 2;
      rays += `<line x1="${(Math.cos(a) * 7).toFixed(1)}" y1="${(Math.sin(a) * 7).toFixed(1)}" x2="${(Math.cos(a) * 25).toFixed(1)}" y2="${(Math.sin(a) * 25).toFixed(1)}" stroke="${c}" stroke-width="1.6" stroke-linecap="round"/>`;
      rays += `<circle cx="${(Math.cos(a) * 29).toFixed(1)}" cy="${(Math.sin(a) * 29).toFixed(1)}" r="1.7" fill="${c}"/>`;
    }
    return `<g transform="translate(${cx},${cy})"><g class="fw" style="animation-delay:${d}s">${rays}</g></g>`;
  }).join('');

  const banners = pennantSwag(-8, 16, 182, 10, 12, [GRN, '#f4f7fa', RED], 0) + pennantSwag(182, 10, 368, 18, 14, [RED, '#f4f7fa', GRN], 0.8);

  let confetti = '';
  for (let i = 0; i < 26; i++) {
    const x = rnd(12, 348), c = i % 3 === 0 ? GRN : (i % 3 === 1 ? '#f4f7fa' : RED), dur = rnd(3.8, 6.5), delay = -rnd(0, dur), w = rnd(4, 6.5);
    confetti += `<g transform="translate(${x.toFixed(1)},0)"><g class="confetti" style="animation-duration:${dur.toFixed(2)}s;animation-delay:${delay.toFixed(2)}s"><rect x="${(-w / 2).toFixed(1)}" y="-2" width="${w.toFixed(1)}" height="3.4" rx="1" fill="${c}"/></g></g>`;
  }

  // the flag: vertical tricolour 3:2 with the coat of arms centred
  const W = 150, H = 100;
  let cloth = `<rect width="${W / 3}" height="${H}" fill="#006847"/><rect x="${W / 3}" width="${W / 3}" height="${H}" fill="#f4f7fa"/><rect x="${2 * W / 3}" width="${W / 3}" height="${H}" fill="#ce1126"/>`;
  cloth += `<g transform="translate(${W / 2},${H / 2}) scale(1.7)">${mexEmblem()}</g>`;
  cloth += `<rect width="${W}" height="${H}" fill="none" stroke="rgba(16,35,56,.22)" stroke-width="0.6"/>`;
  const S = 20, SW = W / S;
  let clips = '', strips = '';
  for (let i = 0; i < S; i++) {
    clips += `<clipPath id="mxcp${i}"><rect x="${(i * SW).toFixed(2)}" y="-8" width="${(SW + 0.05).toFixed(2)}" height="${H + 16}"/></clipPath>`;
    const amp = (2.7 * Math.pow(i / (S - 1), 1.6)).toFixed(2);
    strips += `<g clip-path="url(#mxcp${i})"><use href="#mxflagG" class="flagStrip" style="--amp:${amp}px;animation-delay:${(-i * 0.085).toFixed(2)}s"/></g>`;
  }

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Mexican Independence Day — the flag waving under fireworks by the Ángel de la Independencia">
    <defs>
      <linearGradient id="skyMx2" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#0c1a38"/><stop offset="0.55" stop-color="#22366a"/><stop offset="1" stop-color="#52306a"/></linearGradient>
      <g id="mxflagG">${cloth}</g>
      ${clips}
    </defs>
    <rect width="360" height="220" fill="url(#skyMx2)"/>
    ${stars}
    ${bursts}
    ${catedral(148, 196, 0.92)}
    ${angelColumn(300, 170, 0.92)}
    ${banners}
    ${confetti}
    <path d="M-10,196 Q 180,188 370,196 V 220 H -10 Z" fill="#140b28"/>
    <path d="M-10,206 Q 180,199 370,206 V 220 H -10 Z" fill="#0e0820"/>
    <line x1="44" y1="212" x2="44" y2="12" stroke="#c9cdd6" stroke-width="2.6" stroke-linecap="round"/>
    <circle cx="44" cy="10" r="3" fill="${GOLD}"/>
    <g transform="translate(45,18)">${strips}</g>
  </svg>`;
}

/* ---- International Women's Day: the venus-with-raised-fist emblem framed by
        rising mimosa blossoms and sparkle-petals over a purple-to-white wash ----
   Sibling of the April-1st unicorn / Valentine loader. Traits are rolled per
   render — background tint, petal density, emblem accent colour. Gradient ids
   are salted per call so simultaneously-rendered thumbnails keep their own
   rolls, and every element positions on an outer <g> while its motion class
   lives on a nested inner <g> (a bare transform attribute + animation class on
   the same node would be overridden by the animation). */
function iwdScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'w' + Math.random().toString(36).slice(2, 7);

  const TINTS = {
    orchid: ['#8e24aa', '#d3a4e0', '#fff6fb'],
    plum:   ['#6a1b9a', '#b79bdd', '#f4ecfb'],
    violet: ['#7b1fa2', '#c9a2e4', '#fbf4ff'],
  };
  const ACCENTS = {
    rose:   { ring: '#ef6ea6', heart: '#5a2b9a' },
    orchid: { ring: '#c774d4', heart: '#4a148c' },
    violet: { ring: '#a982e0', heart: '#3f1a78' },
  };
  const tint = TINTS[pick(Object.keys(TINTS))];
  const acc  = ACCENTS[pick(Object.keys(ACCENTS))];
  const density = pick([5, 8, 8, 12]);
  const GREEN = '#43a047', DGREEN = '#2e7d32', YEL = '#ffd24d', DYEL = '#f0ad2e';

  // ---- the venus emblem (ring + cross) cradling a heart, centred on (0,0) ----
  const heartPath = (s) => { const k = s/60, P = (n) => (n*k).toFixed(2);
    return `M${P(0)},${P(38)} C ${P(-52)},${P(6)} ${P(-52)},${P(-40)} ${P(-24)},${P(-40)}`
         + ` C ${P(-8)},${P(-40)} ${P(-2)},${P(-26)} ${P(0)},${P(-18)}`
         + ` C ${P(2)},${P(-26)} ${P(8)},${P(-40)} ${P(24)},${P(-40)}`
         + ` C ${P(52)},${P(-40)} ${P(52)},${P(6)} ${P(0)},${P(38)} Z`; };
  const emblem =
      `<circle cx="0" cy="0" r="30" fill="url(#${uid}halo)"/>`
    + `<circle cx="0" cy="0" r="35.5" fill="none" stroke="${acc.ring}" stroke-width="1.6" opacity=".38"/>`
    + `<circle cx="0" cy="0" r="32" fill="none" stroke="${acc.ring}" stroke-width="7"/>`
    + `<circle cx="0" cy="0" r="28.5" fill="none" stroke="#fff" stroke-width="1.4" opacity=".5"/>`
    // the heart cradled inside the ring
    + `<g transform="translate(0,-3)">`
      + `<path d="${heartPath(28)}" fill="url(#${uid}heart)" stroke="${acc.heart}" stroke-width="1.4" stroke-linejoin="round"/>`
      + `<ellipse cx="-6" cy="-7" rx="5.2" ry="3" transform="rotate(-26 -6 -7)" fill="#fff" opacity=".38"/>`
      + `<circle cx="4" cy="-9" r="1.8" fill="#fff" opacity=".5"/>`
    + `</g>`
    // the venus cross below the ring
    + `<g stroke="${acc.ring}" stroke-width="6" stroke-linecap="round">`
      + `<line x1="0" y1="32" x2="0" y2="49"/>`
      + `<line x1="-9" y1="40.5" x2="9" y2="40.5"/>`
    + `</g>`;
  const emblemG = `<g transform="translate(180,42)"><g class="iwd-reveal"><g class="iwd-breathe">${emblem}</g></g></g>`;

  // ---- mimosa sprig: green stem + leaflets + a cluster of tiny yellow buds ----
  const mimosa = (x, y, s, rot, delay) => {
    const budPos = [[0,-3],[5,-6],[-5,-5],[9,-10],[-9,-9],[3,-12],[-3,-13],[12,-4],[-12,-3],[0,-17],[7,-16],[-7,-16],[10,-14],[-10,-13]];
    let buds = '';
    budPos.forEach(([bx,by],i) => { buds += `<circle cx="${bx}" cy="${by}" r="2.7" fill="${i%3===0?DYEL:YEL}"/>`; });
    return `<g transform="translate(${x},${y}) rotate(${rot}) scale(${s})">`
      + `<g class="iwd-sway" style="animation-delay:${delay}s">`
      + `<path d="M0,28 C -3,16 3,7 0,-3" fill="none" stroke="${GREEN}" stroke-width="2.6" stroke-linecap="round"/>`
      + `<g stroke="${DGREEN}" stroke-width="1.3" stroke-linecap="round" fill="none">`
        + `<path d="M0,22 q-8,-1 -12,-7"/><path d="M0,17 q8,-1 12,-7"/><path d="M0,11 q-7,-1 -10,-6"/><path d="M0,6 q7,-1 10,-6"/>`
      + `</g>`
      + `<g>${buds}</g>`
      + `</g></g>`;
  };
  const sprigs = mimosa(46,206,1.55,-9,0) + mimosa(316,210,1.65,11,.4)
    + mimosa(20,150,0.95,-20,.8) + mimosa(342,158,1.0,19,1.2);

  // ---- rising sparkle-petals + drifting mimosa buds ----
  const shapeFor = (kind, sz) => {
    if (kind === 'sparkle') {
      const b = (sz*0.3).toFixed(1);
      return `<path d="M0,-${sz} L${b},-${b} L${sz},0 L${b},${b} L0,${sz} L-${b},${b} L-${sz},0 L-${b},-${b} Z" fill="url(#${uid}spk)"/>`;
    }
    if (kind === 'bud') {
      return `<g fill="${YEL}"><circle cx="0" cy="0" r="2.4"/><circle cx="3.2" cy="-1.6" r="2.1"/><circle cx="-3" cy="-1.4" r="2.1"/><circle cx="1.4" cy="2.6" r="1.9" fill="${DYEL}"/><circle cx="-1.8" cy="2.4" r="1.9" fill="${DYEL}"/></g>`;
    }
    return `<ellipse rx="${(sz*0.5).toFixed(1)}" ry="${sz}" transform="rotate(28)" fill="url(#${uid}petal)"/>`;
  };
  let parts = '';
  for (let i = 0; i < density; i++) {
    const x = (density > 1) ? Math.round(24 + (312/(density-1))*i + rnd(-14,14)) : 180;
    const y = Math.round(rnd(196,214));
    const sz = +rnd(4.5,8).toFixed(1);
    const d = +rnd(0,6.5).toFixed(2);
    const dur = +rnd(6,9).toFixed(2);
    const kind = pick(['sparkle','petal','bud','petal','bud']);
    parts += `<g transform="translate(${x},${y})"><g class="iwd-petal" style="animation-delay:${d}s;animation-duration:${dur}s">${shapeFor(kind,sz)}</g></g>`;
  }

  // ---- foreground twinkles (kept clear of the centred badge) ----
  const TW = [[50,52,5,0],[310,60,6,.6],[300,158,4.5,1.1],[60,160,4,1.6]];
  const tw = TW.map(([x,y,s,dl]) => {
    const b = (s*0.3).toFixed(1);
    return `<g transform="translate(${x},${y})"><g class="iwd-twinkle" style="animation-delay:${dl}s">`
      + `<path d="M0,-${s} L${b},-${b} L${s},0 L${b},${b} L0,${s} L-${b},${b} L-${s},0 L-${b},-${b} Z" fill="#fff"/></g></g>`;
  }).join('');

  // ---- secondary background motion: slow-drifting soft light orbs ----
  const orbs = `<g transform="translate(70,80)"><g class="iwd-orb"><circle r="26" fill="url(#${uid}orb)"/></g></g>`
    + `<g transform="translate(292,96)"><g class="iwd-orb" style="animation-delay:-4s"><circle r="20" fill="url(#${uid}orb)"/></g></g>`
    + `<g transform="translate(150,38)"><g class="iwd-orb" style="animation-delay:-8s"><circle r="15" fill="url(#${uid}orb)"/></g></g>`;

  // ---- pulsing radial glow behind the badge ----
  const glow = `<g transform="translate(180,121)"><g class="iwd-glow"><ellipse rx="94" ry="82" fill="url(#${uid}g)"/></g></g>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="An International Women's Day emblem with rising blossoms.">
    <defs>
      <linearGradient id="${uid}sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${tint[0]}"/><stop offset="0.55" stop-color="${tint[1]}"/><stop offset="1" stop-color="${tint[2]}"/>
      </linearGradient>
      <linearGradient id="${uid}heart" x1="0" y1="0" x2="0.25" y2="1">
        <stop offset="0" stop-color="#7e5bbe"/><stop offset="1" stop-color="${acc.heart}"/>
      </linearGradient>
      <linearGradient id="${uid}petal" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffffff" stop-opacity=".95"/><stop offset="1" stop-color="#d9b8ec" stop-opacity=".7"/>
      </linearGradient>
      <linearGradient id="${uid}spk" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#fff7d6"/><stop offset="1" stop-color="#ffd24d"/>
      </linearGradient>
      <radialGradient id="${uid}g" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#ffffff" stop-opacity=".85"/><stop offset="0.5" stop-color="#f0d9ff" stop-opacity=".4"/><stop offset="1" stop-color="#f0d9ff" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="${uid}halo" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#ffffff" stop-opacity=".92"/><stop offset="0.7" stop-color="#ffffff" stop-opacity=".5"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="${uid}orb" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#ffffff" stop-opacity=".5"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <rect width="360" height="220" fill="url(#${uid}sky)"/>
    ${orbs}
    ${glow}
    ${sprigs}
    ${parts}
    ${emblemG}
    ${tw}
  </svg>`;
}

/* ---- Valentine's Day: a rosy sky of drifting hearts framing the BARE mark ----
   Sibling of the April-1st unicorn. Traits are rolled per render — sky
   (blush/dusk/cream), heart palette, particle shape (heart/sparkle/petal),
   solo vs. paired hero, love-note type and facing. Gradient ids are salted
   per call so simultaneously-rendered thumbnails keep their own rolls. */
function valentineScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'v' + Math.random().toString(36).slice(2, 7);
  const BERRY = '#7a2540';

  const SKIES = {
    blush: ['#ffc2d8', '#ffe0e9', '#fff4ec'],
    dusk:  ['#b98ad0', '#ff9db9', '#ffd8c9'],
    cream: ['#ffe9c7', '#ffdfe1', '#fff3f0'],
  };
  const PALS = {
    rose:    ['#ffa6c2', '#ff5b8a', '#c94f6d'],
    crimson: ['#ff8098', '#e8476b', '#a83553'],
    blush:   ['#ffc2d4', '#ff8fb0', '#df6a8c'],
    punch:   ['#ff9bb0', '#ff6f8f', '#c24d6a'],
  };
  const sky  = SKIES[pick(Object.keys(SKIES))];
  const pal  = PALS[pick(Object.keys(PALS))];
  const part = pick(['heart', 'sparkle', 'petal']);
  const duo  = Math.random() < 0.5;
  const note = pick(['envelope', 'plane']);

  // heart path centred in an s-radius box
  const heart = (s) => {
    const k = s / 60, P = (n) => (n * k).toFixed(2);
    return `M${P(0)},${P(38)} C ${P(-52)},${P(6)} ${P(-52)},${P(-40)} ${P(-24)},${P(-40)}`
         + ` C ${P(-8)},${P(-40)} ${P(-2)},${P(-26)} ${P(0)},${P(-18)}`
         + ` C ${P(2)},${P(-26)} ${P(8)},${P(-40)} ${P(24)},${P(-40)}`
         + ` C ${P(52)},${P(-40)} ${P(52)},${P(6)} ${P(0)},${P(38)} Z`;
  };
  const star = (s) => { const b = (s * 0.28).toFixed(2), S = s.toFixed(2);
    return `M0,-${S} L${b},-${b} L${S},0 L${b},${b} L0,${S} L-${b},${b} L-${S},0 L-${b},-${b} Z`; };

  // a plump heart CHARACTER: gradient fill, gloss, cheek blush, sweet face
  const heartChar = (scale, rot) =>
    `<g transform="scale(${scale}) rotate(${rot})">`
    + `<path d="${heart(46)}" fill="url(#${uid}h)" stroke="${pal[2]}" stroke-width="2.5" stroke-linejoin="round"/>`
    + `<ellipse cx="-15" cy="-20" rx="12" ry="8" transform="rotate(-24 -15 -20)" fill="#fff" opacity=".38"/>`
    + `<circle cx="7" cy="-24" r="3.4" fill="#fff" opacity=".55"/>`
    + `<ellipse cx="-20" cy="4" rx="7" ry="4.5" fill="${pal[2]}" opacity=".4"/>`
    + `<ellipse cx="20" cy="4" rx="7" ry="4.5" fill="${pal[2]}" opacity=".4"/>`
    + `<path d="M-16,-6 q6,7 12,0" fill="none" stroke="${BERRY}" stroke-width="2.6" stroke-linecap="round"/>`
    + `<path d="M4,-6 q6,7 12,0" fill="none" stroke="${BERRY}" stroke-width="2.6" stroke-linecap="round"/>`
    + `<path d="M-6,7 q6,5 12,0" fill="none" stroke="${BERRY}" stroke-width="2.2" stroke-linecap="round"/>`
    + `</g>`;

  // hero: a pair of hearts flanking the mark, or a single offset hero — both
  // kept clear of the centred BARE badge, each beating on its own centre
  let hero;
  if (duo) {
    hero = `<g transform="translate(78,132)"><g class="val-glow"><ellipse cx="0" cy="0" rx="52" ry="46" fill="url(#${uid}g)"/></g><g class="val-beat">${heartChar(0.82, 9)}</g></g>`
         + `<g transform="translate(282,132)"><g class="val-glow" style="animation-delay:.2s"><ellipse cx="0" cy="0" rx="52" ry="46" fill="url(#${uid}g)"/></g><g class="val-beat" style="animation-delay:.2s">${heartChar(0.82, -9)}</g></g>`;
  } else {
    hero = `<g transform="translate(86,138)"><g class="val-bob"><g class="val-glow"><ellipse cx="0" cy="0" rx="64" ry="56" fill="url(#${uid}g)"/></g><g class="val-beat">${heartChar(1.05, 6)}</g></g></g>`;
  }

  // rising background particles across the lower band
  const PARTS = [[46,200,7,0,6.5],[250,205,5,1.6,7.4],[150,210,9,3.1,6],[312,200,6,2.3,8],[24,205,5,4.4,7],[206,208,7,.9,6.8]];
  const particles = PARTS.map(([x,y,s,d,dur]) => {
    let shape;
    if (part === 'sparkle') shape = `<path d="${star(s)}" fill="url(#${uid}p)"/>`;
    else if (part === 'petal') shape = `<ellipse rx="${(s*0.55).toFixed(1)}" ry="${s}" transform="rotate(35)" fill="url(#${uid}p)"/>`;
    else shape = `<path d="${heart(s*1.1)}" fill="url(#${uid}p)"/>`;
    return `<g class="val-part" transform="translate(${x},${y})" style="animation-delay:${d}s;animation-duration:${dur}s">${shape}</g>`;
  }).join('');

  // dotted Cupid's-arrow trail rising toward a heart-tipped arrowhead
  const TRAIL = [[40,186],[68,172],[96,162],[124,156],[152,154]];
  const trail = TRAIL.map(([x,y],i) =>
    `<g class="val-trail-dot" style="animation-delay:${(i*0.3).toFixed(2)}s"><circle cx="${x}" cy="${y}" r="3.6" fill="#c94f6d"/></g>`).join('')
    + `<g class="val-trail-tip" style="animation-delay:${(TRAIL.length*0.3).toFixed(2)}s" transform="translate(178,152) rotate(-22)">`
    + `<path d="M0,0 L-15,-7 M0,0 L-15,7 M0,0 L-19,0" stroke="#c94f6d" stroke-width="3.6" stroke-linecap="round" fill="none"/>`
    + `<path d="${heart(13)}" transform="translate(-3,0)" fill="#ff5b8a" stroke="#c94f6d" stroke-width="1.6"/></g>`;

  // love-note gliding across the upper sky (envelope or paper plane)
  const noteArt = note === 'plane'
    ? `<path d="M-16,-9 L18,0 L-16,9 L-9,0 Z" fill="#fff" stroke="${BERRY}" stroke-width="1.4" stroke-linejoin="round"/>`
      + `<path d="M-16,-9 L-2,1 L-16,9 Z" fill="#ffd7e0" stroke="${BERRY}" stroke-width="1.4" stroke-linejoin="round"/>`
    : `<rect x="-17" y="-11" width="34" height="22" rx="3" fill="#fff" stroke="${BERRY}" stroke-width="1.4"/>`
      + `<path d="M-17,-9 L0,4 L17,-9" fill="none" stroke="${BERRY}" stroke-width="1.4" stroke-linejoin="round"/>`
      + `<path d="${heart(9)}" transform="translate(0,2) scale(.5)" fill="#ff5b8a"/>`;
  const loveNote = `<g class="val-note"><g transform="translate(0,46)"><g class="val-note-wob">${noteArt}</g></g></g>`;

  // foreground twinkling sparkles (kept off the centred badge)
  const SPARKS = [[52,54,5,0],[306,70,6,.5],[286,150,4,1],[70,96,4,1.5]];
  const sparks = SPARKS.map(([x,y,s,d]) =>
    `<g class="val-spark" transform="translate(${x},${y})" style="animation-delay:${d}s"><path d="${star(s)}" fill="#fff9e6"/></g>`).join('');

  const clouds = `<g class="val-cloud c1" fill="#fff" opacity=".85"><ellipse cx="0" cy="58" rx="26" ry="15"/><ellipse cx="22" cy="52" rx="20" ry="16"/><ellipse cx="42" cy="60" rx="22" ry="13"/></g>`
    + `<g class="val-cloud c2" fill="#fff" opacity=".72"><ellipse cx="0" cy="40" rx="20" ry="12"/><ellipse cx="18" cy="34" rx="16" ry="13"/><ellipse cx="34" cy="41" rx="18" ry="11"/></g>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="Hearts drifting across a Valentine's sky.">
    <defs>
      <linearGradient id="${uid}sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${sky[0]}"/><stop offset="0.56" stop-color="${sky[1]}"/><stop offset="1" stop-color="${sky[2]}"/>
      </linearGradient>
      <linearGradient id="${uid}h" x1="0" y1="0" x2="0.35" y2="1">
        <stop offset="0" stop-color="${pal[0]}"/><stop offset="0.55" stop-color="${pal[1]}"/><stop offset="1" stop-color="${pal[2]}"/>
      </linearGradient>
      <linearGradient id="${uid}p" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#ffe3ec" stop-opacity=".95"/><stop offset="1" stop-color="#ff8fb0" stop-opacity=".75"/>
      </linearGradient>
      <radialGradient id="${uid}g" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#fff0b0" stop-opacity=".9"/><stop offset="0.45" stop-color="#ffb8cf" stop-opacity=".55"/><stop offset="1" stop-color="#ffb8cf" stop-opacity="0"/>
      </radialGradient>
    </defs>
    <rect width="360" height="220" fill="url(#${uid}sky)"/>
    ${clouds}
    ${particles}
    ${trail}
    ${loveNote}
    ${hero}
    ${sparks}
  </svg>`;
}

/* ---- Earth Day (general): a rotating planet Earth over a green hill, with a
        growing seedling, drifting leaves, a soft sun and clean clouds. Traits
        are rolled per render — sky (dawn/day/dusk), the foreground base
        (cupped hands vs. a grassy tuft), and leaf shape/count. Gradient ids are
        salted per call so simultaneously-rendered thumbnails keep their own
        rolls. The believable globe spin is a wrapped horizontal scroll of clean
        continent silhouettes clipped to the disc — not a pinwheel rotation. ---- */
function earthDayScene() {
  const pick = (a) => a[Math.floor(Math.random() * a.length)];
  const uid  = 'e' + Math.random().toString(36).slice(2, 7);

  // rolled traits
  const SKIES = {
    dawn: { sky: ['#ffcf9e', '#a9d7ff', '#e8f6ff'], sun: ['#fff2c4', '#ffd24d'], stars: false },
    day:  { sky: ['#4aa8ff', '#8fd0ff', '#e6f6ff'], sun: ['#fffbe6', '#ffe27a'], stars: false },
    dusk: { sky: ['#26407a', '#6f6fae', '#ffb488'], sun: ['#ffd39a', '#ff8f4d'], stars: true  },
  };
  const s   = SKIES[pick(Object.keys(SKIES))];
  const base = pick(['hands', 'tuft', 'hands']);
  const leafKind = pick(['pointed', 'round']);
  const leafN = pick([6, 8, 8, 10]);

  const OCEAN = '#1e6fbf', OCEAN_HI = '#57b6ff';
  const G_LO = '#2e9e5b', G_HI = '#4fd1a5', G_DK = '#1f7a45';
  const SKIN = '#f0c39a', SKIN_DK = '#d99a6c';

  const CX = 180, CY = 58, R = 38, P = 76;

  // ---------- background twinkles (dusk only) ----------
  let twinkles = '';
  if (s.stars) {
    const TW = [[44,30,2.4,0],[96,20,1.8,.7],[300,26,2.6,.4],[262,16,1.7,1.1],[330,58,2,1.6],[70,64,1.6,2]];
    twinkles = TW.map(([x,y,r,d]) =>
      `<g transform="translate(${x},${y})"><g class="earth-twinkle" style="animation-delay:${d}s"><circle r="${r}" fill="#fff"/></g></g>`).join('');
  }

  // ---------- sun with a soft pulsing corona (top-right) ----------
  const sun = `<g transform="translate(312,40)"><g class="earth-sun">`
    + `<circle r="34" fill="url(#${uid}corona)"/>`
    + `<circle r="17" fill="url(#${uid}sun)"/>`
    + `<circle r="17" fill="none" stroke="#fff" stroke-width="1" opacity=".35"/>`
    + `</g></g>`;

  // ---------- clean drifting clouds ----------
  const cloud = (x, y, sc, op, dur, dl) =>
    `<g transform="translate(${x},${y}) scale(${sc})"><g class="earth-cloud" style="animation-duration:${dur}s;animation-delay:${dl}s" fill="#fff" opacity="${op}">`
    + `<ellipse cx="0" cy="4" rx="24" ry="12"/><ellipse cx="18" cy="-3" rx="17" ry="14"/><ellipse cx="36" cy="4" rx="20" ry="11"/><ellipse cx="-16" cy="6" rx="15" ry="9"/>`
    + `</g></g>`;
  const clouds = cloud(56, 40, 1, .92, 9, 0) + cloud(232, 30, .8, .8, 11, -3);

  // ---------- clean continent silhouettes (authored within ±36 of centre) ----------
  // approximate real continents, authored within one ~76-wide tile so the band
  // scrolls seamlessly (Pacific gap falls between Asia and the Americas).
  const continents =
      // The Americas — broad North America tapering through the isthmus to a
      // pointed South America (left third of the tile)
      `<path d="M-30,-28 C -22,-31 -14,-28 -15,-22 C -16,-17 -22,-16 -21,-11 C -20,-7 -15,-9 -14,-5 C -13,0 -17,1 -16,6 C -15,12 -10,15 -12,21 C -14,29 -20,30 -22,23 C -24,16 -20,12 -23,7 C -27,1 -30,-6 -29,-13 C -30,-19 -33,-24 -30,-28 Z" fill="url(#${uid}land)"/>`
      // Europe + Africa — a chunky central mass, Africa hanging below
    + `<path d="M1,-24 C 9,-26 15,-23 15,-18 C 20,-19 24,-15 21,-11 C 25,-7 24,0 19,2 C 21,9 16,18 9,20 C 3,25 -4,19 -3,12 C -8,9 -8,1 -3,-1 C -6,-9 -6,-20 1,-24 Z" fill="url(#${uid}land)"/>`
      // Asia — extends up and to the right of Eurasia
    + `<path d="M17,-25 C 29,-29 37,-21 33,-13 C 37,-10 34,-3 28,-5 C 23,-3 20,-9 21,-14 C 17,-17 15,-22 17,-25 Z" fill="url(#${uid}land)"/>`;
  // small islands — Australia (lower right), Indonesia, a northern isle
  const islands =
      `<path d="M28,15 C 33,13 37,16 35,20 C 32,24 26,23 25,19 C 25,16 26,16 28,15 Z" fill="url(#${uid}land)"/>`
    + `<circle cx="23" cy="10" r="2.1" fill="url(#${uid}land)"/><circle cx="8" cy="-29" r="2.4" fill="url(#${uid}land)"/>`;
  const landTile = (dx) => `<g transform="translate(${CX + dx},${CY})">${continents}${islands}</g>`;
  // clip on a STATIC wrapper (fixed to the globe); the band scrolls inside it —
  // otherwise the clip window slides with the animation and land drifts off.
  const band = `<g clip-path="url(#${uid}clip)"><g class="earth-spin">${[-P, 0, P].map(landTile).join('')}</g></g>`;

  // ---------- the globe: atmosphere halo, ocean, land, sphere shading, specular ----------
  const globe =
      `<g transform="translate(${CX},${CY})"><g class="earth-glow"><circle r="47" fill="url(#${uid}atmo)"/></g></g>`
    + `<circle cx="${CX}" cy="${CY}" r="${R}" fill="url(#${uid}ocean)"/>`
    + band
    + `<circle cx="${CX}" cy="${CY}" r="${R}" fill="url(#${uid}shade)"/>`
    + `<ellipse cx="${CX-13}" cy="${CY-15}" rx="14" ry="9" transform="rotate(-26 ${CX-13} ${CY-15})" fill="#fff" opacity=".22"/>`
    + `<circle cx="${CX}" cy="${CY}" r="${R}" fill="none" stroke="#cdeeff" stroke-width="1.3" opacity=".65"/>`;

  // ---------- orbiting accents (recycle glyph + sparkles), around the globe centre ----------
  const recycle = `<g transform="scale(.62)">`
    + [0, 120, 240].map((a) => `<g transform="rotate(${a})">`
        + `<path d="M0,-6 A6,6 0 0 1 5.2,3" fill="none" stroke="${G_DK}" stroke-width="2.4" stroke-linecap="round"/>`
        + `<path d="M5.2,3 l2.7,-1 l-3.3,-2.3 z" fill="${G_DK}"/></g>`).join('')
    + `</g>`;
  const spark = (c) => `<path d="M0,-5 L1.5,-1.5 L5,0 L1.5,1.5 L0,5 L-1.5,1.5 L-5,0 L-1.5,-1.5 Z" fill="${c}"/>`;
  const orbit = `<g class="earth-orbit" style="transform-box:view-box;transform-origin:${CX}px ${CY}px">`
    + `<g transform="translate(${CX},${CY - (R + 12)})">${recycle}</g>`
    + `<g transform="translate(${CX + (R + 12) * 0.87},${CY + (R + 12) * 0.5})">${spark('#ffd24d')}</g>`
    + `<g transform="translate(${CX - (R + 12) * 0.87},${CY + (R + 12) * 0.5})">${spark('#fff')}</g>`
    + `</g>`;

  // ---------- foreground hill ----------
  const hill = `<path d="M0,220 L0,198 Q120,180 180,182 Q240,184 360,198 L360,220 Z" fill="url(#${uid}hill)"/>`
    + `<path d="M0,220 L0,204 Q180,190 360,204 L360,220 Z" fill="url(#${uid}hill2)"/>`;

  // ---------- leaf shapes ----------
  const pointed = (L) => { const w = L * 0.5;
    return `M0,0 C ${-w},${-L*0.34} ${-w*0.42},${-L} 0,${-L} C ${w*0.42},${-L} ${w},${-L*0.34} 0,0 Z`; };
  const leafArt = (L, c) => leafKind === 'round'
    ? `<g><ellipse cx="0" cy="${-L*0.5}" rx="${L*0.42}" ry="${L*0.6}" fill="${c}"/><path d="M0,0 L0,${-L}" stroke="${G_DK}" stroke-width=".7" opacity=".45"/></g>`
    : `<g><path d="${pointed(L)}" fill="${c}"/><path d="M0,0 L0,${-L}" stroke="${G_DK}" stroke-width=".7" opacity=".5"/></g>`;

  // ---------- the growing seedling (shared by both bases) ----------
  const seedling = (yBase) =>
    `<g transform="translate(${CX},${yBase})"><g class="earth-grow">`
    + `<path d="M0,2 C -2,-14 2,-30 0,-45" fill="none" stroke="#2f8f4f" stroke-width="3.6" stroke-linecap="round"/>`
    + `<g transform="translate(-2,-18) rotate(-54)"><g class="earth-sway">${leafArt(18, G_HI)}</g></g>`
    + `<g transform="translate(2,-18) rotate(54)"><g class="earth-sway" style="animation-delay:.4s">${leafArt(18, G_LO)}</g></g>`
    + `<g transform="translate(-2,-32) rotate(-38)"><g class="earth-sway" style="animation-delay:.7s">${leafArt(13, G_HI)}</g></g>`
    + `<g transform="translate(2,-32) rotate(38)"><g class="earth-sway" style="animation-delay:.9s">${leafArt(13, G_LO)}</g></g>`
    + `<g transform="translate(0,-45) rotate(-4)"><g class="earth-sway" style="animation-delay:1.1s">${leafArt(11, G_HI)}</g></g>`
    + `</g></g>`;

  // ---------- foreground base: cupped hands, or a grassy tuft ----------
  let ground;
  if (base === 'hands') {
    // a symmetric pair of cupped palms — six finger scallops along the rim
    const bowl = `M-44,-4 C -44,-16 -38,-18 -34,-13 C -30,-19 -24,-19 -21,-13 C -17,-19 -11,-19 -8,-13`
      + ` C -4,-19 4,-19 8,-13 C 11,-19 17,-19 21,-13 C 24,-19 30,-19 34,-13 C 38,-18 44,-16 44,-4`
      + ` C 44,16 30,21 0,21 C -30,21 -44,16 -44,-4 Z`;
    ground = seedling(188)
      + `<g transform="translate(${CX},196)">`
        + `<ellipse cx="0" cy="17" rx="50" ry="8" fill="#0b2c48" opacity=".14"/>`
        + `<path d="${bowl}" fill="url(#${uid}skin)" stroke="${SKIN_DK}" stroke-width="1" stroke-linejoin="round"/>`
        + `<path d="M-30,-6 Q0,2 30,-6" fill="none" stroke="#fff" stroke-width="1.3" opacity=".3"/>`
        + `<line x1="0" y1="-12" x2="0" y2="18" stroke="${SKIN_DK}" stroke-width="1" opacity=".45"/>`
      + `</g>`;
  } else {
    ground = seedling(192)
      + `<g transform="translate(${CX},193)" stroke="${G_DK}" stroke-width="2" stroke-linecap="round" fill="none">`
        + `<path d="M-15,4 Q-19,-9 -15,-18"/><path d="M-8,4 Q-10,-11 -6,-22"/><path d="M8,4 Q10,-11 6,-22"/><path d="M15,4 Q19,-9 15,-18"/>`
      + `</g>`;
  }

  // ---------- drifting foreground leaves ----------
  const cols = [G_HI, G_LO, '#3fb371', '#7fd6a0'];
  let leaves = '';
  for (let i = 0; i < leafN; i++) {
    const x = Math.round((leafN > 1) ? 20 + (320 / (leafN - 1)) * i + rnd(-16, 16) : 180);
    const L = +rnd(9, 15).toFixed(1);
    const rot = Math.round(rnd(-40, 40));
    const dl = +rnd(0, 8).toFixed(2);
    const dur = +rnd(7, 11).toFixed(2);
    leaves += `<g transform="translate(${x},0)"><g class="earth-leaf" style="animation-delay:${dl}s;animation-duration:${dur}s">`
      + `<g transform="rotate(${rot})">${leafArt(L, pick(cols))}</g></g></g>`;
  }

  // ---------- soft glow behind the badge for cohesion ----------
  const centreGlow = `<g transform="translate(${CX},120)"><ellipse rx="72" ry="60" fill="url(#${uid}cglow)"/></g>`;

  return `<svg class="scene-svg" viewBox="0 0 360 220" preserveAspectRatio="xMidYMid slice" role="img" aria-label="A rotating Earth surrounded by drifting leaves.">
    <defs>
      <linearGradient id="${uid}sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${s.sky[0]}"/><stop offset="0.55" stop-color="${s.sky[1]}"/><stop offset="1" stop-color="${s.sky[2]}"/>
      </linearGradient>
      <linearGradient id="${uid}ocean" x1="0" y1="0" x2="0.3" y2="1">
        <stop offset="0" stop-color="${OCEAN_HI}"/><stop offset="0.55" stop-color="#2f8fe0"/><stop offset="1" stop-color="${OCEAN}"/>
      </linearGradient>
      <linearGradient id="${uid}land" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${G_HI}"/><stop offset="1" stop-color="${G_LO}"/>
      </linearGradient>
      <linearGradient id="${uid}hill" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#43b874"/><stop offset="1" stop-color="#2b8a52"/>
      </linearGradient>
      <linearGradient id="${uid}hill2" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#2e9e5b"/><stop offset="1" stop-color="#1f7a45"/>
      </linearGradient>
      <linearGradient id="${uid}skin" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="${SKIN}"/><stop offset="1" stop-color="${SKIN_DK}"/>
      </linearGradient>
      <radialGradient id="${uid}shade" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#08305c" stop-opacity="0"/><stop offset="0.66" stop-color="#08305c" stop-opacity="0"/><stop offset="1" stop-color="#062a52" stop-opacity=".55"/>
      </radialGradient>
      <radialGradient id="${uid}atmo" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#bfe9ff" stop-opacity="0"/><stop offset="0.78" stop-color="#bfe9ff" stop-opacity="0"/><stop offset="0.9" stop-color="#9fdcff" stop-opacity=".7"/><stop offset="1" stop-color="#9fdcff" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="${uid}sun" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="${s.sun[0]}"/><stop offset="1" stop-color="${s.sun[1]}"/>
      </radialGradient>
      <radialGradient id="${uid}corona" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="${s.sun[1]}" stop-opacity=".55"/><stop offset="1" stop-color="${s.sun[1]}" stop-opacity="0"/>
      </radialGradient>
      <radialGradient id="${uid}cglow" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stop-color="#ffffff" stop-opacity=".55"/><stop offset="0.55" stop-color="#eafff4" stop-opacity=".28"/><stop offset="1" stop-color="#eafff4" stop-opacity="0"/>
      </radialGradient>
      <clipPath id="${uid}clip"><circle cx="${CX}" cy="${CY}" r="${R}"/></clipPath>
    </defs>
    <rect width="360" height="220" fill="url(#${uid}sky)"/>
    ${twinkles}
    ${sun}
    ${clouds}
    ${centreGlow}
    ${globe}
    ${orbit}
    ${hill}
    ${ground}
    ${leaves}
  </svg>`;
}

/* ============================================================
   Section / holiday data  (offices + a shared general set)
   ============================================================ */
const FLAG_US = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#fff"/><g fill="#ef4123"><rect y="0" width="42" height="4"/><rect y="8" width="42" height="4"/><rect y="16" width="42" height="4"/><rect y="24" width="42" height="4"/></g><rect width="20" height="16" fill="#1e4164"/><g fill="#fff"><circle cx="4" cy="4" r="1"/><circle cx="10" cy="4" r="1"/><circle cx="16" cy="4" r="1"/><circle cx="7" cy="8" r="1"/><circle cx="13" cy="8" r="1"/><circle cx="4" cy="12" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="16" cy="12" r="1"/></g></svg>`;
const FLAG_BE = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="14" height="28" fill="#1a1a1a"/><rect x="14" width="14" height="28" fill="#f6c700"/><rect x="28" width="14" height="28" fill="#ef4123"/></svg>`;
const FLAG_BR = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#009C3B"/><polygon points="21,3 38,14 21,25 4,14" fill="#FFDF00"/><circle cx="21" cy="14" r="6" fill="#002776"/><path d="M15.6,15.8 Q21,11.6 26.4,13.4" stroke="#fff" stroke-width="1.5" fill="none"/></svg>`;
const FLAG_CL = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="14" fill="#fff"/><rect y="14" width="42" height="14" fill="#D52B1E"/><rect width="14" height="14" fill="#0039A6"/><polygon points="7,3 7.99,5.64 10.8,5.76 8.6,7.52 9.35,10.24 7,8.68 4.65,10.24 5.4,7.52 3.2,5.76 6.01,5.64" fill="#fff"/></svg>`;
const FLAG_CN = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#DE2910"/><polygon points="7,2.5 8.12,5.46 11.28,5.61 8.81,7.59 9.65,10.64 7,8.9 4.35,10.64 5.19,7.59 2.72,5.61 5.88,5.46" fill="#FFDE00"/><g fill="#FFDE00"><circle cx="14.5" cy="3" r="1.1"/><circle cx="16.5" cy="6" r="1.1"/><circle cx="16.5" cy="9.5" r="1.1"/><circle cx="14.5" cy="12.5" r="1.1"/></g></svg>`;
const FLAG_IN = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#FF9933"/><rect y="9.3" width="42" height="9.4" fill="#fff"/><rect y="18.7" width="42" height="9.3" fill="#138808"/><circle cx="21" cy="14" r="3.6" fill="none" stroke="#06038D" stroke-width="1.1"/><circle cx="21" cy="14" r="1" fill="#06038D"/><g stroke="#06038D" stroke-width="0.7"><line x1="21" y1="10.6" x2="21" y2="17.4"/><line x1="17.6" y1="14" x2="24.4" y2="14"/><line x1="18.6" y1="11.6" x2="23.4" y2="16.4"/><line x1="23.4" y1="11.6" x2="18.6" y2="16.4"/></g></svg>`;
const FLAG_SG = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="14" fill="#ED2939"/><rect y="14" width="42" height="14" fill="#fff"/><circle cx="11" cy="7" r="5" fill="#fff"/><circle cx="13.4" cy="7" r="4.3" fill="#ED2939"/><g fill="#fff"><polygon points="23,2 23.45,3.3 24.8,3.3 23.68,4.09 24.12,5.4 23,4.6 21.88,5.4 22.32,4.09 21.2,3.3 22.55,3.3"/><polygon points="27.76,5.45 28.21,6.75 29.56,6.75 28.44,7.54 28.88,8.85 27.76,8.05 26.64,8.85 27.08,7.54 25.96,6.75 27.31,6.75"/><polygon points="25.94,11.05 26.39,12.35 27.74,12.35 26.62,13.14 27.06,14.45 25.94,13.65 24.82,14.45 25.26,13.14 24.14,12.35 25.49,12.35"/><polygon points="20.06,11.05 20.51,12.35 21.86,12.35 20.74,13.14 21.18,14.45 20.06,13.65 18.94,14.45 19.38,13.14 18.26,12.35 19.61,12.35"/><polygon points="18.24,5.45 18.69,6.75 20.04,6.75 18.92,7.54 19.36,8.85 18.24,8.05 17.12,8.85 17.56,7.54 16.44,6.75 17.79,6.75"/></g></svg>`;
const FLAG_HU = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#fff"/><rect width="42" height="9.34" fill="#CD2A3E"/><rect y="18.66" width="42" height="9.34" fill="#43704d"/></svg>`;
const FLAG_ES = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#c60b1e"/><rect y="7" width="42" height="14" fill="#ffc400"/><g transform="translate(14,14)"><rect x="-3.4" y="-5" width="1.5" height="10" fill="#c69a1e"/><rect x="1.9" y="-5" width="1.5" height="10" fill="#c69a1e"/><path d="M-2.4,-4 H2.4 V2.6 Q0,6 -2.4,2.6 Z" fill="#f3eee0" stroke="#c69a1e" stroke-width="0.4"/><rect x="-2.4" y="-4" width="2.4" height="3.2" fill="#c60b1e"/><rect x="-2.7" y="-5.4" width="5.4" height="1.6" fill="#f4c400"/></g></svg>`;
const FLAG_AE = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="42" height="28" fill="#fff"/><rect x="10" width="32" height="9.34" fill="#00843d"/><rect x="10" y="18.66" width="32" height="9.34" fill="#1a1a1a"/><rect width="10" height="28" fill="#d21f3c"/></svg>`;
const FLAG_MX = `<svg class="flag" viewBox="0 0 42 28" aria-hidden="true"><rect width="14" height="28" fill="#006847"/><rect x="14" width="14" height="28" fill="#fff"/><rect x="28" width="14" height="28" fill="#ce1126"/><g transform="translate(21,14)"><ellipse cx="0" cy="2.4" rx="2.4" ry="1.2" fill="#3f7a4f"/><path d="M-1,-1.4 C 1.5,-1.4 2.4,0.6 1,2 C 0,2.9 -1.8,2.4 -1.9,0.8 Z" fill="#7a4a1e"/><path d="M-1.6,-1.4 L-3.4,-0.9 L-1.6,-0.2 Z" fill="#e0a83a"/><path d="M-3.4,-0.9 q-1.4,-0.8 -2.6,0.3" stroke="#2fa35a" stroke-width="0.9" fill="none" stroke-linecap="round"/></g></svg>`;
const ICON_GENERAL = `<span class="gicon"><svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><ellipse cx="12" cy="12" rx="4" ry="9"/><line x1="3" y1="12" x2="21" y2="12"/></svg></span>`;
const ICON_VALENTINE = `<span class="gicon" style="background:#e8476b"><svg viewBox="0 0 24 24" fill="#fff" aria-hidden="true"><path d="M12 20.6 C 3.6 14.4 3.6 6.9 8.1 6.9 C 10.7 6.9 11.7 9.2 12 10.5 C 12.3 9.2 13.3 6.9 15.9 6.9 C 20.4 6.9 20.4 14.4 12 20.6 Z"/></svg></span>`;


export { independenceScene,thanksgivingScene,belgianScene,christmasScene,carnivalScene,brazilScene,fiestasPatriasScene,chileChristmasScene,diwaliScene,indiaIndependenceScene,chineseNewYearScene,chinaNationalScene,singaporeScene,hungaryFoundationScene,hungaryRevolutionScene,spainNationalScene,epiphanyScene,eidAlFitrScene,eidAlAdhaScene,diaDeMuertosScene,mexIndependenceScene,iwdScene,valentineScene,earthDayScene };
